webpackJsonp([1],{

/***/ "+Try":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("yzOQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f662428_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("g6E3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f662428_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/x7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mouseover":_vm.userTypeSetup}},[_c('div',{staticClass:"title-bar detail clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("addCodeScanning"))+"\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":function($event){_vm.addCodeScanning('addCodeScanningForm')}}},[_vm._v(_vm._s(_vm.$t("save"))+"\n\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":_vm.cancelOperation}},[_vm._v(_vm._s(_vm.$t("cancel"))+"\n\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"data-list detail"},[_c('div',{staticClass:"detail-header"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("CodeScanningInformation")))]),_vm._v(" "),_c('div',{staticClass:"detail-triangle"})]),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_c('el-form',{ref:"addCodeScanningForm",staticClass:"detail-form",attrs:{"size":"small","model":_vm.CodeScanningInfo,"label-width":"120px","rules":_vm.rules,"status-icon":""}},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('ScanningTimes'),"prop":"ScanningTimes"}},[_c('el-tooltip',{attrs:{"effect":"dark","content":"0 表示未找到产品号","placement":"right"}},[_c('el-input',{model:{value:(_vm.CodeScanningInfo.ScanningTimes),callback:function ($$v) {_vm.$set(_vm.CodeScanningInfo, "ScanningTimes", $$v)},expression:"CodeScanningInfo.ScanningTimes"}})],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('ScanningMessage'),"prop":"ScanningMessage"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.CodeScanningInfo.ScanningMessage),callback:function ($$v) {_vm.$set(_vm.CodeScanningInfo, "ScanningMessage", $$v)},expression:"CodeScanningInfo.ScanningMessage"}})],1)],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "01Oi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("Kh+8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd321ba0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("PH41");
function injectStyle (ssrContext) {
  __webpack_require__("birI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd321ba0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Uae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("CodeScanningInformation"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[(_vm.canEdit)?_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":_vm.addEAN}},[_vm._v(_vm._s(_vm.$t("add"))+"\n        "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n        "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":function($event){_vm.searchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("search"))+"\n        "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.CodeScanningData,"size":"mini"}},[(_vm.canEdit)?_c('el-table-column',{attrs:{"label":"操作","align":"center","width":"180","resizable":true},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.handleEdit(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$t("edit")))]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.handleDelete(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$t("delete")))])]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ScanningTimes","label":this.$t('ScanningTimes'),"header-align":"center","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.friendlyScanTimes(scope.row.ScanningTimes))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ScanningMessage","label":this.$t('ScanningMessage'),"header-align":"center","align":"center"}})],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"10px"}},[_c('el-pagination',{staticStyle:{"float":"right"},attrs:{"current-page":_vm.pageIndex,"page-sizes":[15,30,50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('search'),"visible":_vm.searchDialogVisible,"width":"45%"},on:{"update:visible":function($event){_vm.searchDialogVisible=$event}}},[_c('el-form',{staticClass:"search-form",attrs:{"model":_vm.filter,"inline":true,"size":"small"}},[_c('el-form-item',{attrs:{"label":this.$t('ScanningTimes'),"size":"small","label-width":_vm.searchDialogLabelWidth}},[_c('div',{on:{"keyup":function($event){_vm.handlekeyup($event)}}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.filter.ScanningTimes),callback:function ($$v) {_vm.$set(_vm.filter, "ScanningTimes", $$v)},expression:"filter.ScanningTimes"}})],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('ScanningMessage'),"size":"small","label-width":_vm.searchDialogLabelWidth}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.filter.ScanningMessage),callback:function ($$v) {_vm.$set(_vm.filter, "ScanningMessage", $$v)},expression:"filter.ScanningMessage"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",staticStyle:{"text-align":"center"},attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(_vm.$t('reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":_vm.search}},[_vm._v(_vm._s(this.$t('confirm')))])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2PZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_roleTypes__ = __webpack_require__("B0E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__ = __webpack_require__("jb9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ProductReturn",
  data: function data() {
    return {
      searchDialogVisible: false,
      returnRecords: [],
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
      loading: false,
      exporting: false,
      filter: {},
      filterOptions: [],
      detailTableCols: [{
        prop: "QRCode1",
        label: "productReturn.qrcode1",
        width: 200,
        formatter: null
      }, {
        prop: "IwacInfo.CustomerNumber",
        label: "productReturn.customerNumber",
        width: 100,
        formatter: null
      }, {
        prop: "IwacInfo.CustomerName",
        label: "productReturn.customerName",
        width: 200,
        formatter: null
      }, {
        prop: "IwacInfo.OrderNumber",
        label: "productReturn.orderNumber",
        width: 100,
        formatter: null
      }, {
        prop: "IwacInfo.BoxNumber",
        label: "productReturn.boxNumber",
        width: 200,
        formatter: null
      }, {
        prop: "EanInfo.EANcode",
        label: "productReturn.eancode",
        formatter: null
      }, {
        prop: "EanInfo.ProductLongCode",
        label: "productReturn.longcode",
        formatter: null
      }, {
        prop: "IwacInfo.DeliveryTime",
        label: "productReturn.deliveryTime",
        formatter: this.timeFormatter
      }]
    };
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getReturnRecords();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.getReturnRecords();
    },
    getReturnRecords: function getReturnRecords() {
      var _this = this;

      this.loading = true;
      var params = {
        filter: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios.get("api/product/return", { params: params }).then(function (res) {
        _this.totalCount = res.data.TotalCount;
        _this.returnRecords = res.data.Data;
        _this.loading = false;
      }).catch(function (e) {
        _this.loading = false;
      });
    },
    search: function search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].setHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].PRODUCTRETURN_HISTORY, this.filterOptions);
      this.getReturnRecords();
    },
    resetFilter: function resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].removeHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].PRODUCTRETURN_HISTORY);
    },
    setFilterOptions: function setFilterOptions() {
      var _this2 = this;

      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
        var val = _this2.filter[k];
        if (typeof val === "number" || val) {
          _this2.filterOptions.push({ name: k, value: val });
        }
      });
    },
    refresh: function refresh() {
      this.resetFilter();
      this.getReturnRecords();
    },
    initializeFilter: function initializeFilter() {
      var _this3 = this;

      var his = __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].getHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].PRODUCTRETURN_HISTORY);
      if (his) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter);
        his.forEach(function (h) {
          if (keys.includes(h.name)) {
            _this3.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    beginScan: function beginScan() {
      this.$router.push({ name: "ReturnScan" });
    },
    exportExcel: function exportExcel() {
      var _this4 = this;

      this.exporting = true;
      var params = {
        filter: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.filterOptions)
      };
      this.$axios.get("api/product/return/export", { params: params }).then(function (resp) {
        var fileName = decodeURIComponent(resp.headers["file-name"] || "退货记录.csv");
        var BOM = "\uFEFF";
        var blob = new Blob([BOM + resp.data]);
        __WEBPACK_IMPORTED_MODULE_6_file_saver___default.a.saveAs(blob, fileName);
        _this4.exporting = false;
      }).catch(function (e) {
        _this4.exporting = false;
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(["roles", "permissions"]), {
    canExport: function canExport() {
      return this.roles.includes(__WEBPACK_IMPORTED_MODULE_3__models_roleTypes__["a" /* default */].Administrator) || this.permissions.find(function (p) {
        return p.toLowerCase() === "productreturn.export";
      });
    },
    canScan: function canScan() {
      return this.roles.includes(__WEBPACK_IMPORTED_MODULE_3__models_roleTypes__["a" /* default */].Administrator) || this.permissions.find(function (p) {
        return p.toLowerCase() === "productreturn.insert";
      });
    }
  }),
  created: function created() {
    this.initializeFilter();
    this.getReturnRecords();
  }
});

/***/ }),

/***/ "31Q/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4D5u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "553w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_OperationHeader__ = __webpack_require__("Es0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_roleTypes__ = __webpack_require__("B0E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_searchHistoryService__ = __webpack_require__("jb9L");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CodeScanningInformation",
  components: { OperationHeader: __WEBPACK_IMPORTED_MODULE_3__components_shared_OperationHeader__["a" /* default */] },
  data: function data() {
    return {
      loading: true,
      filter: {
        ScanningTimes: "",
        ScanningMessage: ""
      },
      filterOptions: [],
      userTypeList: [],
      QRCTypeList: [],
      searchDialogLabelWidth: "120px",
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      searchDialogVisible: false,
      CodeScanningData: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(["roles", "permissions"]), {
    canEdit: function canEdit() {
      return this.roles.includes(__WEBPACK_IMPORTED_MODULE_6__models_roleTypes__["a" /* default */].Administrator) || this.permissions.find(function (p) {
        return p.toLowerCase() === "CodeScanningInformation.edit" || p.toLowerCase() === "CodeScanningInformation.insert";
      });
    }
  }),
  created: function created() {
    this.initializeFilter();
    this.obtainTableDataAccordingToConditions();
  },

  methods: {
    resetFilter: function resetFilter() {
      this.filter = {
        CodeType: "",
        UserType: [],
        ScanningTimes: "",
        ScanningMessage: ""
      };
      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_8__services_searchHistoryService__["a" /* default */].removeHistory(__WEBPACK_IMPORTED_MODULE_7__models_searchTypes__["a" /* default */].CODESCANNING_HISTORY);
    },
    addEAN: function addEAN() {
      this.$router.push("addCodeScanningInformation");
    },
    handleEdit: function handleEdit(index, row) {
      this.$router.push({
        name: "EditCodeScanningInformation",
        params: { Id: row.Id }
      });
    },
    userTypeSetup: function userTypeSetup() {
      if (this.userTypeList == "") {
        for (var i = 2; i <= 4; i++) {
          this.userTypeList.push(i);
        }
        this.userTypeList.push(8);
      }
      if (this.QRCTypeList == "") {
        this.QRCTypeList.push(1);
        this.QRCTypeList.push(2);
      }
    },
    handleDelete: function handleDelete(index, row) {
      var _this = this;

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this.deleteData(row.Id);
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.obtainTableDataAccordingToConditions();
      } else {
        this.pageIndex = 1;
      }
    },
    handlekeyup: function handlekeyup(event) {
      var father = event.currentTarget;
      var input = father.getElementsByTagName("input")[0];
      input.value = input.value.replace(/[^0-9]/g, "");
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.obtainTableDataAccordingToConditions();
    },
    obtainTableDataAccordingToConditions: function obtainTableDataAccordingToConditions() {
      var _this2 = this;

      this.loading = true;
      this.$axios.get("api/codescanning/getall", {
        params: {
          filter: this.filtergenerator(),
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
      }).then(function (response) {
        _this2.translateData(response.data.Data);
        _this2.loading = false;
        _this2.totalCount = response.data.TotalCount;
      });
    },
    deleteData: function deleteData(rowId) {
      var _this3 = this;

      this.$axios.get("api/codescanning/delete", {
        params: {
          Id: rowId
        }
      }).then(function (response) {
        _this3.$message({
          type: "success",
          message: "删除成功"
        });
        _this3.obtainTableDataAccordingToConditions();
      });
    },
    refresh: function refresh() {
      this.pageIndex = 1;
      this.resetFilter();
      this.obtainTableDataAccordingToConditions();
    },
    initializeFilter: function initializeFilter() {
      var _this4 = this;

      var his = __WEBPACK_IMPORTED_MODULE_8__services_searchHistoryService__["a" /* default */].getHistory(__WEBPACK_IMPORTED_MODULE_7__models_searchTypes__["a" /* default */].CODESCANNING_HISTORY);
      if (his) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter);
        his.forEach(function (h) {
          if (keys.includes(h.name)) {
            _this4.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    setFilterOptions: function setFilterOptions() {
      var _this5 = this;

      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
        var val = _this5.filter[k];
        if (typeof val === "number" || val) {
          _this5.filterOptions.push({ name: k, value: val });
        }
      });
    },
    search: function search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      __WEBPACK_IMPORTED_MODULE_8__services_searchHistoryService__["a" /* default */].setHistory(__WEBPACK_IMPORTED_MODULE_7__models_searchTypes__["a" /* default */].CODESCANNING_HISTORY, this.filterOptions);
      this.obtainTableDataAccordingToConditions();
    },
    translateData: function translateData(data) {
      for (var i = 0; i < data.length; i++) {
        var utype = "UserType" + data[i].UserType;
        var codetype = "QRC" + data[i].CodeType;
      }
      this.CodeScanningData = data;
    },
    filtergenerator: function filtergenerator() {
      var filterOptions = [];

      if (this.filter.ScanningMessage !== null && this.filter.ScanningMessage.trim() !== "") {
        var filterOption = {
          name: "ScanningMessage",
          value: this.filter.ScanningMessage
        };

        filterOptions.push(filterOption);
      }
      if (this.filter.ScanningTimes !== null && this.filter.ScanningTimes.trim() !== "") {
        var filterOption = {
          name: "ScanningTimes",
          value: this.filter.ScanningTimes
        };

        filterOptions.push(filterOption);
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filterOptions);
    },
    friendlyScanTimes: function friendlyScanTimes(times) {
      if (!times) {
        return times + " (\u672A\u627E\u5230\u4EA7\u54C1\u53F7)";
      }
      return times;
    }
  }
});

/***/ }),

/***/ "5Exv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Oc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("CashbackManagement"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[(_vm.canEdit)?_c('el-tooltip',{attrs:{"content":"所有搜索结果禁用红包领取","placement":"top"}},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.inavtivationAll}},[_vm._v("禁用红包\n          "),_c('i',{staticClass:"fa fa-lock"})])],1):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('el-tooltip',{attrs:{"content":"所有搜索结果启用红包领取","placement":"top"}},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.avtivationAll}},[_vm._v("启用红包\n          "),_c('i',{staticClass:"fa fa-unlock"})])],1):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n        "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.userTypeSetup}},[_vm._v(_vm._s(_vm.$t("search"))+"\n        "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.CashbackData,"size":"mini"},on:{"cell-dblclick":_vm.openCell}},[(_vm.canEdit)?_c('el-table-column',{attrs:{"label":"操作","align":"center","width":"180","resizable":true},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.handleEdit(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$t("edit")))]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.handleActivation(scope.$index, scope.row)}}},[_vm._v(_vm._s(scope.row.IsActive ? _vm.$t("inActivation") : _vm.$t("activation")))]),_vm._v(" "),(false)?_c('el-button',{attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.handleDelete(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$t("delete")))]):_vm._e()]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":"红包领取","align":"center","width":"100","resizable":true},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.IsActive)?_c('i',{staticClass:"el-icon-success"}):_c('i',{staticClass:"el-icon-error"})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"EANCode","header-align":"center","label":this.$t('EANCode'),"align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ProductLongCode","label":this.$t('ProductLongCode'),"header-align":"center","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userType","label":this.$t('UserType'),"formatter":_vm.UserTypeFormatter,"header-align":"center","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"CashbackAmount","label":this.$t('CashbackAmount'),"header-align":"center","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.canEdit)?_c('span',[_vm._v(_vm._s(scope.row.CashbackAmount))]):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('div',[(!scope.row.editFlag&&_vm.canEdit)?_c('span',[_vm._v(_vm._s(scope.row.CashbackAmount))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"90%","float":"left"}},[(scope.row.editFlag)?_c('span',[_c('div',{on:{"keyup":function($event){_vm.handlekeyup($event)}}},[_c('el-input',{attrs:{"id":"editinput","placeholder":"请输入返现金额"},nativeOn:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; } _vm.handlecancel(scope.row)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.handleSave(scope.row)}]},model:{value:(_vm.inputColumn1),callback:function ($$v) {_vm.inputColumn1=$$v},expression:"inputColumn1"}})],1)]):_vm._e()]),_vm._v(" "),(!scope.row.editFlag)?_c('span',{staticClass:"cell-icon",staticStyle:{"margin-left":"5px"},on:{"click":function($event){_vm.handlePageEdit(scope.row)}}},[_c('a',{attrs:{"title":"编辑"}},[_c('i',{staticClass:"el-icon-edit"})])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"float":"left","margin-left":"2px"}},[(scope.row.editFlag)?_c('span',{staticClass:"cell-icon",on:{"click":function($event){_vm.handleSave(scope.row)}}},[_c('a',{attrs:{"title":"保存"}},[_c('i',{staticClass:"fa fa-file",attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),(scope.row.editFlag)?_c('span',{staticClass:"cell-icon",on:{"click":function($event){_vm.handlecancel(scope.row)}}},[_c('a',{attrs:{"title":"取消"}},[_c('i',{staticClass:"el-icon-document"})])]):_vm._e()])]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"10px"}},[_c('el-pagination',{staticStyle:{"float":"right"},attrs:{"current-page":_vm.pageIndex,"page-sizes":[15,30,50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('search'),"visible":_vm.searchDialogVisible,"width":"45%"},on:{"update:visible":function($event){_vm.searchDialogVisible=$event}}},[_c('el-form',{staticClass:"search-form",attrs:{"model":_vm.filter,"inline":true,"size":"small","label-width":"100px"}},[_c('el-form-item',{attrs:{"label":this.$t('EANCode'),"size":"small"}},[_c('el-input',{staticClass:"localinputwidth",attrs:{"auto-complete":"off"},model:{value:(_vm.filter.EANCode),callback:function ($$v) {_vm.$set(_vm.filter, "EANCode", $$v)},expression:"filter.EANCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('ProductLongCode'),"size":"small"}},[_c('el-input',{staticClass:"localinputwidth",attrs:{"auto-complete":"off"},model:{value:(_vm.filter.ProductLongCode),callback:function ($$v) {_vm.$set(_vm.filter, "ProductLongCode", $$v)},expression:"filter.ProductLongCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('CashbackAmount'),"size":"small"}},[_c('div',{on:{"keyup":function($event){_vm.handlekeyup($event)}}},[_c('el-input',{staticClass:"localinputwidth",attrs:{"auto-complete":"off"},model:{value:(_vm.filter.CashbackAmount),callback:function ($$v) {_vm.$set(_vm.filter, "CashbackAmount", $$v)},expression:"filter.CashbackAmount"}})],1)]),_vm._v(" "),_c('el-form-item',{staticClass:"usertype-selector",attrs:{"label":this.$t('UserType'),"size":"small"}},[_c('el-select',{attrs:{"multiple":"","size":"small"},model:{value:(_vm.filter.userType),callback:function ($$v) {_vm.$set(_vm.filter, "userType", $$v)},expression:"filter.userType"}},_vm._l((_vm.userTypeList),function(t){return _c('el-option',{key:t,attrs:{"label":_vm.$t('UserType'+t),"value":t}})}))],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",staticStyle:{"text-align":"center"},attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(_vm.$t('reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":_vm.search}},[_vm._v(_vm._s(this.$t('confirm')))])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5jHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__ = __webpack_require__("L14P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb6f967_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_vue__ = __webpack_require__("PqgG");
function injectStyle (ssrContext) {
  __webpack_require__("Oxk1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fb6f967"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb6f967_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5reh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT; });
/* unused harmony export AUTHORIZATIONHEADER */
/* unused harmony export MENU */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MENUINDEX; });
var LOGIN = 'login';

var LOGOUT = 'logout';

var AUTHORIZATIONHEADER = 'authorization';

var MENU = 'menu';

var MENUINDEX = 'menuIndex';

/***/ }),

/***/ "6/7Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__("5jHf");
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "not-auth",
  components: { error: __WEBPACK_IMPORTED_MODULE_0__error__["a" /* default */] }
});

/***/ }),

/***/ "69sp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6bja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_roleTypes__ = __webpack_require__("B0E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__ = __webpack_require__("jb9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "QRCCode",
  data: function data() {
    var _this = this;

    var checkBatchNumber = function checkBatchNumber(r, v, callback) {
      if (v) {
        _this.$axios.get("api/qrc/existBatchNumber/" + v).then(function (resp) {
          if (resp.data) {
            callback();
          } else {
            callback(new Error(_this.$t("qrc.batchNumberNotExist")));
          }
        });
      }
    };

    return {
      searchDialogVisible: false,
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      historyRecords: [],
      filter: {
        BatchNumber: "",
        UserName: "",
        StartGenTime: "",
        EndGenTime: ""
      },
      filterOptions: []
    };
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getHistory();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.getHistory();
    },
    getHistory: function getHistory() {
      var _this2 = this;

      this.loading = true;
      var params = {
        filter: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios.get("api/qrc/history", { params: params }).then(function (res) {
        _this2.totalCount = res.data.TotalCount;
        _this2.historyRecords = res.data.Data;
        _this2.loading = false;
      }).catch(function (e) {
        _this2.loading = false;
      });
    },
    search: function search() {
      var _this3 = this;

      this.searchDialogVisible = false;
      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
        var val = _this3.filter[k];
        if (val) {
          _this3.filterOptions.push({ name: k, value: val });
        }
      });
      __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].setHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].QRCHISTORY_HISTORY, this.filterOptions);
      this.getHistory();
    },
    resetFilter: function resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].removeHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].QRCHISTORY_HISTORY);
    },
    refresh: function refresh() {
      this.resetFilter();
      this.getHistory();
    },
    initializeFilter: function initializeFilter() {
      var _this4 = this;

      var his = __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].getHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].QRCHISTORY_HISTORY);
      if (his) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter);
        his.forEach(function (h) {
          if (keys.includes(h.name)) {
            _this4.filter[h.name] = h.value;
          }
        });
      }
    },
    exportCodes: function exportCodes(batchNumber) {
      this.$axios.get("api/qrc/export/" + batchNumber).then(function (resp) {
        var fileName = decodeURIComponent(resp.headers["file-name"] || "二维码.csv");
        var BOM = "\uFEFF";
        var blob = new Blob([BOM + resp.data]);
        __WEBPACK_IMPORTED_MODULE_6_file_saver___default.a.saveAs(blob, fileName);
      });
    },
    goBack: function goBack() {
      this.$router.push({ name: "QRCCode" });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(["roles", "permissions"]), {
    canExport: function canExport() {
      return this.roles.includes(__WEBPACK_IMPORTED_MODULE_3__models_roleTypes__["a" /* default */].Administrator) || this.permissions.find(function (p) {
        return p.toLowerCase() === "qrc.export";
      });
    }
  }),
  created: function created() {
    this.initializeFilter();
    __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].removeBesides(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].QRCHISTORY_HISTORY);
    this.getHistory();
  }
});

/***/ }),

/***/ "70sN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("qrc.historyTitle"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.$t("back"))+"\n        "),_c('i',{staticClass:"fa el-icon-back"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n        "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("search"))+"\n        "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.historyRecords,"size":"mini"}},[(_vm.canExport)?_c('el-table-column',{attrs:{"label":"操作","align":"center","resizable":true},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.exportCodes(scope.row.BatchNumber)}}},[_vm._v(_vm._s(_vm.$t("qrc.exportCodes")))])]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"BatchNumber","align":"center","resizable":true,"label":this.$t('qrc.batchNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"GenerateCount","align":"center","resizable":true,"label":this.$t('qrc.count')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"GenerateTime","align":"center","resizable":true,"label":this.$t('qrc.generateTime'),"formatter":_vm.timeFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"UserName","align":"center","resizable":true,"label":this.$t('qrc.generatePerson')}})],1),_vm._v(" "),_c('el-row',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pageIndex,"page-sizes":[15, 30, 50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('search'),"visible":_vm.searchDialogVisible,"width":"40%"},on:{"update:visible":function($event){_vm.searchDialogVisible=$event}}},[_c('el-form',{staticClass:"search-form",attrs:{"model":_vm.filter,"inline":true,"size":"small","label-width":"70px"}},[_c('el-form-item',{attrs:{"label":this.$t('qrc.batchNumber'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.BatchNumber),callback:function ($$v) {_vm.$set(_vm.filter, "BatchNumber", $$v)},expression:"filter.BatchNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('qrc.generatePerson'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.UserName),callback:function ($$v) {_vm.$set(_vm.filter, "UserName", $$v)},expression:"filter.UserName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('qrc.generateTime'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.StartGenTime),callback:function ($$v) {_vm.$set(_vm.filter, "StartGenTime", $$v)},expression:"filter.StartGenTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('to'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.EndGenTime),callback:function ($$v) {_vm.$set(_vm.filter, "EndGenTime", $$v)},expression:"filter.EndGenTime"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(this.$t('reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":_vm.search}},[_vm._v(_vm._s(this.$t('confirm')))])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7mqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EditEAN",
  filters: {
    rounding: function rounding(value) {
      return value.toFixed(2);
    }
  },
  data: function data() {
    return {
      EANCodeInfo: {
        EANCode: "",
        AmountPerPackage: "",
        ProductLongCode: "",
        ProductShortCode: "",
        ProductSerials: "",
        SuggestedRetailPrice: ""
      },

      rules: {
        EANCode: [{ required: true, message: this.$t("EANCodeValidation") }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > format.length) {
              callback(new Error("EAN码只能为阿拉伯数字"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        ProductLongCode: [{
          required: true,
          message: this.$t("ProductLongCodeValidation")
        }, {
          pattern: new RegExp(/[-]/),
          message: this.$t("必须包含数字与‘-’"),
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9-]/g, "");
            if (raw.length > format.length) {
              callback(new Error("必须包含数字与‘-’"));
            } else {
              if (raw.charAt(raw.length - 1) === "-" || raw.charAt(0) === "-") {
                callback(new Error("格式不正确"));
              }
              callback();
            }
          },
          trigger: "blur"
        }],
        ProductShortCode: [{
          required: true,
          message: this.$t("ProductShortCodeValidation")
        }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > format.length) {
              callback(new Error("短号只能为阿拉伯数字"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        ProductSerials: [{ required: true, message: this.$t("ProductSerialsCodeValidation") }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > format.length) {
              callback(new Error("系列号只能为阿拉伯数字"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        AmountPerPackage: [{
          required: true,
          message: this.$t("AmountPerPackageValidation")
        }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > 9) {
              callback(new Error("每盒产品数量过大"));
            }
            if (raw.length > format.length) {
              callback(new Error("请输入一个整数"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        SuggestedRetailPrice: [{
          required: true,
          message: this.$t("SuggestedRetailPriceValidation")
        }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^\d+(\.\d+)?$]/g, "");

            if (raw.length > format.length) {
              callback(new Error("请输入一个浮点数"));
            }

            var index = raw.indexOf(".");
            if (index != -1) {
              var arrStr = [];
              arrStr = raw.split(".");
              if (arrStr[1] && arrStr[1].length > 2) {
                callback(new Error("请输入一个2位小数"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$axios.get("api/eancodes/" + this.$route.params.EANId).then(function (response) {
      _this.EANCodeInfo.Id = response.data.Id;
      _this.EANCodeInfo.EANCode = response.data.EANCode;
      _this.EANCodeInfo.ProductLongCode = response.data.ProductLongCode;
      _this.EANCodeInfo.ProductShortCode = response.data.ProductShortCode;
      _this.EANCodeInfo.AmountPerPackage = response.data.AmountPerPackage;
      _this.EANCodeInfo.CashbackInformation = response.data.CashbackInformation;
      _this.EANCodeInfo.ProductSerials = response.data.ProductSerials;
      _this.EANCodeInfo.SuggestedRetailPrice = response.data.SuggestedRetailPrice;
    });
  },

  methods: {
    addEAN: function addEAN(addEANCodeForm) {
      var _this2 = this;

      this.$refs[addEANCodeForm].validate(function (valid) {
        if (valid) {
          _this2.$axios.post("api/eancodes/addoredit", _this2.EANCodeInfo).then(function (response) {
            _this2.$message({
              message: _this2.$t("EANAEditSuccessfully"),

              type: "success",
              showClose: true,
              duration: 2000
            });
            _this2.$router.push({ name: "EANCode" });
          }).catch(function (err) {
            _this2.$message({
              message: _this2.$t(err.response.statusText),
              type: "error",
              showClose: true,
              duration: 2000
            });
          });
        } else {
          _this2.$message({
            message: _this2.$t("operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },
    handlefocus: function handlefocus(ev) {
      this.EANCodeInfo.AmountPerPackage = parseInt(this.EANCodeInfo.AmountPerPackage);
    },
    cancelOperation: function cancelOperation() {
      this.$router.push({ name: "EANCode" });
    }
  }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "8+7V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar detail clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n        "+_vm._s(_vm.$t("editCashback"))+"\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":function($event){_vm.addEAN('addCashbackForm')}}},[_vm._v(_vm._s(_vm.$t("save"))+"         \n        ")]),_vm._v(" "),_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":_vm.cancelOperation}},[_vm._v(_vm._s(_vm.$t("cancel"))+"       \n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"data-list detail"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_c('el-form',{ref:"addCashbackForm",staticClass:"detail-form",attrs:{"size":"small","model":_vm.CashbackInfo,"label-width":"120px","rules":_vm.rules,"status-icon":""}},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('EANCode'),"prop":"EANCode"}},[_c('el-input',{attrs:{"disabled":"disabled"},model:{value:(_vm.CashbackInfo.EANCode),callback:function ($$v) {_vm.$set(_vm.CashbackInfo, "EANCode", $$v)},expression:"CashbackInfo.EANCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('CashbackAmount'),"prop":"CashbackAmount"}},[_c('div',{on:{"keyup":function($event){_vm.handlekeyup($event)}}},[_c('el-input',{attrs:{"autofocus":true},on:{"focus":_vm.handlefocus},model:{value:(_vm.CashbackInfo.CashbackAmount),callback:function ($$v) {_vm.$set(_vm.CashbackInfo, "CashbackAmount", _vm._n($$v))},expression:"CashbackInfo.CashbackAmount"}})],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('ProductLongCode'),"prop":"ProductLongCode"}},[_c('el-input',{attrs:{"disabled":"disabled"},model:{value:(_vm.CashbackInfo.ProductLongCode),callback:function ($$v) {_vm.$set(_vm.CashbackInfo, "ProductLongCode", $$v)},expression:"CashbackInfo.ProductLongCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('UserType'),"size":"small"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"size":"small","disabled":"disabled"},model:{value:(_vm.CashbackInfo.UserType),callback:function ($$v) {_vm.$set(_vm.CashbackInfo, "UserType", $$v)},expression:"CashbackInfo.UserType"}},[_c('el-option',{key:_vm.CashbackInfo.UserType,attrs:{"label":_vm.$t('UserType'+_vm.CashbackInfo.UserType),"value":_vm.CashbackInfo.UserType}})],1)],1)],1)],1)],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-header"},[_c('span',[_vm._v("返现信息")]),_vm._v(" "),_c('div',{staticClass:"detail-triangle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8ZTO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    Generated: 0,
    Manufactured: 1
});

/***/ }),

/***/ "8qvv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "91so":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navbar_Navbar__ = __webpack_require__("TdT6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sidebar_Sidebar__ = __webpack_require__("01Oi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App",
  components: { Navbar: __WEBPACK_IMPORTED_MODULE_1__components_navbar_Navbar__["a" /* default */], Sidebar: __WEBPACK_IMPORTED_MODULE_2__components_sidebar_Sidebar__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["menus"])),
  created: function created() {
    console.log("application");
  }
});

/***/ }),

/***/ "9Gp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_OperationHeader__ = __webpack_require__("Es0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_ATips__ = __webpack_require__("lX8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_searchHistoryService__ = __webpack_require__("jb9L");




var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CMUser",
  components: { OperationHeader: __WEBPACK_IMPORTED_MODULE_3__components_shared_OperationHeader__["a" /* default */], ATips: __WEBPACK_IMPORTED_MODULE_5__components_shared_ATips__["a" /* default */] },
  data: function data() {
    return {
      loading: true,
      filter: {
        ChannelAccount: "",
        ChannelName: "",
        ChannelType: [],
        SalesAreas: [],
        Office: ""
      },
      salesAreasList: [],
      userTypeList: [],
      searchDialogLabelWidth: "120px",
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      searchDialogVisible: false,
      CMUserData: [],
      filterOptions: []
    };
  },
  created: function created() {
    this.initializeFilter();
    this.obtainTableDataAccordingToConditions();
    this.setup();
  },

  methods: (_methods = {
    setup: function setup() {
      this.userTypeSetup();
      this.salesAreaSetUp();
    },
    resetFilter: function resetFilter() {
      this.filter = {
        ChannelAccount: "",
        ChannelName: "",
        ChannelType: [],
        SalesAreas: [],
        Email: "",
        Name: "",
        Bu: "",
        Office: ""
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.obtainTableDataAccordingToConditions();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.obtainTableDataAccordingToConditions();
    },
    obtainTableDataAccordingToConditions: function obtainTableDataAccordingToConditions() {
      var _this = this;

      this.loading = true;
      this.$axios.get("api/cmuser/getuser", {
        params: {
          filter: this.filtergenerator(),

          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
      }).then(function (response) {
        _this.translateData(response.data.Data);
        _this.totalCount = response.data.TotalCount;
        _this.loading = false;
      });
    },
    refresh: function refresh() {
      this.pageIndex = 1;
      this.clearFilter();
      this.obtainTableDataAccordingToConditions();
    },
    userTypeSetup: function userTypeSetup() {
      if (this.userTypeList == "") {
        for (var i = 2; i <= 4; i++) {
          this.userTypeList.push(i);
        }
        this.userTypeList.push(8);
        this.userTypeList.push(9);
      }
    },
    salesAreaSetUp: function salesAreaSetUp() {
      var _this2 = this;

      this.$axios.get("api/cmuser/cmsalesarea").then(function (response) {
        _this2.salesAreasList = response.data;
      });
    },
    clearFilter: function clearFilter() {
      this.filter.ChannelName = "";
      this.filter.SalesAreas = [];
      this.filter.Office = "";
      this.filter.ChannelType = [];
      this.filter.ChannelAccount = "";
      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_7__services_searchHistoryService__["a" /* default */].removeHistory(__WEBPACK_IMPORTED_MODULE_6__models_searchTypes__["a" /* default */].CUSTOERMER_HISTORY);
    },
    translateData: function translateData(data) {
      for (var i = 0; i < data.length; i++) {
        var utype = "UserType" + data[i].UserType;
        data[i].UserType = this.$t(utype);
      }
      this.CMUserData = data;
      this.loading = false;
    },
    search: function search() {
      this.pageIndex = 1;
      this.searchDialogVisible = false;
      this.obtainTableDataAccordingToConditions();
    },
    initializeFilter: function initializeFilter() {
      var _this3 = this;

      var his = __WEBPACK_IMPORTED_MODULE_7__services_searchHistoryService__["a" /* default */].getHistory(__WEBPACK_IMPORTED_MODULE_6__models_searchTypes__["a" /* default */].CUSTOERMER_HISTORY);
      if (his) {
        var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.filter);
        his.forEach(function (h) {
          if (keys.includes(h.name)) {
            _this3.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    setFilterOptions: function setFilterOptions() {
      var _this4 = this;

      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
        var val = _this4.filter[k];
        if (typeof val === "number" || val) {
          _this4.filterOptions.push({ name: k, value: val });
        }
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "search", function search() {
    this.searchDialogVisible = false;
    this.pageIndex = 1;
    this.setFilterOptions();
    __WEBPACK_IMPORTED_MODULE_7__services_searchHistoryService__["a" /* default */].setHistory(__WEBPACK_IMPORTED_MODULE_6__models_searchTypes__["a" /* default */].CUSTOERMER_HISTORY, this.filterOptions);
    this.obtainTableDataAccordingToConditions();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "filtergenerator", function filtergenerator() {
    var filterOptions = [];

    if (this.filter.ChannelName !== null && this.filter.ChannelName.trim() !== "") {
      var filterOption = {
        name: "ChannelName",
        value: this.filter.ChannelName
      };

      filterOptions.push(filterOption);
    }

    if (this.filter.ChannelAccount !== null && this.filter.ChannelAccount.trim() !== "") {
      var filterOption = {
        name: "ChannelAccount",
        value: this.filter.ChannelAccount
      };

      filterOptions.push(filterOption);
    }

    if (this.filter.Office !== null && this.filter.Office.trim() !== "") {
      var filterOption = {
        name: "Office",
        value: this.filter.Office
      };

      filterOptions.push(filterOption);
    }

    if (this.filter.SalesAreas.length > 0) {
      var selectedSalesArea = "";
      var count = 0;

      for (var i = 0; i < this.filter.SalesAreas.length; i++) {
        selectedSalesArea += this.filter.SalesAreas[i];
        if (count !== this.filter.SalesAreas.length - 1) {
          selectedSalesArea += "%";
        }
        count++;
      }

      var filterOption = {
        name: "SalesAreas",
        value: selectedSalesArea
      };
      filterOptions.push(filterOption);
    }

    if (this.filter.ChannelType.length > 0) {
      var selectedTypes = "";
      var count = 0;

      for (var i = 0; i < this.filter.ChannelType.length; i++) {
        selectedTypes += "Type" + this.filter.ChannelType[i];
        if (count !== this.filter.ChannelType.length - 1) {
          selectedTypes += "%";
        }
        count++;
      }

      var filterOption = {
        name: "UserTypes",
        value: selectedTypes
      };

      filterOptions.push(filterOption);
    }

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filterOptions);
  }), _methods)
});

/***/ }),

/***/ "9H58":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wagoPic.8364b30.jpg";

/***/ }),

/***/ "ARzl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnScan_vue__ = __webpack_require__("bKlf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4433b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnScan_vue__ = __webpack_require__("as2O");
function injectStyle (ssrContext) {
  __webpack_require__("ucJP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnScan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4433b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnScan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Acar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cashback_vue__ = __webpack_require__("peMH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de2f7b48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cashback_vue__ = __webpack_require__("5Oc5");
function injectStyle (ssrContext) {
  __webpack_require__("V9tU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cashback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de2f7b48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cashback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B0E2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
    Administrator: "Administrator",
    StockAdministrator: "StockAdministrator",
    MarketAdministrator: "MarketAdministrator",
    Manager: "Manager",
    Scanner: "Scanner",
    ReturnAdministrator: "ReturnAdministrator"
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),

/***/ "B7TC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var service = {
    getQRCode: function getQRCode(url) {
        if (url.includes('?')) {
            var query = url.split('?')[1];
            return query.split('=')[1];
        } else {
            return url;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "BVFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("CMUserView"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n        "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":function($event){_vm.searchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("search"))+"\n        "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.CMUserData,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"ChannelAccount","label":this.$t('ChannelAccount'),"header-align":"center","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ChannelName","label":this.$t('BICustomName'),"header-align":"center","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"UserType","label":this.$t('ChannelType'),"header-align":"center","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Office","label":this.$t('Office'),"header-align":"center","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"SaleAreas","label":this.$t('ReceivedSalsArea'),"header-align":"center","align":"center"}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"10px"}},[_c('el-pagination',{staticStyle:{"float":"right"},attrs:{"current-page":_vm.pageIndex,"page-sizes":[15,30,50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('search'),"visible":_vm.searchDialogVisible,"width":"45%"},on:{"update:visible":function($event){_vm.searchDialogVisible=$event}}},[_c('el-form',{staticClass:"search-form",attrs:{"model":_vm.filter,"inline":true,"size":"small","label-width":"100px"}},[_c('el-form-item',{attrs:{"label":this.$t('BICustomName'),"size":"small"}},[_c('el-input',{staticClass:"localinputwidth",attrs:{"auto-complete":"off"},model:{value:(_vm.filter.ChannelName),callback:function ($$v) {_vm.$set(_vm.filter, "ChannelName", $$v)},expression:"filter.ChannelName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('ChannelAccount'),"size":"small"}},[_c('el-input',{staticClass:"localinputwidth",attrs:{"auto-complete":"off"},model:{value:(_vm.filter.ChannelAccount),callback:function ($$v) {_vm.$set(_vm.filter, "ChannelAccount", $$v)},expression:"filter.ChannelAccount"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('Office'),"size":"small"}},[_c('el-input',{staticClass:"localinputwidth",attrs:{"auto-complete":"off"},model:{value:(_vm.filter.Office),callback:function ($$v) {_vm.$set(_vm.filter, "Office", $$v)},expression:"filter.Office"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('SalesArea'),"size":"small"}},[_c('el-select',{staticClass:"localinputwidth",attrs:{"multiple":"","size":"small"},model:{value:(_vm.filter.SalesAreas),callback:function ($$v) {_vm.$set(_vm.filter, "SalesAreas", $$v)},expression:"filter.SalesAreas"}},_vm._l((_vm.salesAreasList),function(t){return _c('el-option',{key:t.Code,attrs:{"label":t.Code,"value":t.Code}})}))],1),_vm._v(" "),_c('el-form-item',{staticClass:"usertype-selector",attrs:{"label":this.$t('UserType'),"size":"small"}},[_c('el-select',{attrs:{"multiple":"","size":"small"},model:{value:(_vm.filter.ChannelType),callback:function ($$v) {_vm.$set(_vm.filter, "ChannelType", $$v)},expression:"filter.ChannelType"}},_vm._l((_vm.userTypeList),function(t){return _c('el-option',{key:t,attrs:{"label":_vm.$t('UserType'+t),"value":t}})}))],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",staticStyle:{"text-align":"center"},attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(_vm.$t('reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":_vm.search}},[_vm._v(_vm._s(this.$t('confirm')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ccg8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var menuList = [{
  "name": "Users",
  "icon": "fa fa-users",
  "type": "menu",
  "translate": "用户管理",
  "parent": "",
  "routeName": "UserManagement"
}, {
  "name": "EAN",
  "icon": "fa fa-barcode",
  "type": "menu",
  "translate": "EAN管理",
  "parent": "",
  "routeName": "EANCode"
}, {
  "name": "QRC",
  "icon": "fa fa-qrcode",
  "type": "menu",
  "translate": "QRC管理",
  "parent": "",
  "routeName": "QRCCode"
}, {
  "name": "BoxScan",
  "icon": "fa fa-inbox",
  "type": "menu",
  "translate": "装箱扫描",
  "parent": "",
  "routeName": "BoxScan"
}, {
  "name": "Delivery",
  "icon": "fa fa-truck",
  "type": "menu",
  "translate": "发货管理",
  "parent": "",
  "routeName": "Delivery"
}, {
  "name": "ProductReturn",
  "icon": "fa fa-recycle",
  "type": "menu",
  "translate": "退货管理",
  "parent": "",
  "routeName": "ProductReturn"
}, {
  "name": "Cashback",
  "icon": "fa fa-gift",
  "type": "menu",
  "translate": "返现信息",
  "parent": "",
  "routeName": "Cashback"
}, {
  "name": "CMUser",
  "icon": "fa fa-user-o",
  "type": "menu",
  "translate": "客户信息",
  "parent": "",
  "routeName": "CMUser"
}, {
  "name": "CodeScanningInformation",
  "icon": "fa fa-comments",
  "type": "menu",
  "translate": "扫码信息",
  "parent": "",
  "routeName": "CodeScanningInformation"
}, {
  "name": "Report",
  "icon": "fa fa-bar-chart",
  "type": "menu",
  "translate": "报表管理",
  "parent": "",
  "routeName": "Report"
}];

/* harmony default export */ __webpack_exports__["a"] = (menuList);

/***/ }),

/***/ "DTqe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"top-nav clearfix large"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"title pull-left"},[_c('span',{staticClass:"main-text"},[_vm._v(_vm._s(_vm.mainTitle))]),_vm._v(" "),_c('span',{staticClass:"sub-text"},[_vm._v(_vm._s(_vm.subTitle))])]),_vm._v(" "),_c('div',{staticClass:"user pull-right"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.user.userName))]),_vm._v(" "),_c('span',{staticClass:"logout"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.logout()}}},[_vm._v("注销")])])])]),_vm._v(" "),_c('div',{staticClass:"top-nav clearfix small"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"menu-icon",on:{"click":_vm.toggleMenu}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"logout",on:{"click":function($event){_vm.logout()}}},[_vm._m(1)]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo pull-left"},[_c('img',{attrs:{"src":__webpack_require__("xhJp"),"alt":"logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-power-off"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__("xhJp"),"alt":"logo"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dpj6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileImporter_vue__ = __webpack_require__("eBDn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e7daa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileImporter_vue__ = __webpack_require__("Yztd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileImporter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e7daa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileImporter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Es0F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationHeader_vue__ = __webpack_require__("wgec");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb86b4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationHeader_vue__ = __webpack_require__("uBdi");
function injectStyle (ssrContext) {
  __webpack_require__("69sp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb86b4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F/SY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  maxCasbackAmount: 100,
  minCasbackAmount: 1
});

/***/ }),

/***/ "FXU2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__ = __webpack_require__("mqru");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2c76fd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__ = __webpack_require__("tXg3");
function injectStyle (ssrContext) {
  __webpack_require__("jrIq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d2c76fd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2c76fd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HFTL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrapper"},[_c('div',{staticClass:"login-main clearfix"},[_c('div',{staticClass:"login-input"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"login-title"},[_vm._v("\n        产品追溯平台\n      ")]),_vm._v(" "),_c('div',{staticClass:"login-subtitle"},[_vm._v("\n        Product Traceable Platform\n      ")]),_vm._v(" "),_c('div',{staticClass:"login-userinfo"},[_c('el-form',{ref:"loginForm",attrs:{"rules":_vm.rules,"model":_vm.userInfo,"size":"small","status-icon":true,"show-message":false},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login('loginForm')}}},[_c('el-form-item',{attrs:{"prop":"username"}},[_c('el-input',{attrs:{"autofocus":true,"placeholder":_vm.$t('login.placeholder.userName')},model:{value:(_vm.userInfo.username),callback:function ($$v) {_vm.$set(_vm.userInfo, "username", $$v)},expression:"userInfo.username"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"password"}},[_c('el-input',{attrs:{"type":"password","placeholder":_vm.$t('login.placeholder.password')},model:{value:(_vm.userInfo.password),callback:function ($$v) {_vm.$set(_vm.userInfo, "password", $$v)},expression:"userInfo.password"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"login-btn",attrs:{"type":"primary","loading":_vm.logining,"size":"small"},on:{"click":function($event){_vm.login('loginForm')}}},[_vm._v(_vm._s(_vm.$t("login.title")))])],1),_vm._v(" "),_c('el-checkbox',{staticClass:"rem-me",attrs:{"size":"small"},model:{value:(_vm.rememberMeChecked),callback:function ($$v) {_vm.rememberMeChecked=$$v},expression:"rememberMeChecked"}},[_vm._v(_vm._s(_vm.$t("login.rememberMe")))])],1)],1),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"copy-right"},[_vm._v("\n    Copyright @ "+_vm._s(_vm.year)+" WAGO Corporation. All rights reserved.\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-logo"},[_c('img',{attrs:{"src":__webpack_require__("xhJp"),"alt":"logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-link"},[_c('a',{attrs:{"href":"http://www.wago.com.cn/"}},[_vm._v("WAGO中国>")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:wagocm@wago.com"}},[_vm._v("联系我们>")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-img"},[_c('img',{attrs:{"src":__webpack_require__("9H58"),"alt":"logo"}}),_vm._v(" "),_c('div',{staticClass:"login-link"},[_c('div',[_vm._v("电气连接与自动化解决方案")]),_vm._v(" "),_c('div',[_vm._v("的行业领导者")]),_vm._v(" "),_c('a',{staticClass:"detail",attrs:{"href":"http://www.wago.com.cn/wago/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC/index.jsp"}},[_vm._v("详情>")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HWeK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CMUserInfo_vue__ = __webpack_require__("9Gp+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb612f4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CMUserInfo_vue__ = __webpack_require__("BVFt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CMUserInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb612f4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CMUserInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ILFG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IXLs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar detail clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n        "+_vm._s(_vm.$t("editEAN"))+"\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":function($event){_vm.addEAN('addEANCodeForm')}}},[_vm._v(_vm._s(_vm.$t("save"))+"\n         \n        ")]),_vm._v(" "),_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":_vm.cancelOperation}},[_vm._v(_vm._s(_vm.$t("cancel"))+"\n        \n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"data-list detail"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_c('el-form',{ref:"addEANCodeForm",staticClass:"detail-form",attrs:{"size":"small","model":_vm.EANCodeInfo,"label-width":"120px","rules":_vm.rules,"status-icon":""}},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('EANCode'),"prop":"EANCode"}},[_c('el-input',{attrs:{"disabled":"disabled"},model:{value:(_vm.EANCodeInfo.EANCode),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "EANCode", $$v)},expression:"EANCodeInfo.EANCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('AmountPerPackage'),"prop":"AmountPerPackage"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.AmountPerPackage),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "AmountPerPackage", $$v)},expression:"EANCodeInfo.AmountPerPackage"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('ProductLongCode'),"prop":"ProductLongCode"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.ProductLongCode),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "ProductLongCode", $$v)},expression:"EANCodeInfo.ProductLongCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('ProductShortCode'),"prop":"ProductShortCode"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.ProductShortCode),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "ProductShortCode", $$v)},expression:"EANCodeInfo.ProductShortCode"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('ProductSerials'),"prop":"ProductSerials"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.ProductSerials),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "ProductSerials", $$v)},expression:"EANCodeInfo.ProductSerials"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('SuggestedRetailPrice'),"prop":"SuggestedRetailPrice"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.SuggestedRetailPrice),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "SuggestedRetailPrice", $$v)},expression:"EANCodeInfo.SuggestedRetailPrice"}})],1)],1)],1)],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-header"},[_c('span',[_vm._v("EAN码信息")]),_vm._v(" "),_c('div',{staticClass:"detail-triangle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IzDB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error',{attrs:{"title":"404","content":"未找到该页面"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JBQq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__("5reh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__("wtEF");






// axios.defaults.timeout = 5000;

if (true) {
  // axios.defaults.baseURL = 'http://192.168.3.77:8001/api/';
  // axios.defaults.baseURL = 'https://traceableplatform.azurewebsites.net/api/';
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = 'https://traceableplatform.chinacloudsites.cn/webapi/';
  //axios.defaults.baseURL = 'https://qrc.wagobbu.cn/webapi/';
} else {
  axios.defaults.baseURL = 'http://localhost:41533/';
}

// http request interceptor
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  if (__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */].getters.token) {
    config.headers.Authorization = "bearer " + __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */].getters.token;
  }
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

// http response interceptor
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (err) {
  if (err.response) {
    switch (err.response.status) {
      case 401:
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_2__store_types__["b" /* LOGOUT */]);
        __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].replace({
          name: 'Error401'
        });

    }
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),

/***/ "Kh+8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__("5reh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_searchHistoryService__ = __webpack_require__("jb9L");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isCollapse: true
    };
  },

  methods: {
    handleOpen: function handleOpen(key, keyPath) {},
    handleClose: function handleClose(key, keyPath) {},
    removeSearchHistory: function removeSearchHistory() {
      __WEBPACK_IMPORTED_MODULE_4__services_searchHistoryService__["a" /* default */].removeAll();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['menus', 'menuIndex'])),
  created: function created() {}
});

/***/ }),

/***/ "L14P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["title", "content"],
  name: "error",
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),

/***/ "LHG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AddCodeScanningInformation",
  data: function data() {
    return {
      userTypeList: [],
      QRCTypeList: [],

      CodeScanningInfo: {
        CodeType: "",
        UserType: "",
        ScannningTimes: "",
        ScanningMessage: ""
      },

      rules: {
        CodeType: [{ required: true, message: this.$t("CodeTypeValidation") }],
        UserType: [{ required: true, message: this.$t("UserTypeCodeValidation") }],
        ScanningTimes: [{ required: true, message: this.$t("ScanningTimesValidation") }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");

            if (raw.length > format.length) {
              callback(new Error("请输入一个整数"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        ScanningMessage: [{ required: true, message: this.$t("ScanningMessageValidation") }]
      }
    };
  },

  methods: {
    userTypeSetup: function userTypeSetup() {
      if (this.userTypeList == "") {
        for (var i = 2; i <= 4; i++) {
          this.userTypeList.push(i);
        }
        this.userTypeList.push(8);
      }
      if (this.QRCTypeList == "") {
        this.QRCTypeList.push(1);
        this.QRCTypeList.push(2);
      }
    },
    handlekeyup: function handlekeyup(event) {
      var father = event.currentTarget;
      var input = father.getElementsByTagName("input")[0];
      input.value = input.value.replace(/[^1-9]/g, "");
    },
    addCodeScanning: function addCodeScanning(addCodeScanningForm) {
      var _this = this;

      this.$refs[addCodeScanningForm].validate(function (valid) {
        if (valid) {
          _this.$axios.post("api/codescanning/addoredit", _this.CodeScanningInfo).then(function (response) {
            _this.$message({
              message: _this.$t("addCodeScanningSuccessfully"),
              type: "success",
              showClose: true,
              duration: 2000
            });
            _this.$router.push("CodeScanningInformation");
          }).catch(function (err) {
            _this.$message({
              message: _this.$t(err.response.statusText),
              type: "error",
              showClose: true,
              duration: 2000
            });
          });
        } else {
          _this.$message({
            message: _this.$t("operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },
    cancelOperation: function cancelOperation() {
      this.$router.push("CodeScanningInformation");
    }
  }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15dd432c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("a8h5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15dd432c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MEIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error',{attrs:{"title":"401","content":"无权限访问该页面"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MwJs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// const enUsTranslationResource = {
//   hello: 'hello, world',
// }

// export default enUsTranslationResource

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my name is fan zhongkui'
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_i18n__ = __webpack_require__("xO72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_application_Application__ = __webpack_require__("dsoT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__international_locale__ = __webpack_require__("Rnow");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__("Vi3T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__international_zh__ = __webpack_require__("PdMv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__international_en__ = __webpack_require__("MwJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_types__ = __webpack_require__("5reh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_http__ = __webpack_require__("JBQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_css_theme_scss__ = __webpack_require__("ILFG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_css_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_css_theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_css_main_scss__ = __webpack_require__("8qvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_css_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_css_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__node_modules_font_awesome_css_font_awesome_css__ = __webpack_require__("5W1q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__node_modules_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__node_modules_font_awesome_css_font_awesome_css__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



















//require('./mock.js')

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_14__util_http__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.timeFormatter = function (row, col, val) {
  if (!val) {
    return null;
  }
  return val;
};

// const i18n = new VueI18n({
//   locale: 'zh',  // 语言标识
//   messages: {
//     en: {
//       translation: enUsTranslationResource
//     },
//     zh: {
//       translation: zhCnTranslationResource
//     }
//   }
// })


// Vue.use(ElementUI, {
//   i18n: (key, value) => i18n._t(key, value)
// })
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_i18n___default.a);

//const navLang = navigator.language // 检测系统语言
// const localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : false
//var localLang = 'zh-cn'
// if (navLang === 'zh-CN') {
//   localLang = 'zh-cn'
// } else {
//   localLang = 'en'
// }
//const _lang = window.localStorage.getItem('language') || localLang || 'zh-cn'
//Vue.config.lang = _lang

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.lang = 'zh-cn';

// 饿了吗语言包和项目自身语言包合并
var mergeZH = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_zh_CN___default.a, __WEBPACK_IMPORTED_MODULE_7__international_locale__["a" /* default */].chinese);
var mergeEN = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_en___default.a, __WEBPACK_IMPORTED_MODULE_7__international_locale__["a" /* default */].english);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].locale('zh-cn', mergeZH);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].locale('en', mergeEN);
// 监控语言切换
// bus.$on('chang-langs', function (type) {
//   Vue.config.lang = type
//   window.localStorage.setItem('language', type)
// })

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_12__store_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<AppRoot/>',
  components: { AppRoot: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ "NHt8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCashback_vue__ = __webpack_require__("rqsq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57bd3d06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCashback_vue__ = __webpack_require__("8+7V");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCashback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57bd3d06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCashback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NNsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EANCode_vue__ = __webpack_require__("dnrf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e45dd84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EANCode_vue__ = __webpack_require__("wC+R");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EANCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e45dd84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EANCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NaOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("sonc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476a2d03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("HFTL");
function injectStyle (ssrContext) {
  __webpack_require__("RbpJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476a2d03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O+8E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar detail clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\r\n        "+_vm._s(_vm.$t("user.editUser"))+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":function($event){_vm.addUser('addUserForm')}}},[_vm._v(_vm._s(_vm.$t("save"))+"\r\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.cancelOperation()}}},[_vm._v(_vm._s(_vm.$t("cancel"))+"\r\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"data-list detail"},[_c('div',{staticClass:"detail-header"},[_c('span',[_vm._v(_vm._s(_vm.$t("user.info")))]),_vm._v(" "),_c('div',{staticClass:"detail-triangle"})]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"detail-content"},[_c('el-form',{ref:"addUserForm",staticClass:"detail-form",attrs:{"model":_vm.userInfo,"label-width":"80px","size":"small","rules":_vm.rules,"status-icon":""}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.email'),"prop":"Email"}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.userInfo.Email),callback:function ($$v) {_vm.$set(_vm.userInfo, "Email", $$v)},expression:"userInfo.Email"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.rolesPlaceholder'),"prop":"UserRoles"}},[_c('el-select',{model:{value:(_vm.userInfo.UserRoles),callback:function ($$v) {_vm.$set(_vm.userInfo, "UserRoles", $$v)},expression:"userInfo.UserRoles"}},_vm._l((_vm.rolesList),function(role){return _c('el-option',{key:role,attrs:{"label":_vm.$t(("user.roles." + role)),"value":role}})}))],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.name'),"prop":"Name"}},[_c('el-input',{model:{value:(_vm.userInfo.Name),callback:function ($$v) {_vm.$set(_vm.userInfo, "Name", $$v)},expression:"userInfo.Name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.phoneNumber'),"prop":"PhoneNumber"}},[_c('el-input',{model:{value:(_vm.userInfo.PhoneNumber),callback:function ($$v) {_vm.$set(_vm.userInfo, "PhoneNumber", $$v)},expression:"userInfo.PhoneNumber"}})],1)],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OKFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("qrc.title"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[(_vm.canEdit)?_c('el-button',{staticClass:"sm-hidden",attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.generateDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("qrc.generateCode"))+"\n        "),_c('i',{staticClass:"fa fa-qrcode"})]):_vm._e(),_vm._v(" "),_c('el-button',{staticClass:"sm-hidden",attrs:{"plain":true,"size":"mini"},on:{"click":_vm.QRCHistory}},[_vm._v(_vm._s(_vm.$t("qrc.history"))+"\n        "),_c('i',{staticClass:"fa fa-history"})]),_vm._v(" "),(_vm.canEdit)?_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.statusDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("qrc.setCodeStatus"))+"\n        "),_c('i',{staticClass:"fa fa-cog"})]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n        "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("search"))+"\n        "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.codes,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"QRCode1","align":"center","resizable":true,"label":this.$t('qrc.qrcode1')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"QRCode2","align":"center","resizable":true,"label":this.$t('qrc.qrcode2')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"BatchNumber","align":"center","resizable":true,"label":this.$t('qrc.batchNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Status","align":"center","width":"120px","resizable":true,"label":this.$t('qrc.status')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":_vm.tagType(scope.row.Status)}},[_vm._v("\n            "+_vm._s(_vm.statusFormatter(scope.row.Status))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"GeneratedTime","align":"center","resizable":true,"label":this.$t('qrc.generateTime'),"formatter":_vm.timeFormatter}})],1),_vm._v(" "),_c('el-row',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pageIndex,"page-sizes":[15, 30, 50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('search'),"visible":_vm.searchDialogVisible},on:{"update:visible":function($event){_vm.searchDialogVisible=$event}}},[_c('el-form',{staticClass:"search-form",attrs:{"model":_vm.filter,"inline":true,"size":"small","label-width":"70px"}},[_c('el-form-item',{attrs:{"label":this.$t('qrc.qrcode1'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.QRCode1),callback:function ($$v) {_vm.$set(_vm.filter, "QRCode1", $$v)},expression:"filter.QRCode1"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('qrc.qrcode2'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.QRCode2),callback:function ($$v) {_vm.$set(_vm.filter, "QRCode2", $$v)},expression:"filter.QRCode2"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('qrc.generateTime'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.StartGenTime),callback:function ($$v) {_vm.$set(_vm.filter, "StartGenTime", $$v)},expression:"filter.StartGenTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('to'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.EndGenTime),callback:function ($$v) {_vm.$set(_vm.filter, "EndGenTime", $$v)},expression:"filter.EndGenTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('qrc.status'),"prop":"Status"}},[_c('el-select',{attrs:{"size":"small","clearable":true},model:{value:(_vm.filter.Status),callback:function ($$v) {_vm.$set(_vm.filter, "Status", $$v)},expression:"filter.Status"}},_vm._l((_vm.statusList),function(val,key){return _c('el-option',{key:key,attrs:{"label":_vm.$t(("qrc.statusEnum." + key)),"value":val}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('qrc.batchNumber'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.BatchNumber),callback:function ($$v) {_vm.$set(_vm.filter, "BatchNumber", $$v)},expression:"filter.BatchNumber"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(this.$t('reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":_vm.search}},[_vm._v(_vm._s(this.$t('confirm')))])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('qrc.generateCode'),"visible":_vm.generateDialogVisible,"width":"400px"},on:{"update:visible":function($event){_vm.generateDialogVisible=$event}}},[_c('el-form',{staticClass:"search-form",attrs:{"size":"small","inline":true,"label-width":"100px"}},[_c('el-form-item',{attrs:{"label":this.$t('qrc.codeCount'),"size":"small"}},[_c('el-select',{model:{value:(_vm.generateCount),callback:function ($$v) {_vm.generateCount=$$v},expression:"generateCount"}},_vm._l((_vm.genCountList),function(c){return _c('el-option',{key:c,attrs:{"label":c,"value":c}})}))],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.generateDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini","loading":_vm.generating},on:{"click":_vm.generateCode}},[_vm._v(_vm._s(this.$t('qrc.generate')))])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('qrc.setCodeStatus'),"visible":_vm.statusDialogVisible,"width":"460px"},on:{"update:visible":function($event){_vm.statusDialogVisible=$event}}},[_c('el-form',{ref:"statusForm",staticClass:"search-form",attrs:{"id":"status-dialog","size":"small","status-icon":"","model":_vm.setStatusInfo,"inline":true,"rules":_vm.setStatusInfo.rules,"label-width":"70px"}},[_c('el-form-item',{attrs:{"label":this.$t('qrc.batchNumber'),"size":"small","prop":"batchNumber"}},[_c('el-input',{model:{value:(_vm.setStatusInfo.batchNumber),callback:function ($$v) {_vm.$set(_vm.setStatusInfo, "batchNumber", $$v)},expression:"setStatusInfo.batchNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('qrc.status'),"prop":"status"}},[_c('el-select',{attrs:{"size":"small"},model:{value:(_vm.setStatusInfo.status),callback:function ($$v) {_vm.$set(_vm.setStatusInfo, "status", $$v)},expression:"setStatusInfo.status"}},_vm._l((_vm.changeStatusList),function(val,key){return _c('el-option',{key:key,attrs:{"label":_vm.$t(("qrc.statusEnum." + key)),"value":val}})}))],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.statusDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":_vm.setCodeStatus}},[_vm._v(_vm._s(this.$t('setup')))])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ObFG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRCHistory_vue__ = __webpack_require__("6bja");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6164a2f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRCHistory_vue__ = __webpack_require__("70sN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRCHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6164a2f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRCHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oxk1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PH41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"menu-bar"},[_c('el-col',{attrs:{"span":24}},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.menuIndex,"router":true},on:{"open":_vm.handleOpen,"close":_vm.handleClose}},_vm._l((_vm.menus),function(item){return _c('el-menu-item',{key:item.id,attrs:{"index":item.routeName,"route":{ name: item.routeName }},on:{"click":_vm.removeSearchHistory}},[_c('i',{class:[item.icon]}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.translate))])])}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PdMv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _user$login$qrc$boxSc;

/* harmony default export */ __webpack_exports__["a"] = (_user$login$qrc$boxSc = {
  user: {
    confirmDelete: "确定删除用户[{name}]吗?",
    info: "用户信息",
    title: "用户权限管理",
    resetPassword: "重置密码",
    email: "邮箱",
    name: "姓名",
    username: "用户名",
    phoneNumber: "手机",
    rolesTitle: "用户角色",
    rolesPlaceholder: "角色",
    addUser: "新建用户信息",
    editUser: "编辑用户信息",
    DuplicateUser: "不可重复添加用户",
    confirmPasswordSameValidation: "两次输入密码不一致",
    emailFormatValidation: "请输入正确的邮箱地址",
    userRolesValidation: "请选择角色",
    userAddedSuccessfully: "添加用户成功",
    userUpdatedSuccessfully: "修改用户成功",
    userDeletedSuccessfully: "删除用户成功",
    userDeletedUnsuccessfully: "删除用户失败",
    canNotDeleteAdmin: "无法删除管理员账户",
    operationFailure: "操作失败",
    passwordValidation: "请输入密码",
    confirmPasswordRequiredValidation: "请再次输入密码",
    passwordResetSuccessfully: "修改密码成功",
    password: "密码",
    emailValidation: "请输入邮箱",
    confirmPassword: "确认密码",
    nameValidation: "请输入姓名",
    roles: {
      MarketAdministrator: "市场管理员",
      Administrator: "平台管理员",
      Scanner: "扫描员",
      Manager: "经理",
      StockAdministrator: "仓库管理员",
      ReturnAdministrator: "退货管理员"
    },
    pvalid: {
      minLen: "密码至少需要{len}位",
      oneUppercase: "密码至少需包含一个大写字母",
      oneLowercase: "密码至少需包含一个小写字母",
      oneDigit: "密码至少需包含一个数字",
      oneNonLetterOrDigit: "密码至少需包含一个非字母或数字的符号"
    }
  },
  login: {
    usernameRuleMessage: "用户名不可为空",
    passwordRuleMessage: "密码不可为空",
    loginFailure: "登录失败：用户名或密码错误",
    title: "登录",
    rememberMe: "记住用户名",
    placeholder: {
      userName: "请输入用户名",
      password: "请输入密码"
    }
  },
  qrc: {
    title: "QRC码管理",
    historyTitle: "QRC码生成历史",
    generateCode: "生成二维码",
    codeCount: "二维码数量",
    qrcode1: "二维码1",
    qrcode2: "二维码2",
    status: "状态",
    generateTime: "生成时间",
    batchNumber: "批次号",
    statusEnum: {
      Generated: "已生成",
      Manufactured: "已制作",
      Delivered: "已发货",
      Received: "已领取红包"
    },
    changeStatus: "修改状态",
    generate: "生成",
    setCodeStatus: "设置二维码状态",
    batchNumberNotEmpty: "批次号不能为空",
    batchNumberNotExist: "批次号不存在",
    plsSelectStatus: "请选择二维码状态",
    setStatusSuccess: "设置状态成功",
    setStatusFail: "设置状态失败",
    history: "生成历史",
    count: "生成数量",
    generatePerson: "操作人",
    exportCodes: "导出二维码"
  },
  boxScan: {
    title: "装箱扫描",
    scanIn: "扫描录入",
    beginScan: "开始扫描",
    commitScanInfo: "提交扫描",
    commitScanInfoError: "提交扫描信息错误",
    commitScanInfoSuccess: "提交扫描信息成功",
    scanBoxNumber: "请扫描箱号",
    boxNumber: "箱号",
    eanCode: "EAN码",
    qrCode: "二维码",
    productLongCode: "产品长号",
    scanEanCode: "请扫描EAN码",
    scanQRCode: "请扫描二维码",
    eanCheckFail: "未找到对应的EAN码",
    qrcodeCheckFail: "未找到对应的二维码",
    boxNumberScanned: "该箱号已经扫描：{boxNumber}",
    boxNumberFormatterError: "箱号格式错误，必须为20位",
    clearConfirm: "此操作将清空当前所有扫描记录, 是否继续?",
    clearEanConfirm: "确定要清除EAN码[{code}]的扫描记录吗?",
    clearSuccess: "清除成功",
    deleteScanInfoConfirm: "确定要删除箱号[{boxNumber}]的扫描记录吗,删除后无法恢复?",
    submitDialogTitle: "扫描信息确认",
    productCount: "产品总数",
    productBoxCount: "产品盒数",
    boxTotalCount: "产品总数",
    currentBoxNumber: "当前箱号：",
    currentNumber: "当前数量：",
    duplicateQRCode: "该二维码已扫描",
    qrcodeShippedError: "该二维码已发货",
    deliveryScanTime: "扫描时间",
    scanUserName: "扫描员",
    clearEanScanInfo: "清除该产品型号的扫描记录",
    viewScanRecord: "扫描记录",
    completeIWAC: "是否导入IWAC",
    exportScanInfos: "导出",
    importScanInfos: "导入",
    confirmImportScanInfos: "导入操作将覆盖当前的扫描信息，确定导入吗？",
    importScanInfosInvalid: "导入的扫描信息格式错误！"
  },
  delivery: {
    title: "发货信息管理",
    importIWAC: "IWAC导入",
    uploadOneFileMsg: "每次只支持上传一个文件",
    uploadOneQrcMsg: "每次只支持上传一张二维码",
    selectUploadFile: "请选择需要上传的excel文件",
    clickToUpload: "点击上传",
    uploadSuccess: "上传成功",
    customerNumber: "客户号码",
    customerName: "客户名称",
    customerType: "客户类型",
    customerOffice: "客户地区",
    boxNumber: "箱号",
    orderNumber: "订单号",
    boxScanTime: "装箱扫描时间",
    deliveryTime: "发货时间",
    eanCode: "EAN码",
    productLongCode: "产品长号",
    productShortCode: "产品短号",
    amountPerPackage: "单位包装数",
    productSerials: "产品系列号",
    receivedTime: "红包领取时间",
    bonus: "红包金额(元)",
    qrc1: "二维码1",
    qrc2: "二维码2",
    notReceived: "尚未领取",
    ensureScanned: "导入IWAC信息前，请先进行装箱扫描，否则将无法匹配发货信息",
    qrcSearch: "二维码查询",
    uploadQrc: "上传二维码",
    selectUploadQrc: "请选择需要查询的二维码图片",
    resolveQrcodeFail: "未检测到有效的二维码图片",
    downloadTemp: "模板下载",
    codeAuthCount: "防伪查询次数",
    hasReceived: "是否领取红包",
    overview: "概览",
    notExistQrcode: "该二维码信息不存在"
  },
  report: {
    title: "红包领取信息",
    eanCode: "EAN码",
    productLongCode: "产品长号",
    productShortCode: "产品短号",
    productSerials: "产品系列号",
    receivedTime: "红包领取时间",
    bonus: "红包金额(元)",
    customerOffice: "发货地点",
    customerName: "客户名称",
    deliveryTime: "发货时间",
    receiveAddress: "红包领取地址",
    amountPerPackage: "单位包装数量",
    qrc1: "二维码1",
    qrc2: "二维码2",
    batchNumber: "批次号",
    customerNumber: "客户号码",
    customerType: "客户类型",
    scanCount: "一码扫描次数",
    orderCount: "订货数量",
    deliveryCount: "发货数量",
    orderNumber: "订单号",
    salesAreas: "客户销售范围"
  },
  productReturn: {
    title: "退货记录",
    returnScan: "退货扫描",
    remark: "退货备注",
    count: "退货数量",
    userName: "处理人",
    createTime: "退货时间",
    qrcode1: "二维码1",
    eancode: "EAN码",
    longcode: "产品长号",
    boxNumber: "箱号",
    orderNumber: "订单号",
    customerNumber: "客户号",
    customerName: "客户名",
    deliveryTime: "发货日期",
    detail: "详情"
  },
  returnScan: {
    title: "退货扫描",
    scanQrc1: "请扫描退货产品的二维码1",
    returnRecord: "退货记录",
    commitReturn: "确认退货",
    currentInfo: "退货列表：总计 {count}",
    qrcode: "二维码",
    codeStatusError: "该二维码校验错误，无法退货",
    boxNumber: "箱号",
    customerNum: "客户号",
    customerName: "客户名称",
    orderNum: "订单号",
    eanCode: "EAN码",
    pLongCode: "产品长号",
    pShortCode: "产品短号",
    deliveryTime: "发货时间",
    codeScanned: "该二维码已经在退货列表",
    clearConfirm: "此操作将清空当前所有扫描记录, 是否继续?",
    deleteConfirm: "确定删除该退货产品吗?",
    clearSuccess: "清除成功",
    commitConfirmMsg: "请仔细核对退货信息，退货后将不可取消，是否继续?",
    returnSuccess: "退货成功",
    returnRemarkTip: "输入一些退货备注信息吧..."
  },
  EANCodeManagement: "EAN码管理",
  EANCode: "EAN码",
  ProductSerials: "产品系列号",
  ProductLongCode: "产品长号",
  ProductShortCode: "产品短号",
  AmountPerPackage: "每盒产品数量",
  SuggestedRetailPrice: "建议零售价",
  CashbackInformation: "返现信息",
  CashbackAmount: "返现金额",
  EANCodeValidation: "请输入EAN码",
  ProductLongCodeValidation: "请输入产品长号",
  ProductShortCodeValidation: "请输入产品短号",
  CashbackInformationValidation: "请输入返现信息",
  AmountPerPackageValidation: "请输入每箱产品数量",
  SuggestedRetailPriceValidation: "请输入建议零售价",
  IsNumValidation: "请输入正整数",
  ProductSerialsCodeValidation: "产品系列号不可为空",
  editEAN: "编辑EAN码",
  EANAaddedSuccessfully: "EAN码添加成功",
  EANAEditSuccessfully: "EAN码编辑成功",
  DuplicateEANCode: "该EAN码已存在，请核对！",
  DuplicateCodeScanningTimes: "该扫描次数返回信息已存在，请核对！",
  addEAN: "新建EAN码",
  CashbackManagement: "返现管理"
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "CashbackAmount", "返现金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "EditCashback", "返现信息编辑"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserRole", "用户角色"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "ReceivedSalsArea", "销售区域"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "ChannelAccount", "客户号码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "ChannelType", "客户性质"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "Email", "邮箱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "ChannelTypeName", "客户分级"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "Remarks", "备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType", "客户类别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType0", "直销客户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType1", "工业分销商"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType2", "建筑连接器分销商-零售渠道"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType3", "建筑连接器分销商-工程渠道"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType4", "建筑连接器分销商-电商渠道"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType5", "工业代理商"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType6", "系统集成商"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType7", "WAGO用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType8", "建筑直销渠道"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType9", "建筑连接器分销商-家装渠道"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserType10", "工业贸易商"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "editCashback", "编辑返现信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "CashbackAmountValidation", "返现金额不能为空"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "CashbackEditSuccessfully", "返现信息编辑成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "CMUserView", "客户信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "BICustomName", "客户名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "Office", "办事处"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoABUBBUManager", "WAGO ABU/BBU经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "ChannelCustomer", "渠道客户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoSales", "WAGO 销售人员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoRegionManager", "WAGO 大区经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "Administrator", "系统管理员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoOfficeManager", "WAGO 办事处经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoChannelManager", "WAGO 渠道经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoSalesMarketingManager", "WAGO 销售市场总经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoExpressAdministrator", "WAGO 物流管理员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoComplatintAdministrator", "投诉管理员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoQualityAdministrator", "质量管理员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoStockAdministrator", "库存管理员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "addCodeScanningSuccessfully", "添加扫码返回信息成功！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "editCodeScanningSuccessfully", "编辑扫码返回信息成功！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "WagoCEO", "公司总裁"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "SalesArea", "销售区域"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserRoles", "用户角色"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType0", "系统管理员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType1", "渠道客户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType2", "WAGO 销售人员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType3", "WAGO 办事处经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType4", "WAGO 渠道经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType5", "WAGO 大区经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType6", "WAGO ABU/BBU经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType7", "WAGO 销售市场总经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType9", "WAGO 物流管理员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType10", "WAGO 投诉管理员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType11", "WAGO 质量管理员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType12", "WAGO 库存管理员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "RoleType13", "公司总裁"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "BU", "BU"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "QRC1", "二维码1"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "QRC2", "二维码2"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "editCodeScanning", "编辑扫码显示信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "addCodeScanning", "新建扫码显示信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "CodeTypeValidation", "扫码类型不能为空"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "UserTypeCodeValidation", "客户类型不能为空"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "ScanningTimesValidation", "扫描次数不能为空"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "ScanningMessageValidation", "扫码显示信息不能为空"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "CodeScanningInformation", "扫码显示信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "ScanningTimes", "扫描次数"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "ScanningMessage", "扫码显示信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "CodeType", "扫码类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "operationFailure", "操作失败"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "modify", "修改"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "save", "保存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "cancel", "取消"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "search", "搜索"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "confirm", "确定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "refresh", "刷新"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "add", "新建"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "edit", "编辑"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "delete", "删除"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "tip", "提示"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "from", "从"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "to", "到"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "reset", "重置"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "setup", "设置"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "export", "导出"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "back", "返回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "submit", "提交"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "total", "总计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "operation", "操作"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "deleteSuccess", "删除成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "deleteFail", "删除失败"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "upload", "上传"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "query", "查询"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "serialNumber", "序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "activation", "启用红包"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "inActivation", "禁用红包"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "deleteSuccess", "删除成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "deleteFail", "删除失败"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "upload", "上传"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user$login$qrc$boxSc, "query", "查询"), _user$login$qrc$boxSc);

/***/ }),

/***/ "PqgG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"error-content"},[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),_c('div',{staticClass:"error-link"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n      主页\n    ")]),_vm._v("\n    |\n    "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n      登录\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"error-footer"},[_vm._v("\n    © "+_vm._s(_vm.year)+" - 追溯管理平台\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QT0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__ = __webpack_require__("ZWhC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427aa494_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__ = __webpack_require__("cbEs");
function injectStyle (ssrContext) {
  __webpack_require__("TpEs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-427aa494"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427aa494_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qu2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messageService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__("OxnK");


var subject = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["a" /* Subject */]();

var messageService = {
    sendMessage: function sendMessage(message) {
        return subject.next({ text: message });
    },
    clearMessages: function clearMessages() {
        return subject.next();
    },
    getMessage: function getMessage() {
        return subject.asObservable();
    }
};

/***/ }),

/***/ "RbpJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RgSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserManagement_vue__ = __webpack_require__("aPi7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c05b7af4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserManagement_vue__ = __webpack_require__("YyFz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c05b7af4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rnow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zh__ = __webpack_require__("PdMv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en__ = __webpack_require__("MwJs");



/* harmony default export */ __webpack_exports__["a"] = ({
  chinese: __WEBPACK_IMPORTED_MODULE_0__zh__["a" /* default */],
  english: __WEBPACK_IMPORTED_MODULE_1__en__["a" /* default */]
});

/***/ }),

/***/ "SXfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var cookieStorage = {
    getItem: function getItem(key) {
        return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(key);
    },
    setItem: function setItem(key, val) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(key, val);
    },
    removeItem: function removeItem(key) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(key);
    }
};

var storage = localStorage;

try {
    localStorage.setItem('test', 'test');
    localStorage.removeItem('test');
} catch (e) {
    storage = cookieStorage;
}

/* harmony default export */ __webpack_exports__["a"] = (storage);

/***/ }),

/***/ "TWZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("productReturn.title"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[(_vm.canExport)?_c('el-button',{staticClass:"sm-hidden",attrs:{"plain":true,"loading":_vm.exporting,"size":"mini"},on:{"click":_vm.exportExcel}},[_vm._v(_vm._s(_vm.$t("export"))+"\n        "),_c('i',{staticClass:"fa fa-download"})]):_vm._e(),_vm._v(" "),(_vm.canScan)?_c('el-button',{staticClass:"sm-hidden",attrs:{"plain":true,"size":"mini"},on:{"click":_vm.beginScan}},[_vm._v(_vm._s(_vm.$t("productReturn.returnScan"))+"\n        "),_c('i',{staticClass:"fa fa-qrcode"})]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n        "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("search"))+"\n        "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"stripe":"","data":_vm.returnRecords,"size":"mini"}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":scope.row.Details,"size":"mini"}},[_c('el-table-column',{attrs:{"type":"index","width":"50","label":_vm.$t('serialNumber'),"align":"center"}}),_vm._v(" "),_vm._l((_vm.detailTableCols),function(col){return _c('el-table-column',{key:col.prop,attrs:{"prop":col.prop,"align":"center","resizable":true,"label":_vm.$t(col.label),"width":col.width,"show-overflow-tooltip":true}})})],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"CreateTime","align":"center","resizable":true,"label":_vm.$t('productReturn.createTime'),"formatter":_vm.timeFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Remark","align":"center","resizable":true,"label":_vm.$t('productReturn.remark')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Count","align":"center","resizable":true,"label":_vm.$t('productReturn.count')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"UserName","align":"center","resizable":true,"label":_vm.$t('productReturn.userName')}})],1),_vm._v(" "),_c('el-row',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pageIndex,"page-sizes":[15, 30, 50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":_vm.$t('search'),"visible":_vm.searchDialogVisible},on:{"update:visible":function($event){_vm.searchDialogVisible=$event}}},[_c('el-form',{staticClass:"search-form",attrs:{"model":_vm.filter,"inline":true,"size":"small","label-width":"70px"}},[_c('el-form-item',{attrs:{"label":_vm.$t('productReturn.userName'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.userName),callback:function ($$v) {_vm.$set(_vm.filter, "userName", $$v)},expression:"filter.userName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('productReturn.remark'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.remark),callback:function ($$v) {_vm.$set(_vm.filter, "remark", $$v)},expression:"filter.remark"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('productReturn.qrcode1'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.qrcode1),callback:function ($$v) {_vm.$set(_vm.filter, "qrcode1", $$v)},expression:"filter.qrcode1"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('productReturn.orderNumber'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.orderNumber),callback:function ($$v) {_vm.$set(_vm.filter, "orderNumber", $$v)},expression:"filter.orderNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('productReturn.createTime'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.startTime),callback:function ($$v) {_vm.$set(_vm.filter, "startTime", $$v)},expression:"filter.startTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('to'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.endTime),callback:function ($$v) {_vm.$set(_vm.filter, "endTime", $$v)},expression:"filter.endTime"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(_vm.$t('reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":_vm.search}},[_vm._v(_vm._s(_vm.$t('confirm')))])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TdT6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("U+zB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8902c33e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("DTqe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8902c33e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ToSo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TpEs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Txmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRCCode_vue__ = __webpack_require__("rTkM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01487203_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRCCode_vue__ = __webpack_require__("OKFm");
function injectStyle (ssrContext) {
  __webpack_require__("hYsk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRCCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01487203_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRCCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U+zB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__("5reh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_searchHistoryService__ = __webpack_require__("jb9L");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Navbar",
  props: {
    mainTitle: String,
    subTitle: String
  },
  data: function data() {
    return {
      index: ""
    };
  },

  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_3__services_searchHistoryService__["a" /* default */].removeAll();
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_types__["b" /* LOGOUT */]);
      this.$router.push({
        name: "Login"
      });
    },
    toggleMenu: function toggleMenu() {
      var sidebar = document.querySelector(".sidebar");
      sidebar.classList.toggle('open');
      event.stopPropagation();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(["user"])),
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__services_searchHistoryService__["a" /* default */].removeAll();
  },
  mounted: function mounted() {
    var body = document.querySelector('body');
    var sidebar = document.querySelector(".sidebar");
    body.addEventListener("click", function () {
      sidebar.classList.remove("open");
    });
  }
});

/***/ }),

/***/ "V9tU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VATJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VdXl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCodeScanningInformation_vue__ = __webpack_require__("LHG7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e4947a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCodeScanningInformation_vue__ = __webpack_require__("/x7J");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCodeScanningInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e4947a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCodeScanningInformation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VmoN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1702d08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCashback_vue__ = __webpack_require__("yd8o");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1702d08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCashback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "W9Vh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{on:{"mouseover":function($event){_vm.handleFocus($event)}}},[_vm._v(_vm._s(_vm.handleLoad()))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WsFC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EditUser",
  data: function data() {
    return {
      userInfo: {},
      rolesList: [],
      loading: true,
      rules: {
        Email: [{
          required: true
        }, {
          type: "email",
          message: this.$t("user.emailFormatValidation")
        }],
        Name: [{
          required: true,
          message: this.$t("user.nameValidation")
        }],
        UserRoles: [{
          required: true,
          message: this.$t("user.userRolesValidation")
        }],
        PhoneNumber: [{
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            if (raw == "" || raw == null || raw == undefined) {
              callback();
            }
            var format = raw.replace(/[^0-9+]/g, '');

            if (raw.length != 14 && raw.length != 11 || raw.length == 14 && raw.charAt(0) != '+' || raw.substring(1, raw.length).includes("+") || raw.length > format.length) {

              callback(new Error("请输入正确的手机号码"));
            } else {
              callback();
            }
          }, trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    this.loading = true;
    this.$axios.get("api/Roles").then(function (response) {
      _this.rolesList = response.data.map(function (r) {
        return r.Name;
      });
    });

    this.$axios.get("api/users/" + this.$route.params.userId).then(function (response) {
      _this.userInfo = response.data;
      _this.userInfo.UserRoles = _this.userInfo.UserRoles[0];
      _this.loading = false;
    });
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({ name: "UserManagement" });
    },
    addUser: function addUser(addUserForm) {
      var _this2 = this;

      this.$refs[addUserForm].validate(function (valid) {
        if (valid) {
          _this2.$axios.put("api/Users", _this2.userInfo).then(function (response) {
            _this2.$message({
              message: _this2.$t("user.userUpdatedSuccessfully"),
              type: "success",
              showClose: true,
              duration: 2000
            });
            _this2.goBack();
          }).catch(function (e) {
            var modelState = e.response && e.response.data.ModelState;
            var msg = modelState && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(modelState).join() || _this2.$t("user.operationFailure");
            _this2.$message({
              message: msg,
              type: "error"
            });
          });
        } else {
          _this2.$message({
            message: _this2.$t("user.operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },
    cancelOperation: function cancelOperation() {
      this.goBack();
    }
  }
});

/***/ }),

/***/ "Xh3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AddEAN",
  data: function data() {
    return {
      EANCodeInfo: {
        EANCode: "",
        AmountPerPackage: "",
        ProductLongCode: "",
        ProductShortCode: "",
        ProductSerials: "",
        SuggestedRetailPrice: ""
      },
      rules: {
        EANCode: [{ required: true, message: this.$t("EANCodeValidation") }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > format.length) {
              callback(new Error("EAN码只能为阿拉伯数字"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        ProductLongCode: [{
          required: true,
          message: this.$t("ProductLongCodeValidation")
        }, {
          pattern: new RegExp(/[-]/),
          message: this.$t("必须包含数字与‘-’"),
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9-]/g, "");
            if (raw.length > format.length) {
              callback(new Error("必须包含数字与‘-’"));
            } else {
              if (raw.charAt(raw.length - 1) === "-" || raw.charAt(0) === "-") {
                callback(new Error("格式不正确"));
              }
              callback();
            }
          },
          trigger: "blur"
        }],
        ProductShortCode: [{
          required: true,
          message: this.$t("ProductShortCodeValidation")
        }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > format.length) {
              callback(new Error("短号只能为阿拉伯数字"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        ProductSerials: [{ required: true, message: this.$t("ProductSerialsCodeValidation") }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > format.length) {
              callback(new Error("系列号只能为阿拉伯数字"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        AmountPerPackage: [{
          required: true,
          message: this.$t("AmountPerPackageValidation")
        }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > 9) {
              callback(new Error("每盒产品数量过大"));
            }
            if (raw.length > format.length) {
              callback(new Error("请输入一个整数"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        SuggestedRetailPrice: [{
          required: true,
          message: this.$t("SuggestedRetailPriceValidation")
        }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^\d+(\.\d+)?$]/g, "");

            if (raw.length > format.length) {
              callback(new Error("请输入一个浮点数"));
            }

            var index = raw.indexOf(".");
            if (index != -1) {
              var arrStr = [];
              arrStr = raw.split(".");
              if (arrStr[1] && arrStr[1].length > 2) {
                callback(new Error("请输入一个2位小数"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      }
    };
  },

  methods: {
    addEAN: function addEAN(addEANCodeForm) {
      var _this = this;

      this.$refs[addEANCodeForm].validate(function (valid) {
        if (valid) {
          _this.$axios.post("api/eancodes/addoredit", _this.EANCodeInfo).then(function (response) {
            _this.$message({
              message: _this.$t("EANAaddedSuccessfully"),
              type: "success",
              showClose: true,
              duration: 2000
            });
            _this.$router.push("EANCode");
          }).catch(function (err) {
            _this.$message({
              message: _this.$t(err.response.statusText),
              type: "error",
              showClose: true,
              duration: 2000
            });
          });
        } else {
          _this.$message({
            message: _this.$t("operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },
    cancelOperation: function cancelOperation() {
      this.$router.push("EANCode");
    }
  }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Xsve":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCodeScanningInformation_vue__ = __webpack_require__("ZJ9I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa2a55d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCodeScanningInformation_vue__ = __webpack_require__("aX90");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCodeScanningInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa2a55d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCodeScanningInformation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_types__ = __webpack_require__("5reh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_application_Application__ = __webpack_require__("dsoT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_login_Login__ = __webpack_require__("NaOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_application_EANCode_EANCode__ = __webpack_require__("NNsF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_application_EANCode_AddEAN__ = __webpack_require__("q829");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_application_EANCode_EditEAN__ = __webpack_require__("Zqkd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_application_userManagement_UserManagement__ = __webpack_require__("RgSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_application_UserManagement_AddUser__ = __webpack_require__("FXU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_application_UserManagement_EditUser__ = __webpack_require__("d7WJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_application_UserManagement_ResetPassword__ = __webpack_require__("+Try");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_application_QRC_QRCCode__ = __webpack_require__("Txmz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_application_QRC_QRCHistory__ = __webpack_require__("ObFG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_401__ = __webpack_require__("eIH0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_404__ = __webpack_require__("z3nk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_application_Cashback_Cashback__ = __webpack_require__("Acar");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_application_Cashback_AddCashback__ = __webpack_require__("VmoN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_application_Cashback_EditCashback__ = __webpack_require__("NHt8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_application_CMUserInfo_CMUserInfo__ = __webpack_require__("HWeK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_application_Delivery_Delivery__ = __webpack_require__("d82f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_application_BoxScan_BoxScan__ = __webpack_require__("e9G+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_application_BoxScan_ScanInfo__ = __webpack_require__("hm/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_application_CodeScanningInformation_CodeScanningInformation__ = __webpack_require__("p3ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_application_CodeScanningInformation_AddCodeScanningInformation__ = __webpack_require__("VdXl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_application_CodeScanningInformation_EditCodeScanningInformation__ = __webpack_require__("Xsve");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_application_Report_Report__ = __webpack_require__("QT0v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_application_ProductReturn_ProductReturn__ = __webpack_require__("YaSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_application_ProductReturn_ReturnScan__ = __webpack_require__("ARzl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Infrustructure_menu__ = __webpack_require__("Ccg8");
































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: "history",
  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_login_Login__["a" /* default */]
  }, {
    path: '/401',
    name: 'Error401',
    component: __WEBPACK_IMPORTED_MODULE_15__components_common_401__["a" /* default */]
  }, {
    path: '/404',
    name: 'Error404',
    component: __WEBPACK_IMPORTED_MODULE_16__components_common_404__["a" /* default */]
  }, {
    path: '/',
    name: "App",
    component: __WEBPACK_IMPORTED_MODULE_4__components_application_Application__["a" /* default */],
    meta: { requireAuth: true },
    children: [{
      path: 'EANCode',
      name: 'EANCode',
      component: __WEBPACK_IMPORTED_MODULE_6__components_application_EANCode_EANCode__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'addEAN',
      name: 'AddEAN',
      component: __WEBPACK_IMPORTED_MODULE_7__components_application_EANCode_AddEAN__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'editEAN/:EANId',
      name: 'EditEAN',
      component: __WEBPACK_IMPORTED_MODULE_8__components_application_EANCode_EditEAN__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'userManagement',
      name: 'UserManagement',
      component: __WEBPACK_IMPORTED_MODULE_9__components_application_userManagement_UserManagement__["a" /* default */],
      meta: {
        requireAuth: true
      }
    }, {
      path: 'userManagement/add',
      name: 'AddUser',
      component: __WEBPACK_IMPORTED_MODULE_10__components_application_UserManagement_AddUser__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'userManagement/:userId',
      name: 'EditUser',
      component: __WEBPACK_IMPORTED_MODULE_11__components_application_UserManagement_EditUser__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'userManagement/resetPassword/:userId',
      name: 'ResetPassword',
      component: __WEBPACK_IMPORTED_MODULE_12__components_application_UserManagement_ResetPassword__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'QRCCode',
      name: 'QRCCode',
      component: __WEBPACK_IMPORTED_MODULE_13__components_application_QRC_QRCCode__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'QRCCode/history',
      name: 'QRCHistory',
      component: __WEBPACK_IMPORTED_MODULE_14__components_application_QRC_QRCHistory__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'Cashback',
      name: 'Cashback',
      component: __WEBPACK_IMPORTED_MODULE_17__components_application_Cashback_Cashback__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'AddCashback',
      name: 'AddCashback',
      component: __WEBPACK_IMPORTED_MODULE_17__components_application_Cashback_Cashback__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'EditCashback',
      name: 'EditCashback',
      component: __WEBPACK_IMPORTED_MODULE_19__components_application_Cashback_EditCashback__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'CMUser',
      name: 'CMUser',
      component: __WEBPACK_IMPORTED_MODULE_20__components_application_CMUserInfo_CMUserInfo__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'delivery',
      name: 'Delivery',
      component: __WEBPACK_IMPORTED_MODULE_21__components_application_Delivery_Delivery__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'delivery/boxscan',
      name: 'BoxScan',
      component: __WEBPACK_IMPORTED_MODULE_22__components_application_BoxScan_BoxScan__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'delivery/boxscan/scaninfo',
      name: 'ScanInfo',
      component: __WEBPACK_IMPORTED_MODULE_23__components_application_BoxScan_ScanInfo__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'CodeScanningInformation',
      name: 'CodeScanningInformation',
      component: __WEBPACK_IMPORTED_MODULE_24__components_application_CodeScanningInformation_CodeScanningInformation__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'addCodeScanningInformation',
      name: 'AddCodeScanningInformation',
      component: __WEBPACK_IMPORTED_MODULE_25__components_application_CodeScanningInformation_AddCodeScanningInformation__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'editCodeScanningInformation',
      name: 'EditCodeScanningInformation',
      component: __WEBPACK_IMPORTED_MODULE_26__components_application_CodeScanningInformation_EditCodeScanningInformation__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'report',
      name: 'Report',
      component: __WEBPACK_IMPORTED_MODULE_27__components_application_Report_Report__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'product/return',
      name: 'ProductReturn',
      component: __WEBPACK_IMPORTED_MODULE_28__components_application_ProductReturn_ProductReturn__["a" /* default */],
      meta: { requireAuth: true }
    }, {
      path: 'product/return/scan',
      name: 'ReturnScan',
      component: __WEBPACK_IMPORTED_MODULE_29__components_application_ProductReturn_ReturnScan__["a" /* default */],
      meta: { requireAuth: true }
    }]
  }, {
    path: '*',
    redirect: '/404'
  }]
});


var setMenuIndex = function setMenuIndex(routeName) {
  var menu = __WEBPACK_IMPORTED_MODULE_31__Infrustructure_menu__["a" /* default */].find(function (m) {
    return m.routeName === routeName;
  });
  if (menu) {
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_3__store_types__["c" /* MENUINDEX */], routeName);
  }
};

var closeMessage = function closeMessage() {
  __WEBPACK_IMPORTED_MODULE_30_element_ui__["Message"].closeAll();
};

router.beforeEach(function (to, from, next) {
  closeMessage();
  setMenuIndex(to.name);

  if (to.meta.requireAuth) {
    //已登录
    if (__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getters.token) {
      //如果是根路径'/'跳转到第一个菜单
      if (to.fullPath === '/') {
        var _menus = __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getters.menus;
        var routeName = _menus && _menus.length && _menus[0].routeName;
        if (routeName) {
          next({
            name: routeName || 'App'
          });
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      //未登录
      var route = { name: 'Login' };
      if (to.fullPath !== '/') {
        route.query = {
          redirect: to.fullPath
        };
      }
      next(route);
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YaSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductReturn_vue__ = __webpack_require__("2PZW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b240bd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductReturn_vue__ = __webpack_require__("TWZp");
function injectStyle (ssrContext) {
  __webpack_require__("ToSo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductReturn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b240bd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductReturn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YyFz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("user.title"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[(_vm.canAddUser)?_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.addUser}},[_vm._v(_vm._s(_vm.$t("add"))+"\n        "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n        "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("search"))+"\n        "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.userData,"size":"mini"}},[(_vm.canAddUser)?_c('el-table-column',{attrs:{"label":"操作","align":"center","resizable":true},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.handleEdit(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$t("edit")))]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.isAdmin(scope.row)},on:{"click":function($event){_vm.handleDelete(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$t("delete")))]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.resetPassword(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$t("user.resetPassword")))])]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Email","align":"center","resizable":true,"label":this.$t('user.email')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"UserName","align":"center","resizable":true,"label":this.$t('user.username')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Name","align":"center","resizable":true,"label":this.$t('user.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Roles","align":"center","resizable":true,"label":this.$t('user.rolesTitle'),"formatter":_vm.RoleFormatter}})],1),_vm._v(" "),_c('el-row',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pageIndex,"page-sizes":[15,30,50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('search'),"visible":_vm.searchDialogVisible,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.searchDialogVisible=$event},"close":function($event){_vm.searchDialogClosed()}}},[_c('el-form',{staticClass:"search-form",attrs:{"model":_vm.filter,"size":"small"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.username'),"size":"small","label-width":_vm.searchDialogLabelWidth}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.filter.username),callback:function ($$v) {_vm.$set(_vm.filter, "username", $$v)},expression:"filter.username"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.email'),"size":"small","label-width":_vm.searchDialogLabelWidth}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.filter.email),callback:function ($$v) {_vm.$set(_vm.filter, "email", $$v)},expression:"filter.email"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24}},[_c('el-form-item',{attrs:{"label":this.$t('user.rolesPlaceholder'),"prop":"userRoles","label-width":_vm.searchDialogLabelWidth}},[_c('el-select',{attrs:{"multiple":"","size":"small"},model:{value:(_vm.filter.userRoles),callback:function ($$v) {_vm.$set(_vm.filter, "userRoles", $$v)},expression:"filter.userRoles"}},_vm._l((_vm.rolesList),function(role){return _c('el-option',{key:role.value,attrs:{"label":_vm.$t(("user.roles." + (role.Name))),"value":role.Name}})}))],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false;_vm.search();}}},[_vm._v(_vm._s(this.$t('confirm')))])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Yztd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"info","plain":"","size":"mini"},on:{"click":function($event){_vm.centerDialogVisible = true}}},[_vm._v("导入 "),_c('i',{staticClass:"el-icon-upload el-icon--right"})]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"导入","visible":_vm.centerDialogVisible,"lock-scroll":false,"close-on-click-modal":false,"show-close":true,"width":"18%","before-close":_vm.handleClose,"left":""},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"#","auto-upload":false}},[_c('el-button',{attrs:{"slot":"trigger","type":"info","size":"mini"},on:{"click":_vm.removelink},slot:"trigger"},[_vm._v("浏览 "),_c('i',{staticClass:"el-icon-search el-icon--right"})]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"size":"mini","type":"info"},on:{"click":_vm.upload}},[_vm._v("上传 "),_c('i',{staticClass:"el-icon-upload2 el-icon--right"})]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只支持xls/xlsx格式类型的文件 ")])],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"info","size":"mini"},on:{"click":_vm.diposed}},[_vm._v("取消")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZJ9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EditCodeScanningInformation",
  data: function data() {
    return {
      userTypeList: [],
      QRCTypeList: [],

      CodeScanningInfo: {
        CodeType: "",
        UserType: "",
        ScannningTimes: "",
        ScanningMessage: ""
      },

      rules: {
        CodeType: [{ required: true, message: this.$t("CodeTypeValidation") }],
        UserType: [{ required: true, message: this.$t("UserTypeCodeValidation") }],
        ScanningTimes: [{ required: true, message: this.$t("ScanningTimesValidation") }, {
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > format.length) {
              callback(new Error("请输入一个整数"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        ScanningMessage: [{ required: true, message: this.$t("ScanningMessageValidation") }]
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$axios.get("api/codescanning/" + this.$route.params.Id).then(function (response) {
      _this.CodeScanningInfo = response.data;
    });
  },

  methods: {
    userTypeSetup: function userTypeSetup() {
      if (this.userTypeList == "") {
        for (var i = 2; i <= 4; i++) {
          this.userTypeList.push(i);
        }
        this.userTypeList.push(8);
      }
      if (this.QRCTypeList == "") {
        this.QRCTypeList.push(1);
        this.QRCTypeList.push(2);
      }
    },
    handlekeyup: function handlekeyup(event) {
      var father = event.currentTarget;
      var input = father.getElementsByTagName("input")[0];
      input.value = input.value.replace(/[^0-9]/g, "");
    },
    addCodeScanning: function addCodeScanning(addCodeScanningForm) {
      var _this2 = this;

      this.$refs[addCodeScanningForm].validate(function (valid) {
        if (valid) {
          _this2.$axios.post("api/codescanning/addoredit", _this2.CodeScanningInfo).then(function (response) {
            _this2.$message({
              message: _this2.$t("editCodeScanningSuccessfully"),
              type: "success",
              showClose: true,
              duration: 2000
            });
            _this2.$router.push("CodeScanningInformation");
          }).catch(function (err) {
            _this2.$message({
              message: _this2.$t(err.response.statusText),
              type: "error",
              showClose: true,
              duration: 2000
            });
          });
        } else {
          _this2.$message({
            message: _this2.$t("operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },
    cancelOperation: function cancelOperation() {
      this.$router.push("CodeScanningInformation");
    }
  }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "ZWhC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_roleTypes__ = __webpack_require__("B0E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__ = __webpack_require__("jb9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_userTypes__ = __webpack_require__("aYxF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Report",
  data: function data() {
    return {
      searchDialogVisible: false,
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
      reportInfos: [],
      loading: true,
      exportLoading: false,
      filter: {
        hasReceived: "all"
      },
      filterOptions: []
    };
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getReportInfo();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.getReportInfo();
    },
    getReportInfo: function getReportInfo() {
      var _this = this;

      this.loading = true;
      var params = {
        filter: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios.get("api/report", { params: params }).then(function (res) {
        _this.totalCount = res.data.TotalCount;
        _this.reportInfos = res.data.Data;
        _this.loading = false;
      }).catch(function (e) {
        _this.loading = false;
      });
    },
    exportReport: function exportReport() {
      var _this2 = this;

      this.exportLoading = true;
      var params = {
        filter: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.filterOptions)
      };
      this.$axios.get("api/report/export", { params: params }).then(function (res) {
        var fileName = decodeURIComponent(res.headers["file-name"] || "report.csv");
        var BOM = "\uFEFF";
        var blob = new Blob([BOM + res.data]);
        __WEBPACK_IMPORTED_MODULE_7_file_saver___default.a.saveAs(blob, fileName);
        _this2.exportLoading = false;
      }).catch(function (e) {
        _this2.exportLoading = false;
      });
    },
    search: function search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].setHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].REPORT_HISTORY, this.filterOptions);
      this.getReportInfo();
    },
    resetFilter: function resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].removeHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].REPORT_HISTORY);
    },
    setFilterOptions: function setFilterOptions() {
      var _this3 = this;

      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
        var val = _this3.filter[k];
        if (typeof val === "number" || val) {
          _this3.filterOptions.push({ name: k, value: val });
        }
      });
    },
    refresh: function refresh() {
      this.resetFilter();
      this.getReportInfo();
    },
    initializeFilter: function initializeFilter() {
      var _this4 = this;

      var his = __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].getHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].REPORT_HISTORY);
      if (his) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter);
        his.forEach(function (h) {
          if (keys.includes(h.name)) {
            _this4.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    fullAddress: function fullAddress(_ref) {
      var Province = _ref.Province,
          City = _ref.City,
          Location = _ref.Location;

      if (Province || City || Location) {
        return (Province ? Province : "") + " " + (City ? City : "") + " " + (Location ? Location : "");
      } else {
        return "--";
      }
    },
    receivedTimeFormatter: function receivedTimeFormatter(row, col, val) {
      if (val) {
        return this.timeFormatter(row, col, val);
      }
      return this.$t("delivery.notReceived");
    },
    customerTypeFormatter: function customerTypeFormatter(row, col, val) {
      return __WEBPACK_IMPORTED_MODULE_6__models_userTypes__["a" /* default */][val];
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(["roles", "permissions", "token"]), {
    canExport: function canExport() {
      return this.roles.includes(__WEBPACK_IMPORTED_MODULE_3__models_roleTypes__["a" /* default */].Administrator) || this.permissions.find(function (p) {
        return p.toLowerCase() === "report.export";
      });
    }
  }),
  created: function created() {
    this.initializeFilter();
    this.getReportInfo();
  }
});

/***/ }),

/***/ "Zqkd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditEAN_vue__ = __webpack_require__("7mqq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e902adc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditEAN_vue__ = __webpack_require__("IXLs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditEAN_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e902adc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditEAN_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a8h5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aPi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_join__ = __webpack_require__("ZZNS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");



 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UserManagement",
  data: function data() {
    return {
      userData: [],
      filter: {
        username: "",
        email: "",
        userRoles: [],
        name: ""
      },
      rolesList: [],
      searchDialogLabelWidth: "60px",
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      searchDialogVisible: false,
      loading: true
    };
  },

  methods: {
    addUser: function addUser() {
      this.$router.push({ name: "AddUser" });
    },
    RoleFormatter: function RoleFormatter(row, column) {
      var roles = row.UserRoles;

      var displayRoles = [];

      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(roles, function (value) {
        displayRoles.push(self.$t("user.roles." + value));
      });

      return __WEBPACK_IMPORTED_MODULE_2_lodash_join___default()(displayRoles, ",");
    },
    isAdmin: function isAdmin(row) {
      return row.UserRoles.includes("Administrator");
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.obtainTableDataAccordingToConditions();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.obtainTableDataAccordingToConditions();
    },
    handleEdit: function handleEdit(index, row) {
      this.$router.push({ name: "EditUser", params: { userId: row.Id } });
    },
    handleDelete: function handleDelete(index, row) {
      var _this = this;

      if (this.isAdmin(row)) {
        this.$message({
          type: "error",
          message: this.$t("user.canNotDeleteAdmin")
        });
        return;
      }
      this.$confirm(this.$t("user.confirmDelete", { name: row.Name }), this.$t("tip"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning"
      }).then(function () {
        _this.$axios.delete("api/users/" + row.Id).then(function (response) {
          _this.$message({
            type: "success",
            message: _this.$t("user.userDeletedSuccessfully")
          });
          _this.obtainTableDataAccordingToConditions();
        }).catch(function (err) {
          var msg = err.response ? err.response.data : _this.$t("user.userDeletedUnsuccessfully");
          _this.$message({
            type: "error",
            message: msg
          });
        });
      }).catch(function () {});
    },
    resetPassword: function resetPassword(index, row) {
      this.$router.push({ name: "ResetPassword", params: { userId: row.Id } });
    },
    handleClose: function handleClose(done) {
      done();
    },
    search: function search() {
      this.obtainTableDataAccordingToConditions();
    },
    searchDialogClosed: function searchDialogClosed() {},
    refresh: function refresh() {
      this.filter = {
        username: "",
        email: "",
        userRoles: [],
        name: ""
      };
      this.obtainTableDataAccordingToConditions();
    },
    generateFilterOptions: function generateFilterOptions() {
      var filterOptions = [];
      if (this.filter.username !== null && this.filter.username.trim() !== "") {
        var filterOption = {
          name: "userName",
          value: this.filter.username
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.email !== null && this.filter.email.trim() !== "") {
        var filterOption = {
          name: "email",
          value: this.filter.email
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.userRoles.length > 0) {
        var selectedRoles = "";
        var count = 0;
        for (var i = 0; i < this.filter.userRoles.length; i++) {
          selectedRoles += this.filter.userRoles[i];
          if (count !== this.filter.userRoles.length - 1) {
            selectedRoles += "%";
          }
          count++;
        }

        var filterOption = {
          name: "userRoles",
          value: selectedRoles
        };
        filterOptions.push(filterOption);
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filterOptions);
    },
    obtainTableDataAccordingToConditions: function obtainTableDataAccordingToConditions() {
      var _this2 = this;

      this.loading = true;
      this.$axios.get("api/Users", {
        params: {
          filter: this.generateFilterOptions(),
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
      }).then(function (response) {
        _this2.userData = response.data.Data;
        _this2.totalCount = response.data.TotalCount;
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(["roles", "permissions"]), {
    canAddUser: function canAddUser() {
      return this.roles.includes("Administrator") || this.permissions.find(function (p) {
        return p.toLowerCase() === "user.insert";
      });
    }
  }),
  created: function created() {
    var _this3 = this;

    this.obtainTableDataAccordingToConditions();
    this.$axios.get("api/Roles").then(function (response) {
      _this3.rolesList = response.data;
    });
  }
});

/***/ }),

/***/ "aX90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mouseover":_vm.userTypeSetup}},[_c('div',{staticClass:"title-bar detail clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("editCodeScanning"))+"\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":function($event){_vm.addCodeScanning('addCodeScanningForm')}}},[_vm._v(_vm._s(_vm.$t("save"))+"\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":_vm.cancelOperation}},[_vm._v(_vm._s(_vm.$t("cancel"))+"\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"data-list detail"},[_c('div',{staticClass:"detail-header"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("CodeScanningInformation")))]),_vm._v(" "),_c('div',{staticClass:"detail-triangle"})]),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_c('el-form',{ref:"addCodeScanningForm",staticClass:"detail-form",attrs:{"size":"small","model":_vm.CodeScanningInfo,"label-width":"120px","rules":_vm.rules,"status-icon":""}},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('ScanningTimes'),"prop":"ScanningTimes"}},[_c('el-tooltip',{attrs:{"effect":"dark","content":"0 表示未找到产品号","placement":"right"}},[_c('el-input',{model:{value:(_vm.CodeScanningInfo.ScanningTimes),callback:function ($$v) {_vm.$set(_vm.CodeScanningInfo, "ScanningTimes", $$v)},expression:"CodeScanningInfo.ScanningTimes"}})],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('ScanningMessage'),"prop":"ScanningMessage"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.CodeScanningInfo.ScanningMessage),callback:function ($$v) {_vm.$set(_vm.CodeScanningInfo, "ScanningMessage", $$v)},expression:"CodeScanningInfo.ScanningMessage"}})],1)],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aYxF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var userTypes = {
            0: "直销客户",
            1: "工业分销商",
            2: "建筑连接器分销商-零售渠道",
            3: "建筑连接器分销商-工程渠道",
            4: "筑连接器分销商-电商渠道",
            5: "工业代理商",
            6: "系统集成商",
            7: "WAGO用户",
            8: "建筑直销渠道",
            9: "建筑连接器分销商-家装渠道",
            10: "工业贸易商"
};

/* harmony default export */ __webpack_exports__["a"] = (userTypes);

/*
            //工业分销商
            Type1 = 1,
            //建筑连接器分销商-零售渠道
            Type2 = 2,
            //建筑连接器分销商-工程渠道
            Type3 = 3,
            //建筑连接器分销商-电商渠道
            Type4 = 4,
            //工业代理商
            Type5 = 5,
            //建筑直销渠道
            Type8 = 8,
            //系统集成商
            Type6 = 6,
            //WAGO用户
            Type7 = 7,
            //建筑连接器分销商-家装渠道
            Type9 = 9,
            //工业贸易商
            Type10 =10

*/

/***/ }),

/***/ "as2O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("returnScan.title"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.backToRecord}},[_vm._v(_vm._s(_vm.$t("returnScan.returnRecord"))+"\n        "),_c('i',{staticClass:"fa fa-list-ul"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"type":"primary","size":"mini","disabled":!_vm.hasScanned},on:{"click":function($event){_vm.confirmDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("returnScan.commitReturn"))+"\n        "),_c('i',{staticClass:"fa fa-hand-pointer-o"})]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning","plain":true,"size":"mini","disabled":!_vm.hasScanned},on:{"click":_vm.resetScanInfo}},[_vm._v(_vm._s(_vm.$t("reset"))+"\n        "),_c('i',{staticClass:"fa fa-eraser"})])],1)]),_vm._v(" "),_c('div',{staticClass:"data-list"},[_c('div',{staticClass:"scan-input"},[_c('el-form',{staticClass:"search-form",attrs:{"status-icon":""}},[_c('el-form-item',[_c('el-input',{ref:"qrCodeInput",attrs:{"autofocus":true,"placeholder":_vm.$t('returnScan.scanQrc1'),"disabled":_vm.loadingInput,"suffix-icon":_vm.loadingIcon},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.commitQRCode($event)}},model:{value:(_vm.scanCode),callback:function ($$v) {_vm.scanCode=$$v},expression:"scanCode"}},[_c('span',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("\n              "+_vm._s(_vm.$t('returnScan.qrcode'))+"\n            ")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"scan-info"},[_c('div',{staticClass:"current-info"},[_vm._v("\n        "+_vm._s(this.$t('returnScan.currentInfo',{count:this.scanEntries.length}))+"\n      ")]),_vm._v(" "),_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.scanEntries,"size":"mini"}},[_c('el-table-column',{attrs:{"align":"center","resizable":true,"label":this.$t('operation'),"width":"60"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.deleteScanInfo(scope.row.Code)}}},[_vm._v(_vm._s(_vm.$t('delete')))])]}}])}),_vm._v(" "),_vm._l((_vm.tableCols),function(col){return _c('el-table-column',{key:col.prop,attrs:{"align":"center","prop":col.prop,"resizable":true,"label":_vm.$t(col.label),"show-overflow-tooltip":true,"width":col.width}})})],2)],1),_vm._v(" "),_c('el-dialog',{staticClass:"tip-dialog",attrs:{"width":"30%","visible":_vm.confirmDialogVisible,"center":""},on:{"update:visible":function($event){_vm.confirmDialogVisible=$event}}},[_c('div',{staticClass:"tip-info"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"el-icon-warning"}),_vm._v("\n          "+_vm._s(_vm.$t("tip"))+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"msg"},[_vm._v("\n          "+_vm._s(_vm.$t("returnScan.commitConfirmMsg"))+"\n        ")])]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":3,"placeholder":_vm.$t('returnScan.returnRemarkTip')},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}}),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.confirmDialogVisible = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":!_vm.hasScanned,"loading":_vm.processReturn,"plain":true,"size":"mini"},on:{"click":_vm.commitReturn}},[_vm._v(_vm._s(_vm.$t('confirm')))])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bBLy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scanFlag__ = __webpack_require__("iLg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scanInfoService__ = __webpack_require__("qh01");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_qrcodeService__ = __webpack_require__("B7TC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__("OxnK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operators__ = __webpack_require__("T5hQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messageService__ = __webpack_require__("Qu2g");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ScanInfo",
  data: function data() {
    return {
      submitDialogVisible: false,
      loading: true,
      filter: {},
      filterOptions: [],
      scanEntries: [],
      scanSubmitEntries: [],
      currentBoxNumber: "",
      loadingInput: false,
      processCommit: false,
      scanOnly: {
        boxNumber: "",
        eanCode: "",
        qrCode: ""
      },
      scanInfo: {
        boxNumber: "",
        eanCode: "",
        qrCode: ""
      },
      eanCodeInfos: [],
      scanFlag: __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].BOXNUMBER,
      focusItemRef: "boxNumberInput"
    };
  },

  methods: {
    sendMessage: function sendMessage() {
      __WEBPACK_IMPORTED_MODULE_8__messageService__["a" /* messageService */].sendMessage('Message from Home Page Component to App Component!');
    },
    clearMessages: function clearMessages() {
      __WEBPACK_IMPORTED_MODULE_8__messageService__["a" /* messageService */].clearMessages();
    },
    commitBoxNumber: function commitBoxNumber() {
      var _this = this;

      if (this.currentBoxNumber) {
        if (this.currentBoxNumber.length == 8) {
          this.currentBoxNumber = "00000000" + this.currentBoxNumber + new Date().getFullYear();
        }
        //if (this.currentBoxNumber.length !== 20) {
        //this.$alert(this.$t("boxScan.boxNumberFormatterError"), "错误", {
        //type: "error",
        //callback: action => {
        // this.currentBoxNumber = "";
        //},

        //});
        //return;
        //}
        this.loadingInput = true;
        this.$axios.get("api/qrc/existboxnumber/" + this.currentBoxNumber).then(function (resp) {
          if (resp.data) {
            _this.$alert(_this.$t("boxScan.boxNumberScanned", {
              boxNumber: _this.currentBoxNumber
            }), "错误", {
              type: "error",
              callback: function callback(action) {
                _this.currentBoxNumber = "";
              }
            });
          } else {
            _this.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].EANCODE;
            _this.focusItemRef = "eanCodeInput";
          }
          _this.loadingInput = false;
        }).catch(function (e) {
          _this.loadingInput = false;
        });
      }
    },
    commitEanCode: function commitEanCode() {
      var _this2 = this;

      var code = this.scanOnly.eanCode;
      if (!code) return;

      console.log("commitEanCode", this.scanOnly.eanCode);
      if (code.includes('https:') || code.includes('http:') || code.includes('?') || code.includes('.') || code.includes('=')) {
        this.$alert("EAN\u7801\u4E0D\u5408\u6CD5\uFF1A" + code, "错误", {
          type: "error",
          callback: function callback(action) {
            _this2.scanOnly.eanCode = "";
          }
        });

        return;
      }

      var codeInfo = this.eanCodeInfos.find(function (c) {
        return c.EANCode === code;
      });
      if (codeInfo) {
        this.scanOnly.eanCodeInfo = codeInfo;
        this.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].QRCODE;
        this.focusItemRef = "qrCodeInput";
        return;
      }

      //this.eanCodeInfos.push(resp.data);
      //this.scanInfo.eanCodeInfo = resp.data;
      this.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].QRCODE;
      this.focusItemRef = "qrCodeInput";

      //console.log("ean:", this.scanOnly, this.eanCodeInfos, this.focusItemRef)

      /*
      this.loadingInput = true;
      this.$axios
        .get(`api/eancodes/bycode/${code}`)
        .then(resp => {
          console.log("Res", resp);
          if (resp.data) {
            console.log("commitEanCode-backData");
            this.eanCodeInfos.push(resp.data);
            this.scanInfo.eanCodeInfo = resp.data;
            this.scanFlag = scanFlag.QRCODE;
            this.focusItemRef = "qrCodeInput";
          } else {
            console.log("commitEanCode-ErrorData");
            this.$alert(`${this.$t("boxScan.eanCheckFail")}：${code}`, "错误", {
              type: "error",
              callback: action => {
                this.scanInfo.eanCode = "";
              }
            });
          }
          this.loadingInput = false;
        })
        .catch(e => {
          this.$alert(this.$t("boxScan.eanCheckFail"), "提示", {
            type: "error"
          });
          this.loadingInput = false;
        });
      */
    },
    commitQRCode: function commitQRCode() {
      var _this3 = this;

      //console.log("commitQRCodeBefore:" + this.scanOnly.qrCode);
      var codeUrl = this.scanOnly.qrCode;
      if (codeUrl.includes('https:') || codeUrl.includes('http:')) {
        if (!codeUrl.includes('?code')) {
          this.$alert("\u4E8C\u7EF4\u7801\u4E0D\u5408\u6CD5\uFF1A" + codeUrl, "错误", {
            type: "error",
            callback: function callback(action) {
              _this3.scanOnly.qrCode = "";
            }
          });

          return;
        } else {
          this.scanOnly.qrCode = this.scanOnly.qrCode.substring(this.scanOnly.qrCode.indexOf('=') + 1);
        }
      } else if (codeUrl.includes('.')) {
        this.$alert("\u4E8C\u7EF4\u7801\u4E0D\u5408\u6CD5\uFF1A" + codeUrl, "错误", {
          type: "error",
          callback: function callback(action) {
            _this3.scanOnly.qrCode = "";
          }
        });

        return;
      }

      //let code = qrcodeService.getQRCode(codeUrl);
      //console.log("commitQRCodeAfter: " + code);
      //console.log("commitQRCodeInfo", this.scanOnly);
      //this.scanOnly.qrCode = code;
      //if (!code) return;

      if (this.scanEntries.find(function (s) {
        return s.qrCode === _this3.scanOnly.qrCode;
      })) {
        this.loadingInput = true;
        this.$alert(this.$t("boxScan.duplicateQRCode") + "\uFF1A" + this.scanOnly.qrCode, "错误", {
          type: "error",
          callback: function callback(action) {
            _this3.scanOnly.qrCode = "";
            _this3.loadingInput = false;
          }
        });

        return;
      }

      this.scanOnly.boxNumber = this.currentBoxNumber;

      __WEBPACK_IMPORTED_MODULE_8__messageService__["a" /* messageService */].sendMessage(this.scanOnly); //todo
      this.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].EANCODE;
      this.focusItemRef = "eanCodeInput";
      //this.scanOnly.boxNumber = this.currentBoxNumber;
      //this.scanEntries.splice(0, 0, this.scanOnly);
      this.scanOnly = {};
      //scanInfoService.write(this.scanEntries);

      return;

      //todo 验证 调用folkjoin接口,验证通过，加入列表，不通过提示，
      //EAN QRcode结束时subject.next()
      Object(__WEBPACK_IMPORTED_MODULE_6_rxjs__["b" /* forkJoin */])(this.$axios.get("api/eancodes/bycode/" + this.scanInfo.eanCode), this.$axios.get("api/qrc/" + this.scanInfo.qrCode)).subscribe(function (result) {
        console.log("EAN-QR:", result);
        //debugger;
        if (result[0].data) {
          _this3.eanCodeInfos.push(result[0].data);
          _this3.scanInfo.eanCodeInfo = result[0].data;
          //this.scanFlag = scanFlag.QRCODE;
          //this.focusItemRef = "qrCodeInput";
        } else {
          console.log("commitEanCode-ErrorData");
          _this3.$alert(_this3.$t("boxScan.eanCheckFail") + "\uFF1A" + _this3.scanInfo.eanCode, "错误", {
            type: "error",
            callback: function callback(action) {
              _this3.scanInfo.eanCode = "";
              _this3.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].EANCODE;
              _this3.focusItemRef = "eanCodeInput";
              _this3.scanInfo.qrCode = "";
              console.log("commitQRCodeInfo", _this3.scanInfo);
            }
          });

          return;
        }

        if (result[1].data) {
          if (result[1].data.Status < 2) {
            _this3.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].EANCODE;
            _this3.focusItemRef = "eanCodeInput";
            _this3.scanInfo.boxNumber = _this3.currentBoxNumber;
            _this3.scanEntries.splice(0, 0, _this3.scanInfo);
            _this3.scanInfo = {};
            __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].write(_this3.scanEntries);
          } else {
            console.log("commitQRCode-errorData");

            _this3.$alert(_this3.$t("boxScan.qrcodeShippedError") + "\uFF1A" + code, "错误", {
              type: "error",
              callback: function callback(action) {
                _this3.scanInfo.qrCode = "";
              }
            });
          }
        } else {
          _this3.$alert(_this3.$t("boxScan.qrcodeCheckFail") + "\uFF1A" + _this3.scanInfo.qrCode, "错误", {
            type: "error",
            callback: function callback(action) {
              _this3.scanInfo.qrCode = "";
            }
          });
        }
        _this3.loadingInput = false;
      }, function (error) {
        debugger;
        console.error('EAN QRCode检查失败');
        _this3.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].EANCODE;
        _this3.focusItemRef = "eanCodeInput";
        _this3.scanInfo.qrCode = "";
        _this3.scanInfo.eanCode = "";
        _this3.$alert('EAN QRCode检查失败', "提示", {
          type: "error"
        });
      });

      /*
      this.loadingInput = true;
      this.$axios
        .get(`api/qrc/${code}`)
        .then(resp => {
          console.log("Res", resp);
          if (resp.data) {
            console.log("commitQRCode-backData" + resp.data.Status );
          
            if (resp.data.Status < 2) {
              this.scanFlag = scanFlag.EANCODE;
              this.focusItemRef = "eanCodeInput";
              this.scanInfo.boxNumber = this.currentBoxNumber;
              this.scanEntries.splice(0, 0, this.scanInfo);
              this.scanInfo = {};
              scanInfoService.write(this.scanEntries);
            } else {
              console.log("commitQRCode-errorData");
           
              this.$alert(
                `${this.$t("boxScan.qrcodeShippedError")}：${code}`,
                "错误",
                {
                  type: "error",
                  callback: action => {
                    this.scanInfo.qrCode = "";
                  }
                 }
              );
            }
          } else {
              this.$alert(
              `${this.$t("boxScan.qrcodeCheckFail")}：${code}`,
              "错误",
              {
                type: "error",
                callback: action => {
                  this.scanInfo.qrCode = "";
                }
              }
            );
          }
          this.loadingInput = false;
        })
        .catch(e => {});
      */
    },
    searchEanQRCode: function searchEanQRCode(info) {
      var _this4 = this;

      console.log("查询", info.boxNumber, info.eanCode, info.qrCode);
      //return;

      Object(__WEBPACK_IMPORTED_MODULE_6_rxjs__["b" /* forkJoin */])(this.$axios.get("api/eancodes/bycode/" + info.eanCode), this.$axios.get("api/qrc/" + info.qrCode)).pipe(Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_operators__["b" /* timeout */])(2500),
      // 处理超时发出的错误
      Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_operators__["a" /* catchError */])(function (error) {
        console.error('forkJoin timed out!');
        // 你可以在这里处理超时后的逻辑，比如通知用户或者重试等
        //return 'timeout'; // 返回一个值来结束Observable
      })).subscribe(function (result) {
        console.log("EAN-QR:", info.eanCode, info.qrCode, result);
        //debugger;
        var resultScan = { boxNumber: "", eanCode: "", qrCode: "" };

        if (result[0].data) {
          _this4.eanCodeInfos.push(result[0].data);
          _this4.scanInfo.eanCodeInfo = result[0].data;
          _this4.scanInfo.eanCode = info.eanCode;
          //this.scanFlag = scanFlag.QRCODE;
          //this.focusItemRef = "qrCodeInput";
        } else {
          console.log("commitEanCode-ErrorData333");
          _this4.loadingInput = true;
          _this4.$alert(_this4.$t("boxScan.eanCheckFail") + "\uFF1A" + info.eanCode, "错误", {
            type: "error",
            callback: function callback(action) {
              _this4.scanInfo.eanCode = "";
              _this4.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].EANCODE;
              _this4.focusItemRef = "eanCodeInput";
              _this4.scanInfo.qrCode = "";
              _this4.loadingInput = false;
              console.log("commitQRCodeInfo", _this4.scanInfo);
            }
          });

          return;
        }

        if (result[1].data) {
          if (result[1].data.Status < 2) {
            //this.scanFlag = scanFlag.EANCODE;
            //this.focusItemRef = "eanCodeInput";
            _this4.scanInfo.qrCode = info.qrCode;
            _this4.scanInfo.boxNumber = _this4.currentBoxNumber;
            _this4.scanEntries.splice(0, 0, _this4.scanInfo);
            _this4.scanInfo = {};
            __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].write(_this4.scanEntries);
          } else {
            console.log("commitQRCode-errorData");
            _this4.loadingInput = true;
            _this4.$alert(_this4.$t("boxScan.qrcodeShippedError") + "\uFF1A" + info.qrCode, "错误", {
              type: "error",
              callback: function callback(action) {
                _this4.scanInfo.qrCode = "";
              }
            });
          }
        } else {
          _this4.loadingInput = true;
          _this4.$alert(_this4.$t("boxScan.qrcodeCheckFail") + "\uFF1A" + info.qrCode, "错误", {
            type: "error",
            callback: function callback(action) {
              _this4.scanInfo.qrCode = "";
            }
          });
        }
        _this4.loadingInput = false;
      }, function (error) {
        //debugger;
        console.error('EAN QRCode检查失败', info.qrCode);
        _this4.loadingInput = true;
        _this4.$alert('EAN QRCode检查失败 ' + info.qrCode, "提示", {
          type: "error"
        });

        _this4.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].EANCODE;
        _this4.focusItemRef = "eanCodeInput";
        _this4.scanInfo.qrCode = "";
        _this4.scanInfo.eanCode = "";
        _this4.loadingInput = false;
      });
    },
    commitScanInfo: function commitScanInfo() {
      console.log("commitScanInfo");
      this.scanSubmitEntries = __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].groupBy(this.scanEntries);
      this.submitDialogVisible = true;
    },
    commit: function commit() {
      var _this5 = this;

      console.log("commit");
      this.processCommit = true;
      this.$axios.post("api/delivery/boxScan", this.scanEntries).then(function (resp) {
        _this5.$message({
          showClose: true,
          message: _this5.$t("boxScan.commitScanInfoSuccess"),
          type: "success"
        });
        _this5.submitDialogVisible = false;
        _this5.processCommit = false;
        _this5.scanEntries = [];
        _this5.resetBoxNumber();
        __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].clear();
      }).catch(function (e) {
        var msg = e.response && e.response.data || _this5.$t("boxScan.commitScanInfoError");
        _this5.$message({
          showClose: true,
          message: msg,
          type: "error"
        });
        _this5.processCommit = false;
      });
    },
    resetBoxNumber: function resetBoxNumber() {
      this.currentBoxNumber = "";
      this.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].BOXNUMBER;
      this.focusItemRef = "boxNumberInput";
    },
    clearScanInfo: function clearScanInfo() {
      var _this6 = this;

      this.$confirm(this.$t("boxScan.clearConfirm"), this.$t("tip"), {
        type: "warning"
      }).then(function () {
        _this6.scanEntries = [];
        _this6.scanInfo = {};
        _this6.resetBoxNumber();
        __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].clear();
        _this6.$message({
          type: "success",
          message: _this6.$t("boxScan.clearSuccess")
        });
      }).catch(function () {});
    },
    initializeScanInfo: function initializeScanInfo() {
      var info = __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].read();
      if (info.length) {
        this.scanFlag = __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].EANCODE;
        this.focusItemRef = "eanCodeInput";
        this.currentBoxNumber = info[0].boxNumber;
        this.scanEntries = info;
      }
    },
    getSummaries: function getSummaries(param) {
      var _this7 = this;

      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = _this7.$t("total");
          return;
        }
        if (index === 2 || index === 3) {
          var values = data.map(function (item) {
            return Number(item[column.property]);
          });
          if (!values.every(function (value) {
            return isNaN(value);
          })) {
            sums[index] = values.reduce(function (prev, curr) {
              var value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }
        }
      });
      return sums;
    },
    scanInputBlur: function scanInputBlur() {
      //   this.$refs[this.focusItemRef].focus();
    },
    clearEanScanInfo: function clearEanScanInfo(ean) {
      var _this8 = this;

      this.$confirm(this.$t("boxScan.clearEanConfirm", { code: ean }), this.$t("tip"), {
        type: "warning"
      }).then(function () {
        _this8.scanEntries = _this8.scanEntries.filter(function (e) {
          return e.eanCode !== ean;
        });
        __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].clear();
        __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].write(_this8.scanEntries);
        _this8.scanSubmitEntries = __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].groupBy(_this8.scanEntries);
        _this8.$message({
          type: "success",
          message: _this8.$t("boxScan.clearSuccess")
        });
        _this8.submitDialogVisible = false;
      }).catch(function () {});
    },
    backToScanRecord: function backToScanRecord() {
      this.$router.push({ name: "BoxScan" });
    },
    exportScanInfos: function exportScanInfos() {
      var info = __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].read();
      console.log("exportScanInfos");
      console.log(info);
      if (info.length) {
        var boxNumber = info[0].boxNumber;
        var blob = new Blob([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info)], {
          type: "application/json"
        });
        __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(blob, boxNumber + ".json");
      }
    },
    importScanInfos: function importScanInfos(file) {
      var _this9 = this;

      this.$confirm(this.$t("boxScan.confirmImportScanInfos"), this.$t("tip"), {
        type: "warning"
      }).then(function () {
        var reader = new FileReader();
        var onload = function (event) {
          var result = event.target.result;
          try {
            var infos = JSON.parse(result);
            console.log("importScanInfos");
            console.log(infos);
            if (infos instanceof Array && infos.length) {
              var item = infos[0];
              if (item.boxNumber && item.eanCode && item.qrCode && item.eanCodeInfo && item.eanCodeInfo.EANCode) {
                __WEBPACK_IMPORTED_MODULE_2__scanInfoService__["a" /* default */].write(infos);
                this.initializeScanInfo();
              } else {
                this.$alert(this.$t("boxScan.importScanInfosInvalid"), "错误", {
                  type: "error"
                });
              }
            }
          } catch (error) {
            this.$alert(this.$t("boxScan.importScanInfosInvalid"), "错误", {
              type: "error"
            });
          }
        }.bind(_this9);
        reader.onload = onload;
        reader.readAsText(file);
      }).catch(function () {});
      return false;
    }
  },
  computed: {
    canScanBoxNumber: function canScanBoxNumber() {
      return this.scanFlag === __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].BOXNUMBER;
    },
    canScanEanCode: function canScanEanCode() {
      return this.scanFlag === __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].EANCODE;
    },
    canScanQRCode: function canScanQRCode() {
      return this.scanFlag === __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].QRCODE;
    },
    prependTitle: function prependTitle() {
      switch (this.scanFlag) {
        case __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].BOXNUMBER:
          return "箱号";
        case __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].EANCODE:
          return "EAN码";
        case __WEBPACK_IMPORTED_MODULE_1__scanFlag__["a" /* default */].QRCODE:
          return "二维码1";
        default:
          return "箱号";
      }
    },
    loadingIcon: function loadingIcon() {
      return this.loadingInput ? "el-icon-loading" : "";
    },
    hasScanned: function hasScanned() {
      console.log("hasScanned" + !this.scanEntries.length);
      return this.scanEntries.length;
    }
  },
  created: function created() {
    var _this10 = this;

    this.initializeScanInfo();

    this.subscription = __WEBPACK_IMPORTED_MODULE_8__messageService__["a" /* messageService */].getMessage().subscribe(function (message) {
      console.log("getMess", message.text.boxNumber, message.text.eanCode, message.text.qrCode);
      _this10.searchEanQRCode(message.text);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  },
  updated: function updated() {
    this.$refs[this.focusItemRef].focus();
  }
});

/***/ }),

/***/ "bKlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_qrcodeService__ = __webpack_require__("B7TC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_codeStatus__ = __webpack_require__("uPQs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service__ = __webpack_require__("qya9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ReturnScan",
  data: function data() {
    return {
      scanEntries: [],
      loadingInput: false,
      confirmDialogVisible: false,
      processReturn: false,
      remark: "",
      scanCode: "",
      tableCols: [{
        prop: "Code",
        label: "returnScan.qrcode"
      }, {
        prop: "BoxNumber",
        label: "returnScan.boxNumber"
      }, {
        prop: "CustomerNumber",
        label: "returnScan.customerNum"
      }, {
        prop: "CustomerName",
        label: "returnScan.customerName"
      }, {
        prop: "OrderNumber",
        label: "returnScan.orderNum"
      }, {
        prop: "EanCode",
        label: "returnScan.eanCode"
      }, {
        prop: "ProductLongCode",
        label: "returnScan.pLongCode"
      }, {
        prop: "ProductShortCode",
        label: "returnScan.pShortCode"
      }, {
        prop: "DeliveryTime",
        label: "returnScan.deliveryTime"
      }]
    };
  },

  methods: {
    commitQRCode: function commitQRCode() {
      var _this = this;

      var code = __WEBPACK_IMPORTED_MODULE_0__services_qrcodeService__["a" /* default */].getQRCode(this.scanCode);
      this.scanCode = code;
      if (!code) return;
      //是否已扫描
      if (this.scanEntries.some(function (e) {
        return e.Code === code;
      })) {
        this.$alert(this.$t("returnScan.codeScanned"), "错误", {
          type: "error",
          callback: function callback(action) {
            _this.scanCode = "";
          }
        });
        return;
      }

      this.loadingInput = true;
      this.$axios.get("api/product/return/" + code).then(function (resp) {
        if (resp.data) {
          _this.scanEntries.splice(0, 0, resp.data);
          __WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].write(_this.scanEntries);
        }
        _this.scanCode = "";
        _this.loadingInput = false;
      }).catch(function (e) {
        var msg = e.response && e.response.data || _this.$t("returnScan.codeStatusError");
        _this.$alert(msg, "错误", {
          type: "error",
          callback: function callback(action) {
            _this.scanCode = "";
          }
        });
        _this.loadingInput = false;
      });
    },
    commitReturn: function commitReturn() {
      var _this2 = this;

      var params = {
        remark: this.remark,
        codes: this.scanEntries.map(function (e) {
          return e.Code;
        })
      };
      this.processReturn = true;
      this.$axios.post("api/product/return", params).then(function (resp) {
        _this2.clearInfo();
        _this2.$message({
          type: "success",
          message: _this2.$t("returnScan.returnSuccess")
        });
        _this2.confirmDialogVisible = false;
        _this2.processReturn = false;
      }).catch(function (err) {
        _this2.$message({
          type: "error",
          message: _this2.$t("operationFailure")
        });
        _this2.processReturn = false;
      });
    },
    initializeScanInfo: function initializeScanInfo() {
      var info = __WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].read();
      this.scanEntries = info;
    },
    backToRecord: function backToRecord() {
      this.$router.push({ name: "ProductReturn" });
    },
    resetScanInfo: function resetScanInfo() {
      var _this3 = this;

      this.$confirm(this.$t("returnScan.clearConfirm"), this.$t("tip"), {
        type: "warning"
      }).then(function () {
        _this3.clearInfo();
        _this3.$message({
          type: "success",
          message: _this3.$t("returnScan.clearSuccess")
        });
      }).catch(function () {});
    },
    clearInfo: function clearInfo() {
      this.scanEntries = [];
      this.scanCode = "";
      __WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].clear();
    },
    deleteScanInfo: function deleteScanInfo(code) {
      var _this4 = this;

      this.$confirm(this.$t("returnScan.deleteConfirm"), this.$t("tip"), {
        type: "warning"
      }).then(function () {
        _this4.scanEntries = _this4.scanEntries.filter(function (e) {
          return e.Code !== code;
        });
        __WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].write(_this4.scanEntries);
        _this4.$message({
          type: "success",
          message: _this4.$t("deleteSuccess")
        });
      }).catch(function () {});
    }
  },
  computed: {
    loadingIcon: function loadingIcon() {
      return this.loadingInput ? "el-icon-loading" : "";
    },
    hasScanned: function hasScanned() {
      return this.scanEntries.length;
    }
  },
  created: function created() {
    this.initializeScanInfo();
  },
  updated: function updated() {
    if (!this.confirmDialogVisible) this.$refs["qrCodeInput"].focus();
  }
});

/***/ }),

/***/ "bh+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('Navbar',{attrs:{"main-title":"产品追溯平台","sub-title":"Product Traceable Platform"}})],1),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"sidebar"},[_c('Sidebar')],1),_vm._v(" "),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"appear":"","enter-active-class":"animated fadeIn"}},[_c('router-view')],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "birI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cbEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("report.title"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[(_vm.canExport)?_c('el-button',{staticClass:"sm-hidden",attrs:{"plain":true,"size":"mini","loading":_vm.exportLoading},on:{"click":_vm.exportReport}},[_vm._v(_vm._s(_vm.$t("export"))+"\n        "),_c('i',{staticClass:"fa fa-download"})]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n        "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("search"))+"\n        "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.reportInfos,"size":"mini"}},[_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"EANcode","align":"center","resizable":true,"label":this.$t('report.eanCode'),"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ProductSerials","align":"center","resizable":true,"label":this.$t('report.productSerials'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ProductLongCode","align":"center","resizable":true,"label":this.$t('report.productLongCode'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"AmountPerPackage","align":"center","resizable":true,"label":this.$t('report.amountPerPackage'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"QRCode1","align":"center","resizable":true,"label":this.$t('report.qrc1'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"QRCode2","align":"center","resizable":true,"label":this.$t('report.qrc2'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"OrderNumber","align":"center","resizable":true,"label":this.$t('report.orderNumber'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"BatchNumber","align":"center","resizable":true,"label":this.$t('report.batchNumber'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"UserType","align":"center","resizable":true,"label":this.$t('report.customerType'),"width":"160","formatter":_vm.customerTypeFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ChannelAccount","align":"center","resizable":true,"label":this.$t('report.customerNumber'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ChannelName","align":"center","resizable":true,"label":this.$t('report.customerName'),"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"SaleAreasString","align":"center","resizable":true,"label":this.$t('report.salesAreas'),"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"OrderProductCount","align":"center","resizable":true,"label":this.$t('report.orderCount'),"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"DeliveryTime","align":"center","resizable":true,"label":this.$t('report.deliveryTime'),"formatter":_vm.timeFormatter,"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"Office","align":"center","resizable":true,"label":this.$t('report.customerOffice'),"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"OrderProductCount","align":"center","resizable":true,"label":this.$t('report.deliveryCount'),"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ScanCount","align":"center","resizable":true,"label":this.$t('report.scanCount'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"align":"center","resizable":true,"label":this.$t('delivery.hasReceived'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.ReceivedTime)?_c('span',[_vm._v("已领取")]):_c('span',[_vm._v("未领取")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ReceivedTime","align":"center","resizable":true,"label":this.$t('report.receivedTime'),"formatter":_vm.receivedTimeFormatter,"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"Bonus","align":"center","resizable":true,"label":this.$t('report.bonus'),"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"align":"center","resizable":true,"label":this.$t('report.receiveAddress'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.fullAddress(scope.row.Address))+"\n        ")]}}])})],1),_vm._v(" "),_c('el-row',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pageIndex,"page-sizes":[15, 30, 50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('search'),"visible":_vm.searchDialogVisible,"width":"760px"},on:{"update:visible":function($event){_vm.searchDialogVisible=$event}}},[_c('el-form',{staticClass:"search-form",attrs:{"model":_vm.filter,"inline":true,"size":"small","label-width":"100px"}},[_c('el-form-item',{attrs:{"label":this.$t('report.eanCode'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.EANcode),callback:function ($$v) {_vm.$set(_vm.filter, "EANcode", $$v)},expression:"filter.EANcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('report.productSerials'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.ProductSerials),callback:function ($$v) {_vm.$set(_vm.filter, "ProductSerials", $$v)},expression:"filter.ProductSerials"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('report.productLongCode'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.ProductLongCode),callback:function ($$v) {_vm.$set(_vm.filter, "ProductLongCode", $$v)},expression:"filter.ProductLongCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('report.customerName'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.ChannelName),callback:function ($$v) {_vm.$set(_vm.filter, "ChannelName", $$v)},expression:"filter.ChannelName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('report.qrc1'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.QRCode1),callback:function ($$v) {_vm.$set(_vm.filter, "QRCode1", $$v)},expression:"filter.QRCode1"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('report.qrc2'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.QRCode2),callback:function ($$v) {_vm.$set(_vm.filter, "QRCode2", $$v)},expression:"filter.QRCode2"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('report.customerNumber'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.ChannelAccount),callback:function ($$v) {_vm.$set(_vm.filter, "ChannelAccount", $$v)},expression:"filter.ChannelAccount"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('report.orderNumber'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.OrderNumber),callback:function ($$v) {_vm.$set(_vm.filter, "OrderNumber", $$v)},expression:"filter.OrderNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.hasReceived'),"size":"small"}},[_c('el-radio',{attrs:{"label":"true"},model:{value:(_vm.filter.hasReceived),callback:function ($$v) {_vm.$set(_vm.filter, "hasReceived", $$v)},expression:"filter.hasReceived"}},[_vm._v("已领取")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"false"},model:{value:(_vm.filter.hasReceived),callback:function ($$v) {_vm.$set(_vm.filter, "hasReceived", $$v)},expression:"filter.hasReceived"}},[_vm._v("未领取")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"all"},model:{value:(_vm.filter.hasReceived),callback:function ($$v) {_vm.$set(_vm.filter, "hasReceived", $$v)},expression:"filter.hasReceived"}},[_vm._v("所有")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('report.deliveryTime'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.StartDeliveryTime),callback:function ($$v) {_vm.$set(_vm.filter, "StartDeliveryTime", $$v)},expression:"filter.StartDeliveryTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('to'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.EndDeliveryTime),callback:function ($$v) {_vm.$set(_vm.filter, "EndDeliveryTime", $$v)},expression:"filter.EndDeliveryTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('report.receivedTime'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.StartReceivedScanTime),callback:function ($$v) {_vm.$set(_vm.filter, "StartReceivedScanTime", $$v)},expression:"filter.StartReceivedScanTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('to'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.EndReceivedScanTime),callback:function ($$v) {_vm.$set(_vm.filter, "EndReceivedScanTime", $$v)},expression:"filter.EndReceivedScanTime"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(this.$t('reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":_vm.search}},[_vm._v(_vm._s(this.$t('confirm')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d7WJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUser_vue__ = __webpack_require__("WsFC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407a00c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__ = __webpack_require__("O+8E");
function injectStyle (ssrContext) {
  __webpack_require__("5Exv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-407a00c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407a00c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d82f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__ = __webpack_require__("zKtV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31577b30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__ = __webpack_require__("xvOK");
function injectStyle (ssrContext) {
  __webpack_require__("VATJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31577b30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31577b30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dnrf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_OperationHeader__ = __webpack_require__("Es0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_FileImporter__ = __webpack_require__("Dpj6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_roleTypes__ = __webpack_require__("B0E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_searchHistoryService__ = __webpack_require__("jb9L");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EANCode",
  components: { OperationHeader: __WEBPACK_IMPORTED_MODULE_3__components_shared_OperationHeader__["a" /* default */], FileImporter: __WEBPACK_IMPORTED_MODULE_5__components_shared_FileImporter__["a" /* default */] },
  data: function data() {
    return {
      loading: true,
      filter: {
        EANCode: "",
        ProductLongCode: "",
        ProductShortCode: "",
        AmountPerPackage: "",
        ProductSerials: "",
        SuggestedRetailPrice: ""
      },
      rules: {
        EANCode: [{
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > format.length) {
              callback(new Error("EAN码只能为阿拉伯数字"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        ProductLongCode: [{
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9-]/g, "");
            if (raw.length > format.length) {
              callback(new Error("只能包含数字或‘-’"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        ProductShortCode: [{
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > format.length) {
              callback(new Error("短号只能为阿拉伯数字"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],

        AmountPerPackage: [{
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            var format = raw.replace(/[^0-9]/g, "");
            if (raw.length > format.length) {
              callback(new Error("请输入一个整数"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      },
      searchDialogLabelWidth: "120px",
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      searchDialogVisible: false,
      EANData: [],
      filterOptions: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(["roles", "permissions"]), {
    canEdit: function canEdit() {
      return this.roles.includes(__WEBPACK_IMPORTED_MODULE_7__models_roleTypes__["a" /* default */].Administrator) || this.permissions.find(function (p) {
        return p.toLowerCase() === "ean.edit" || p.toLowerCase() === "ean.insert";
      });
    }
  }),
  created: function created() {
    this.initializeFilter();
    this.obtainTableDataAccordingToConditions();
  },

  methods: {
    priceFormatter: function priceFormatter(row, column) {

      return Number(row.SuggestedRetailPrice).toFixed(2);
    },
    addEAN: function addEAN() {
      this.$router.push("addEAN");
    },
    handleEdit: function handleEdit(index, row) {
      this.$router.push({ name: "EditEAN", params: { EANId: row.Id } });
    },
    handleDelete: function handleDelete(index, row) {
      var _this = this;

      this.$confirm("同时删除对应返现信息，确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this.deleteData(row.Id);
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.obtainTableDataAccordingToConditions();
      } else {
        this.pageIndex = 1;
      }
    },
    handlekeyup: function handlekeyup(event) {
      var father = event.currentTarget;
      var input = father.getElementsByTagName("input")[0];
      input.value = input.value.replace(/[^0-9]/g, "");
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.obtainTableDataAccordingToConditions();
    },
    resetFilter: function resetFilter() {
      this.filter = {
        EANCode: "",
        ProductLongCode: "",
        ProductShortCode: "",
        AmountPerPackage: "",
        ProductSerials: "",
        SuggestedRetailPrice: ""
      };
      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_9__services_searchHistoryService__["a" /* default */].removeHistory(__WEBPACK_IMPORTED_MODULE_8__models_searchTypes__["a" /* default */].EAN_HISTORY);
    },
    obtainTableDataAccordingToConditions: function obtainTableDataAccordingToConditions() {
      var _this2 = this;

      this.loading = true;
      this.$axios.get("api/eancodes/getean", {
        params: {
          filter: this.filtergenerator(),
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
      }).then(function (response) {
        _this2.EANData = response.data.Data;
        _this2.loading = false;
        _this2.totalCount = response.data.TotalCount;
      });
    },
    deleteData: function deleteData(rowId) {
      var _this3 = this;

      this.$axios.get("api/eancodes/deleteEANCode", {
        params: {
          Id: rowId
        }
      }).then(function (response) {
        _this3.$message({
          type: "success",

          message: "删除成功"
        });
        _this3.obtainTableDataAccordingToConditions();
      });
    },
    refresh: function refresh() {
      this.pageIndex = 1;
      this.resetFilter();
      this.obtainTableDataAccordingToConditions();
    },
    initializeFilter: function initializeFilter() {
      var _this4 = this;

      var his = __WEBPACK_IMPORTED_MODULE_9__services_searchHistoryService__["a" /* default */].getHistory(__WEBPACK_IMPORTED_MODULE_8__models_searchTypes__["a" /* default */].EAN_HISTORY);
      if (his) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filter);
        his.forEach(function (h) {
          if (keys.includes(h.name)) {
            _this4.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    setFilterOptions: function setFilterOptions() {
      var _this5 = this;

      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
        var val = _this5.filter[k];
        if (typeof val === "number" || val) {
          _this5.filterOptions.push({ name: k, value: val });
        }
      });
    },
    search: function search(searchEANCode) {
      var _this6 = this;

      this.$refs[searchEANCode].validate(function (valid) {
        if (valid) {
          _this6.searchDialogVisible = false;

          _this6.pageIndex = 1;
          _this6.setFilterOptions();
          __WEBPACK_IMPORTED_MODULE_9__services_searchHistoryService__["a" /* default */].setHistory(__WEBPACK_IMPORTED_MODULE_8__models_searchTypes__["a" /* default */].EAN_HISTORY, _this6.filterOptions);
          _this6.obtainTableDataAccordingToConditions();
        } else {
          _this6.$message({
            message: _this6.$t("operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },
    filtergenerator: function filtergenerator() {
      var filterOptions = [];
      if (this.filter.EANCode !== null && this.filter.EANCode.trim() !== "") {
        var filterOption = {
          name: "EANCode",
          value: this.filter.EANCode
        };

        filterOptions.push(filterOption);
      }
      if (this.filter.ProductSerials !== null && this.filter.ProductSerials !== "") {
        var filterOption = {
          name: "ProductSerials",
          value: this.filter.ProductSerials
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.ProductLongCode !== null && this.filter.ProductLongCode.trim() !== "") {
        var filterOption = {
          name: "ProductLongCode",
          value: this.filter.ProductLongCode
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.ProductShortCode !== null && this.filter.ProductShortCode.trim() !== "") {
        var filterOption = {
          name: "ProductShortCode",
          value: this.filter.ProductShortCode
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.AmountPerPackage !== null && this.filter.AmountPerPackage.trim() !== "") {
        var filterOption = {
          name: "AmountPerPackage",
          value: this.filter.AmountPerPackage
        };
        filterOptions.push(filterOption);
      }

      if (this.filter.SuggestedRetailPrice !== null && this.filter.SuggestedRetailPrice.trim() !== "") {
        var filterOption = {
          name: "SuggestedRetailPrice",
          value: this.filter.SuggestedRetailPrice
        };
        filterOptions.push(filterOption);
      }

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filterOptions);
    }
  }
});

/***/ }),

/***/ "dsoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Application_vue__ = __webpack_require__("91so");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19a3c0e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Application_vue__ = __webpack_require__("bh+a");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Application_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19a3c0e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Application_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e9G+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoxScan_vue__ = __webpack_require__("imyc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_670fd206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoxScan_vue__ = __webpack_require__("s9gB");
function injectStyle (ssrContext) {
  __webpack_require__("31Q/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoxScan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_670fd206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoxScan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eBDn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FileImporter",
  props: ['apiurl'],
  data: function data() {
    return {
      centerDialogVisible: false

    };
  },

  methods: {
    handleClose: function handleClose(done) {
      this.diposed();
      done();
    },
    upload: function upload() {

      var fileelements = document.getElementsByName('file');

      for (var i = 0; i < fileelements.length; i++) {
        var links = document.getElementsByClassName('el-upload-list__item-name');
        if (fileelements[i].files.length < 1 || links.length == 0) {
          this.$message({
            message: "请选择上传文件！",
            type: "error",
            showClose: true,
            center: true
          });
          return;
        }
        var formData = new FormData();
        var file = fileelements[i].files[0];

        var isexcel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(file.name).split(".xls").length > 1;
        if (!isexcel) {
          this.$message({
            message: "只支持xls/xlsx格式类型的文件",
            type: "error",
            showClose: true,
            center: true
          });
          return;
        }
        formData.append("Files", file);

        this.$axios.post(this.apiurl, formData);
        this.diposed();
      }
    },
    removelink: function removelink() {
      document.getElementsByName('file')[0].value = "";
      var links = document.getElementsByClassName('el-upload-list__item-name');
      for (var i = 0; i < links.length; i++) {
        links[i].style.display = "none";
      }
    },
    diposed: function diposed() {
      document.getElementsByName('file')[0].value = "";
      var links = document.getElementsByClassName('el-upload-list__item-name');
      for (var i = 0; i < links.length; i++) {
        links[i].style.display = "none";
      }
      this.centerDialogVisible = false;
    }
  }
});

/***/ }),

/***/ "eIH0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_401_vue__ = __webpack_require__("6/7Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3c5be9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_401_vue__ = __webpack_require__("MEIj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_401_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3c5be9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_401_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g6E3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar detail clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n        "+_vm._s(_vm.$t("user.resetPassword"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":function($event){_vm.resetPassword('resetPasswordForm')}}},[_vm._v(_vm._s(_vm.$t("save"))+"\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.cancelOperation()}}},[_vm._v(_vm._s(_vm.$t("cancel"))+"\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"data-list detail"},[_c('div',{staticClass:"detail-header"},[_c('span',[_vm._v(_vm._s(_vm.$t("user.resetPassword")))]),_vm._v(" "),_c('div',{staticClass:"detail-triangle"})]),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_c('el-form',{ref:"resetPasswordForm",staticClass:"detail-form",attrs:{"size":"small","model":_vm.newPassword,"label-width":"80px","rules":_vm.rules,"status-icon":""}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.email'),"prop":"email"}},[_c('el-input',{attrs:{"type":"text","auto-complete":"off","disabled":""},model:{value:(_vm.userInfo.Email),callback:function ($$v) {_vm.$set(_vm.userInfo, "Email", $$v)},expression:"userInfo.Email"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.name'),"prop":"name"}},[_c('el-input',{attrs:{"type":"text","auto-complete":"off","disabled":""},model:{value:(_vm.userInfo.Name),callback:function ($$v) {_vm.$set(_vm.userInfo, "Name", $$v)},expression:"userInfo.Name"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.password'),"prop":"password"}},[_c('div',{on:{"keyup":function($event){_vm.handlekeyup($event)}}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off"},model:{value:(_vm.newPassword.password),callback:function ($$v) {_vm.$set(_vm.newPassword, "password", $$v)},expression:"newPassword.password"}})],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.confirmPassword'),"prop":"confirmPassword"}},[_c('div',{attrs:{"id":"confirmpwd"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off"},model:{value:(_vm.newPassword.confirmPassword),callback:function ($$v) {_vm.$set(_vm.newPassword, "confirmPassword", $$v)},expression:"newPassword.confirmPassword"}})],1)])],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hYsk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hm/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanInfo_vue__ = __webpack_require__("bBLy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_136843d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanInfo_vue__ = __webpack_require__("lzaT");
function injectStyle (ssrContext) {
  __webpack_require__("4D5u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_136843d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iLg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SCAN_FLAG = {
    BOXNUMBER: 0,
    EANCODE: 1,
    QRCODE: 2
};

/* harmony default export */ __webpack_exports__["a"] = (SCAN_FLAG);

/***/ }),

/***/ "imyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_roleTypes__ = __webpack_require__("B0E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__ = __webpack_require__("jb9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BoxScan",
  data: function data() {
    return {
      searchDialogVisible: false,
      scanInfos: [],
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
      loading: false,
      filter: {
        completeIWAC: "all"
      },
      filterOptions: []
    };
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getScanInfos();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.getScanInfos();
    },
    getScanInfos: function getScanInfos() {
      var _this = this;

      this.loading = true;
      var params = {
        filter: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios.get("api/delivery/boxscan", { params: params }).then(function (res) {
        _this.totalCount = res.data.TotalCount;
        _this.scanInfos = res.data.Data;
        _this.loading = false;
      }).catch(function (e) {
        _this.loading = false;
      });
    },
    search: function search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].setHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].SCANBOX_HISTORY, this.filterOptions);
      this.getScanInfos();
    },
    resetFilter: function resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].removeHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].SCANBOX_HISTORY);
    },
    setFilterOptions: function setFilterOptions() {
      var _this2 = this;

      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
        var val = _this2.filter[k];
        if (typeof val === "number" || val) {
          _this2.filterOptions.push({ name: k, value: val });
        }
      });
    },
    refresh: function refresh() {
      this.resetFilter();
      this.getScanInfos();
    },
    initializeFilter: function initializeFilter() {
      var _this3 = this;

      var his = __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].getHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].SCANBOX_HISTORY);
      if (his) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter);
        his.forEach(function (h) {
          if (keys.includes(h.name)) {
            _this3.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    beginScan: function beginScan() {
      this.$router.push({ name: "ScanInfo" });
    },
    deleteScanInfo: function deleteScanInfo(boxNumber) {
      var _this4 = this;

      this.$confirm(this.$t("boxScan.deleteScanInfoConfirm", { boxNumber: boxNumber }), this.$t("tip"), {
        type: "warning"
      }).then(function (resp) {
        _this4.$axios.delete("api/delivery/boxscan/boxnumber/" + boxNumber).then(function (resp) {
          _this4.$message({
            type: "success",
            message: _this4.$t("deleteSuccess")
          });
          _this4.getScanInfos();
        }).catch(function (e) {
          var msg = e.response && e.response.data || _this4.$t("deleteFail");
          _this4.$message({
            type: "error",
            message: msg
          });
        });
      }).catch(function () {});
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(["roles", "permissions"]), {
    canDelete: function canDelete() {
      return this.permissions.find(function (p) {
        return p.toLowerCase() === "boxscan.delete";
      });
    },
    canScan: function canScan() {
      return this.roles.includes(__WEBPACK_IMPORTED_MODULE_3__models_roleTypes__["a" /* default */].Administrator) || this.permissions.find(function (p) {
        return p.toLowerCase() === "boxscan.insert";
      });
    }
  }),
  created: function created() {
    this.initializeFilter();
    this.getScanInfos();
  }
});

/***/ }),

/***/ "iyrP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TYPES = {
    USER_HISTORY: "USER_HISTORY",
    QRC_HISTORY: "QRC_HISTORY",
    QRCHISTORY_HISTORY: "QRCHISTORY_HISTORY",
    DELIVERY_HISTORY: "DELIVERY_HISTORY",
    REPORT_HISTORY: "REPORT_HISTORY",
    SCANBOX_HISTORY: "SCANBOX_HISTORY",
    EAN_HISTORY: "EAN_HISTORY",
    CASHBACK_HISTORY: "CASHBACK_HISTORY",
    CUSTOERMER_HISTORY: "CUSTOERMER_HISTORY",
    CODESCANNING_HISTORY: "CODESCANNING_HISTORY",
    PRODUCTRETURN_HISTORY: "PRODUCTRETURN_HISTORY"
};

/* harmony default export */ __webpack_exports__["a"] = (TYPES);

/***/ }),

/***/ "jb9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Infrustructure_localStorageService__ = __webpack_require__("SXfi");





var searchHistoryService = {
    setHistory: function setHistory(name, val) {
        __WEBPACK_IMPORTED_MODULE_3__Infrustructure_localStorageService__["a" /* default */].setItem(name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(val));
    },

    getHistory: function getHistory(name) {
        var val = __WEBPACK_IMPORTED_MODULE_3__Infrustructure_localStorageService__["a" /* default */].getItem(name);
        if (val) {
            return JSON.parse(val);
        }
    },

    removeAll: function removeAll() {
        var vals = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_2__models_searchTypes__["a" /* default */]);
        vals.forEach(function (element) {
            __WEBPACK_IMPORTED_MODULE_3__Infrustructure_localStorageService__["a" /* default */].removeItem(element);
        });
    },
    removeBesides: function removeBesides(name) {
        var vals = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_2__models_searchTypes__["a" /* default */]);
        vals.forEach(function (element) {
            if (name !== element) __WEBPACK_IMPORTED_MODULE_3__Infrustructure_localStorageService__["a" /* default */].removeItem(element);
        });
    },
    removeHistory: function removeHistory(name) {
        __WEBPACK_IMPORTED_MODULE_3__Infrustructure_localStorageService__["a" /* default */].removeItem(name);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (searchHistoryService);

/***/ }),

/***/ "jrIq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lX8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ATips_vue__ = __webpack_require__("zyzi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cbf7a05_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ATips_vue__ = __webpack_require__("W9Vh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ATips_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cbf7a05_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ATips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lzaT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("boxScan.scanIn"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[_c('el-tooltip',{attrs:{"effect":"dark","content":"导出当前的扫描信息，可用于下次导入","placement":"top"}},[_c('div',{staticClass:"inline-button-wrapper"},[_c('el-button',{attrs:{"plain":true,"size":"mini","disabled":!_vm.hasScanned},on:{"click":_vm.exportScanInfos}},[_vm._v(_vm._s(_vm.$t("boxScan.exportScanInfos"))+"\n            "),_c('i',{staticClass:"fa fa-download"})])],1)]),_vm._v(" "),_c('el-upload',{staticClass:"inline-button-wrapper",attrs:{"action":"","accept":".json","before-upload":_vm.importScanInfos,"limit":1,"show-file-list":false}},[_c('el-tooltip',{attrs:{"effect":"dark","content":"导入扫描信息","placement":"top"}},[_c('el-button',{attrs:{"plain":true,"size":"mini"}},[_vm._v(_vm._s(_vm.$t("boxScan.importScanInfos"))+"\n            "),_c('i',{staticClass:"fa fa-upload"})])],1)],1),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.backToScanRecord}},[_vm._v(_vm._s(_vm.$t("boxScan.viewScanRecord"))+"\n        "),_c('i',{staticClass:"fa fa-list-ul"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"type":"primary","size":"mini","disabled":!_vm.hasScanned},on:{"click":_vm.commitScanInfo}},[_vm._v(_vm._s(_vm.$t("boxScan.commitScanInfo"))+"\n        "),_c('i',{staticClass:"fa fa-hand-pointer-o"})]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning","plain":true,"size":"mini","disabled":!_vm.hasScanned},on:{"click":_vm.clearScanInfo}},[_vm._v(_vm._s(_vm.$t("reset"))+"\n        "),_c('i',{staticClass:"fa fa-eraser"})])],1)]),_vm._v(" "),_c('div',{staticClass:"data-list"},[_c('div',{staticClass:"scan-input"},[_c('el-form',{staticClass:"search-form",attrs:{"status-icon":""}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.canScanBoxNumber),expression:"canScanBoxNumber"}]},[_c('el-input',{ref:"boxNumberInput",attrs:{"placeholder":_vm.$t('boxScan.scanBoxNumber'),"disabled":_vm.loadingInput,"suffix-icon":_vm.loadingIcon},on:{"blur":_vm.scanInputBlur},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.commitBoxNumber($event)}},model:{value:(_vm.currentBoxNumber),callback:function ($$v) {_vm.currentBoxNumber=$$v},expression:"currentBoxNumber"}},[_c('span',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("\n              "+_vm._s(_vm.prependTitle)+"\n            ")])])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.canScanEanCode),expression:"canScanEanCode"}]},[_c('el-input',{ref:"eanCodeInput",attrs:{"placeholder":_vm.$t('boxScan.scanEanCode'),"disabled":_vm.loadingInput,"suffix-icon":_vm.loadingIcon},on:{"blur":_vm.scanInputBlur},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.commitEanCode($event)}},model:{value:(_vm.scanOnly.eanCode),callback:function ($$v) {_vm.$set(_vm.scanOnly, "eanCode", $$v)},expression:"scanOnly.eanCode"}},[_c('span',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("\n              "+_vm._s(_vm.prependTitle)+"\n            ")])])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.canScanQRCode),expression:"canScanQRCode"}]},[_c('el-input',{ref:"qrCodeInput",attrs:{"placeholder":_vm.$t('boxScan.scanQRCode'),"disabled":_vm.loadingInput,"suffix-icon":_vm.loadingIcon},on:{"blur":_vm.scanInputBlur},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.commitQRCode($event)}},model:{value:(_vm.scanOnly.qrCode),callback:function ($$v) {_vm.$set(_vm.scanOnly, "qrCode", $$v)},expression:"scanOnly.qrCode"}},[_c('span',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("\n              "+_vm._s(_vm.prependTitle)+"\n            ")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"scan-info"},[_c('div',{staticClass:"boxNumber"},[_vm._v("\n        "+_vm._s(this.$t('boxScan.currentBoxNumber'))+" "+_vm._s(this.currentBoxNumber)+"    \n        "+_vm._s(this.$t('boxScan.currentNumber'))+" "+_vm._s(this.scanEntries.length)+"\n      ")]),_vm._v(" "),_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.scanEntries,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"eanCode","align":"center","resizable":true,"label":this.$t('boxScan.eanCode')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"eanCodeInfo.ProductLongCode","align":"center","resizable":true,"label":this.$t('boxScan.productLongCode')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qrCode","align":"center","resizable":true,"label":this.$t('boxScan.qrCode')}})],1)],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('boxScan.submitDialogTitle'),"visible":_vm.submitDialogVisible,"width":"40%"},on:{"update:visible":function($event){_vm.submitDialogVisible=$event}}},[_c('el-table',{attrs:{"size":"mini","stripe":true,"data":_vm.scanSubmitEntries,"show-summary":true,"summary-method":_vm.getSummaries}},[_c('el-table-column',{attrs:{"property":"boxNumber","align":"center","label":this.$t('boxScan.boxNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"productLongCode","align":"center","label":this.$t('boxScan.productLongCode')}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"count","align":"center","label":this.$t('boxScan.productBoxCount')}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"productCount","align":"center","label":this.$t('boxScan.productCount')}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":this.$t('operation')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.$t('boxScan.clearEanScanInfo'),"placement":"top"}},[_c('el-button',{staticClass:"delete-btn",attrs:{"type":"text"},on:{"click":function($event){_vm.clearEanScanInfo(scope.row.eanCode)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.submitDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.processCommit,"plain":true,"size":"mini"},on:{"click":_vm.commit}},[_vm._v(_vm._s(this.$t('submit')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ma4i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    Generated: 0,
    Manufactured: 1,
    Delivered: 2,
    Received: 3
});

/***/ }),

/***/ "mqru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AddUser",
  data: function data() {
    var _this = this;

    var confirmPassword = function confirmPassword(rule, value, callback) {
      if (value !== _this.userInfo.password) {
        callback(new Error(_this.$t("user.confirmPasswordSameValidation")));
      } else {
        callback();
      }
    };

    return {
      userInfo: {
        email: "",
        name: "",
        username: "",
        phoneNumber: "",
        confirmPassword: "",
        userRoles: []
      },
      rolesList: [],
      rules: {
        name: [{
          required: true,
          message: this.$t("user.nameValidation")
        }],
        email: [{
          required: true,
          message: this.$t("user.emailValidation")
        }, {
          type: "email",
          message: this.$t("user.emailFormatValidation"),
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: this.$t("user.passwordValidation")
        }, {
          min: 6,
          message: this.$t("user.pvalid.minLen", { len: 6 }),
          trigger: "blur"
        }, {
          pattern: new RegExp(/[A-Z]/),
          message: this.$t("user.pvalid.oneUppercase"),
          trigger: "blur"
        }, {
          pattern: new RegExp(/[a-z]/),
          message: this.$t("user.pvalid.oneLowercase"),
          trigger: "blur"
        }, {
          pattern: new RegExp(/[0-9]/),
          message: this.$t("user.pvalid.oneDigit"),
          trigger: "blur"
        }, {
          pattern: new RegExp(/[^a-zA-Z0-9]/),
          message: this.$t("user.pvalid.oneNonLetterOrDigit"),
          trigger: "blur"
        }],
        confirmPassword: [{
          required: true,
          message: this.$t("user.confirmPasswordRequiredValidation")
        }, { validator: confirmPassword }],
        userRoles: [{ required: true, message: this.$t("user.userRolesValidation") }],

        phoneNumber: [{
          validator: function validator(rule, value, callback) {
            var raw = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value).replace(/\"/g, "");
            if (raw == "" || raw == null || raw == undefined) {
              callback();
            }
            var format = raw.replace(/[^0-9+]/g, "");

            if (raw.length != 14 && raw.length != 11 || raw.length == 14 && raw.charAt(0) != "+" || raw.substring(1, raw.length).includes("+") || raw.length > format.length) {
              callback(new Error("请输入正确的手机号码"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    var _this2 = this;

    this.$axios.get("api/Roles").then(function (response) {
      _this2.rolesList = response.data;
    });
  },

  methods: {
    handlekeyup: function handlekeyup(event) {
      var father = event.currentTarget;
      var confirm = document.getElementById("confirmpwd").getElementsByTagName("input")[0];
      var obj = father.getElementsByTagName("input")[0];
      if (obj.value === this.userInfo.confirmPassword) {
        confirm.focus();
        obj.focus();
      }
    },
    goBack: function goBack() {
      this.$router.push({ name: "UserManagement" });
    },
    addUser: function addUser(addUserForm) {
      var _this3 = this;

      this.$refs[addUserForm].validate(function (valid) {
        if (valid) {
          _this3.$axios.post("api/Users", _this3.userInfo).then(function (response) {
            _this3.$message({
              message: _this3.$t("user.userAddedSuccessfully"),
              type: "success",
              showClose: true,
              duration: 2000
            });
            _this3.goBack();
          }).catch(function (e) {
            var msg = _this3.$t("user.operationFailure");
            if (e.response) {
              var errorMsg = e.response.data.ExceptionMessage || e.response.data;
              if (errorMsg === "DuplicateUser") {
                msg = _this3.$t("user.DuplicateUser");
              } else if (e.response.data.ModelState) {
                msg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(e.response.data.modelState).join();
              }
            }
            _this3.$message({
              message: msg,
              type: "error"
            });
          });
        }
      });
    },
    cancelOperation: function cancelOperation() {
      this.goBack();
    }
  }
});

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p3ZE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CodeScanningInformation_vue__ = __webpack_require__("553w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fee3f174_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodeScanningInformation_vue__ = __webpack_require__("0Uae");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CodeScanningInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fee3f174_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodeScanningInformation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "peMH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_OperationHeader__ = __webpack_require__("Es0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_roleTypes__ = __webpack_require__("B0E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CashbackAmountValidation__ = __webpack_require__("F/SY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_searchHistoryService__ = __webpack_require__("jb9L");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Cashback",
  components: { OperationHeader: __WEBPACK_IMPORTED_MODULE_3__components_shared_OperationHeader__["a" /* default */] },
  data: function data() {
    return {
      switchValue: "",
      loading: true,
      filter: {
        EANCode: "",
        ProductLongCode: "",
        userType: [],
        CashbackInformation: "",
        CashbackAmount: ""
      },
      CashbackInfo: {
        Id: "",
        EANCode: "",
        CashbackAmount: "",
        ProductLongCode: "",
        CashbackInformation: "",
        UserType: ""
      },
      userTypeList: [],
      searchDialogLabelWidth: "30%",
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      maxCashbackAmount: __WEBPACK_IMPORTED_MODULE_8__CashbackAmountValidation__["a" /* default */].maxCasbackAmount,
      minCashbackAmount: __WEBPACK_IMPORTED_MODULE_8__CashbackAmountValidation__["a" /* default */].minCasbackAmount,
      searchDialogVisible: false,
      CashbackData: [],
      filterOptions: [],
      inputColumn1: "",
      isEditing: false
    };
  },
  created: function created() {
    this.initializeFilter();
    this.obtainTableDataAccordingToConditions();
    this.checkinput();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(["roles", "permissions"]), {
    canEdit: function canEdit() {
      return this.roles.includes(__WEBPACK_IMPORTED_MODULE_6__models_roleTypes__["a" /* default */].Administrator) || this.permissions.find(function (p) {
        return p.toLowerCase() === "cashback.edit" || p.toLowerCase() === "cashback.insert";
      });
    }
  }),
  methods: {
    handlePageEdit: function handlePageEdit(row) {
      if (!this.isEditing) {
        this.inputColumn1 = row.CashbackAmount.split("￥")[0];
        row.editFlag = true;
        this.isEditing = true;
      }
    },
    handlecancel: function handlecancel(row) {
      row.editFlag = false;
      this.isEditing = false;
      this.refresh();
    },
    checkinput: function checkinput() {
      setInterval("if(document.getElementById('editinput'))document.getElementById('editinput').focus();", 500);
    },
    openCell: function openCell(row, column, cell, event) {
      if (!this.isEditing) {
        this.inputColumn1 = row.CashbackAmount.split("￥")[0];
        row.editFlag = true;
        this.isEditing = true;
      }
    },

    UserTypeFormatter: function UserTypeFormatter(row, column) {
      var type = row.userType;
      return this.$t("UserType" + type);
    },
    handleSave: function handleSave(row) {
      var _this = this;

      this.isEditing = false;
      this.CashbackInfo = row;
      this.CashbackInfo.CashbackAmount = this.inputColumn1;

      if (this.CashbackInfo.CashbackAmount == null || this.CashbackInfo.CashbackAmount == "") {
        this.obtainTableDataAccordingToConditions();
        return;
      }
      if (this.CashbackInfo.CashbackAmount > this.maxCashbackAmount) {
        this.CashbackInfo.CashbackAmount = this.maxCashbackAmount;
      }
      if (this.CashbackInfo.CashbackAmount > 0 && this.CashbackInfo.CashbackAmount < this.minCashbackAmount) {
        this.CashbackInfo.CashbackAmount = this.minCashbackAmount;
      }

      this.CashbackInfo.CashbackAmount = parseFloat(this.CashbackInfo.CashbackAmount).toFixed(2);
      this.$axios.post("api/cashback/edit", this.CashbackInfo).then(function (response) {
        _this.$message({
          message: _this.$t("CashbackEditSuccessfully"),
          type: "success",
          showClose: true,
          duration: 2000
        });
        _this.obtainTableDataAccordingToConditions();
      });
      row.editFlag = false;
      this.inputColumn1 = "";
    },
    handleMouseEnter: function handleMouseEnter(row, column, cell, event) {
      cell.children[0].children[1].style.color = "black";
    },
    handleMouseOut: function handleMouseOut(row, column, cell, event) {
      cell.children[0].children[1].style.color = "#ffffff";
    },

    handleEdit: function handleEdit(index, row) {
      this.$router.push({ name: "EditCashback", params: { Id: row.Id } });
    },
    handleActivation: function handleActivation(index, row) {
      var _this2 = this;

      var tip = row.IsActive ? "禁用红包领取" : "启用红包领取";
      this.$confirm("\u786E\u5B9A" + tip + "\u5417\uFF1F", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.$axios({
          method: "post",
          url: "api/cashback/changeActivationStatus",
          data: { id: row.Id }
        }).then(function (response) {
          _this2.$message({
            message: tip + "\u6210\u529F",
            type: "success",
            showClose: true,
            duration: 2000
          });
          _this2.obtainTableDataAccordingToConditions();
        });
      });
    },
    inavtivationAll: function inavtivationAll() {
      var _this3 = this;

      this.$confirm("确定禁用所有红包领取吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var params = {
          filter: _this3.filtergenerator()
        };
        _this3.$axios.post("api/cashback/inavtivateAll", {}, { params: params }).then(function (response) {
          _this3.$message({
            message: "禁用所有红包领取成功",
            type: "success",
            showClose: true,
            duration: 2000
          });
          _this3.obtainTableDataAccordingToConditions();
        });
      });
    },
    avtivationAll: function avtivationAll() {
      var _this4 = this;

      this.$confirm("确定启用所有红包领取吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var params = {
          filter: _this4.filtergenerator()
        };
        _this4.$axios.post("api/cashback/activateAll", {}, { params: params }).then(function (response) {
          _this4.$message({
            message: "启用所有红包领取成功",
            type: "success",
            showClose: true,
            duration: 2000
          });
          _this4.obtainTableDataAccordingToConditions();
        });
      });
    },
    handleDelete: function handleDelete(index, row) {
      var _this5 = this;

      this.$confirm("确定要删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this5.deleteData(row.Id);
      });
    },
    resetFilter: function resetFilter() {
      this.filter = {
        EANCode: "",
        ProductLongCode: "",
        userType: [],
        CashbackInformation: "",
        CashbackAmount: ""
      };

      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_9__services_searchHistoryService__["a" /* default */].removeHistory(__WEBPACK_IMPORTED_MODULE_7__models_searchTypes__["a" /* default */].CASHBACK_HISTORY);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.obtainTableDataAccordingToConditions();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.obtainTableDataAccordingToConditions();
    },
    handlekeyup: function handlekeyup(event) {
      var father = event.currentTarget;
      var obj = father.getElementsByTagName("input")[0];

      obj.value = obj.value.replace(/[^\d.]/g, "");
      obj.value = obj.value.replace(/\.{2,}/g, ".");
      obj.value = obj.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      if (obj.value.indexOf(".") < 0 && obj.value != "") {
        obj.value = parseFloat(obj.value);
      }
      if (obj.value > this.maxCashbackAmount) {
        obj.value = this.maxCashbackAmount;
      }

      if (parseFloat(obj.value) > 0 && parseFloat(obj.value) < this.minCashbackAmount) {
        obj.value = this.minCashbackAmount;
      }
    },
    obtainTableDataAccordingToConditions: function obtainTableDataAccordingToConditions() {
      var _this6 = this;

      this.loading = true;
      this.$axios.get("api/cashback/getcashback", {
        params: {
          filter: this.filtergenerator(),
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
      }).then(function (response) {
        _this6.translateData(response.data.Data);

        _this6.loading = false;
        _this6.totalCount = response.data.TotalCount;
      });
    },
    deleteData: function deleteData(rowId) {
      var _this7 = this;

      this.$axios.get("api/cashback/deletecashback", {
        params: {
          Id: rowId
        }
      }).then(function (response) {
        _this7.$message({
          type: "success",
          message: "删除成功"
        });
        _this7.refresh();
      });
    },
    refresh: function refresh() {
      this.isEditing = false;
      this.pageIndex = 1;
      this.inputColumn1 = "";
      this.resetFilter();
      this.obtainTableDataAccordingToConditions();
    },
    userTypeSetup: function userTypeSetup() {
      this.searchDialogVisible = true;

      if (this.userTypeList == "") {
        for (var i = 2; i <= 4; i++) {
          this.userTypeList.push(i);
        }
        this.userTypeList.push(8);
        this.userTypeList.push(9);
      }
    },
    translateData: function translateData(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].CashbackAmount = data[i].CashbackAmount + "￥";
        data[i].editFlag = false;
      }
      this.CashbackData = data;
    },
    initializeFilter: function initializeFilter() {
      var _this8 = this;

      var his = __WEBPACK_IMPORTED_MODULE_9__services_searchHistoryService__["a" /* default */].getHistory(__WEBPACK_IMPORTED_MODULE_7__models_searchTypes__["a" /* default */].CASHBACK_HISTORY);
      if (his) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter);
        his.forEach(function (h) {
          if (keys.includes(h.name)) {
            _this8.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    setFilterOptions: function setFilterOptions() {
      var _this9 = this;

      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
        var val = _this9.filter[k];
        if (typeof val === "number" || val) {
          _this9.filterOptions.push({ name: k, value: val });
        }
      });
    },
    search: function search() {
      this.searchDialogVisible = false;

      this.pageIndex = 1;
      this.setFilterOptions();
      __WEBPACK_IMPORTED_MODULE_9__services_searchHistoryService__["a" /* default */].setHistory(__WEBPACK_IMPORTED_MODULE_7__models_searchTypes__["a" /* default */].CASHBACK_HISTORY, this.filterOptions);
      this.obtainTableDataAccordingToConditions();
    },
    filtergenerator: function filtergenerator() {
      var filterOptions = [];
      if (this.filter.EANCode !== null && this.filter.EANCode.trim() !== "") {
        var filterOption = {
          name: "EANCode",
          value: this.filter.EANCode
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.ProductLongCode !== null && this.filter.ProductLongCode.trim() !== "") {
        var filterOption = {
          name: "ProductLongCode",
          value: this.filter.ProductLongCode
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.CashbackAmount !== null && this.filter.CashbackAmount.trim() !== "") {
        var filterOption = {
          name: "CashbackAmount",
          value: this.filter.CashbackAmount
        };
        filterOptions.push(filterOption);
      }
      if (this.filter.CashbackInformation !== null && this.filter.CashbackInformation.trim() !== "") {
        var filterOption = {
          name: "CashbackInformation",
          value: this.filter.CashbackInformation
        };

        filterOptions.push(filterOption);
      }
      if (this.filter.userType.length > 0) {
        var selectedTypes = "";
        var count = 0;

        for (var i = 0; i < this.filter.userType.length; i++) {
          selectedTypes += this.filter.userType[i];
          if (count !== this.filter.userType.length - 1) {
            selectedTypes += "%";
          }
          count++;
        }

        var filterOption = {
          name: "UserType",
          value: selectedTypes
        };

        filterOptions.push(filterOption);
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filterOptions);
    }
  }
});

/***/ }),

/***/ "q7AJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar detail clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n        "+_vm._s(_vm.$t("addEAN"))+"\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":function($event){_vm.addEAN('addEANCodeForm')}}},[_vm._v(_vm._s(_vm.$t("save"))+"\n          \n        ")]),_vm._v(" "),_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":_vm.cancelOperation}},[_vm._v(_vm._s(_vm.$t("cancel"))+"\n          \n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"data-list detail"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_c('el-form',{ref:"addEANCodeForm",staticClass:"detail-form",attrs:{"size":"small","model":_vm.EANCodeInfo,"label-width":"120px","rules":_vm.rules,"status-icon":""}},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('EANCode'),"prop":"EANCode"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.EANCode),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "EANCode", $$v)},expression:"EANCodeInfo.EANCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('AmountPerPackage'),"prop":"AmountPerPackage"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.AmountPerPackage),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "AmountPerPackage", $$v)},expression:"EANCodeInfo.AmountPerPackage"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('ProductLongCode'),"prop":"ProductLongCode"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.ProductLongCode),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "ProductLongCode", $$v)},expression:"EANCodeInfo.ProductLongCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('ProductShortCode'),"prop":"ProductShortCode"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.ProductShortCode),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "ProductShortCode", $$v)},expression:"EANCodeInfo.ProductShortCode"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('ProductSerials'),"prop":"ProductSerials"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.ProductSerials),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "ProductSerials", $$v)},expression:"EANCodeInfo.ProductSerials"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('SuggestedRetailPrice'),"prop":"SuggestedRetailPrice"}},[_c('el-input',{model:{value:(_vm.EANCodeInfo.SuggestedRetailPrice),callback:function ($$v) {_vm.$set(_vm.EANCodeInfo, "SuggestedRetailPrice", $$v)},expression:"EANCodeInfo.SuggestedRetailPrice"}})],1)],1)],1)],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-header"},[_c('span',[_vm._v("EAN码信息")]),_vm._v(" "),_c('div',{staticClass:"detail-triangle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q829":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEAN_vue__ = __webpack_require__("Xh3x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc80b31e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEAN_vue__ = __webpack_require__("q7AJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEAN_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc80b31e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEAN_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qDWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__("5jHf");
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "not-found",
  components: { error: __WEBPACK_IMPORTED_MODULE_0__error__["a" /* default */] }
});

/***/ }),

/***/ "qh01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Infrustructure_localStorageService__ = __webpack_require__("SXfi");



var service = {
    read: function read() {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_1__Infrustructure_localStorageService__["a" /* default */].getItem("scanInfo")) || [];
    },
    write: function write(info) {
        __WEBPACK_IMPORTED_MODULE_1__Infrustructure_localStorageService__["a" /* default */].setItem("scanInfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
    },
    clear: function clear() {
        __WEBPACK_IMPORTED_MODULE_1__Infrustructure_localStorageService__["a" /* default */].removeItem("scanInfo");
    },
    groupBy: function groupBy(arr) {
        var boxGroups = [];
        arr.forEach(function (val, index) {
            var boxNumber = val.boxNumber;
            var eancode = val.eanCode;
            var productLongCode = val.eanCodeInfo.ProductLongCode;
            var group = boxGroups.find(function (g) {
                return g.boxNumber === boxNumber && g.eanCode === eancode;
            });
            if (group) {
                group.count++;
            } else {
                boxGroups.push({
                    boxNumber: boxNumber,
                    eanCode: eancode,
                    productLongCode: productLongCode,
                    count: 1,
                    perPackCount: Number(val.eanCodeInfo.AmountPerPackage),
                    get productCount() {
                        return this.count * this.perPackCount;
                    }
                });
            }
        });
        return boxGroups;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (service);

/*
groupBy return model
[
    {
        boxNumber:111,
        eanCode:222,
        productLongCode:'123123123
        count:2,
        perPackCount:2,
    },
    {
        boxNumber:111,
        eanCode:222,
        productLongCode:'123123123
        count:2,
        perPackCount:2,
    },
]
*/

/***/ }),

/***/ "qya9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Infrustructure_localStorageService__ = __webpack_require__("SXfi");




var service = {
    read: function read() {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_1__Infrustructure_localStorageService__["a" /* default */].getItem("returnInfo")) || [];
    },
    write: function write(info) {
        __WEBPACK_IMPORTED_MODULE_1__Infrustructure_localStorageService__["a" /* default */].setItem("returnInfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
    },
    clear: function clear() {
        __WEBPACK_IMPORTED_MODULE_1__Infrustructure_localStorageService__["a" /* default */].removeItem("returnInfo");
    }
};

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "rTkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__status__ = __webpack_require__("ma4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__changeStatus__ = __webpack_require__("8ZTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_roleTypes__ = __webpack_require__("B0E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_searchHistoryService__ = __webpack_require__("jb9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "QRCCode",
  data: function data() {
    var _this = this;

    var checkBatchNumber = function checkBatchNumber(r, v, callback) {
      if (v) {
        _this.$axios.get("api/qrc/existBatchNumber/" + v).then(function (resp) {
          if (resp.data) {
            callback();
          } else {
            callback(new Error(_this.$t("qrc.batchNumberNotExist")));
          }
        });
      }
    };

    return {
      changeStatusList: __WEBPACK_IMPORTED_MODULE_4__changeStatus__["a" /* default */],
      statusList: __WEBPACK_IMPORTED_MODULE_3__status__["a" /* default */],
      searchDialogVisible: false,
      generateDialogVisible: false,
      statusDialogVisible: false,
      pageSize: 15,
      pageIndex: 1,
      codes: [],
      totalCount: 0,
      loading: true,
      generating: false,
      generateCount: 1000,
      genCountList: [1000, 10000, 50000, 100000],
      filter: {
        QRCode1: "",
        QRCode2: "",
        Status: null,
        StartGenTime: null,
        EndGenTime: null,
        BatchNumber: ""
      },
      filterOptions: [],
      setStatusInfo: {
        status: 1,
        batchNumber: "",
        rules: {
          batchNumber: [{
            required: true,
            message: this.$t("qrc.batchNumberNotEmpty"),
            trigger: "blur"
          }, { validator: checkBatchNumber, trigger: "blur" }],
          status: [{ required: true, message: this.$t("qrc.plsSelectStatus") }]
        }
      }
    };
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getCodes();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.getCodes();
    },
    getCodes: function getCodes() {
      var _this2 = this;

      this.loading = true;
      var params = {
        filter: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios.get("api/qrc", { params: params }).then(function (res) {
        _this2.totalCount = res.data.TotalCount;
        _this2.codes = res.data.Data;
        _this2.loading = false;
      }).catch(function (e) {
        _this2.loading = false;
      });
    },
    search: function search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      __WEBPACK_IMPORTED_MODULE_7__services_searchHistoryService__["a" /* default */].setHistory(__WEBPACK_IMPORTED_MODULE_6__models_searchTypes__["a" /* default */].QRC_HISTORY, this.filterOptions);
      this.getCodes();
    },
    resetFilter: function resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_7__services_searchHistoryService__["a" /* default */].removeHistory(__WEBPACK_IMPORTED_MODULE_6__models_searchTypes__["a" /* default */].QRC_HISTORY);
    },
    setFilterOptions: function setFilterOptions() {
      var _this3 = this;

      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
        var val = _this3.filter[k];
        if (typeof val === "number" || val) {
          _this3.filterOptions.push({ name: k, value: val });
        }
      });
    },
    refresh: function refresh() {
      this.resetFilter();
      this.getCodes();
    },
    statusFormatter: function statusFormatter(cellValue) {
      var _this4 = this;

      var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.statusList).filter(function (k) {
        return _this4.statusList[k] === cellValue;
      });
      return this.$t("qrc.statusEnum." + key);
    },
    initializeFilter: function initializeFilter() {
      var _this5 = this;

      var his = __WEBPACK_IMPORTED_MODULE_7__services_searchHistoryService__["a" /* default */].getHistory(__WEBPACK_IMPORTED_MODULE_6__models_searchTypes__["a" /* default */].QRC_HISTORY);
      if (his) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter);
        his.forEach(function (h) {
          if (keys.includes(h.name)) {
            _this5.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    generateCode: function generateCode() {
      var _this6 = this;

      this.generating = true;
      this.$axios.get("api/qrc/generate/" + this.generateCount).then(function (res) {
        var fileName = decodeURIComponent(res.headers["file-name"] || "二维码.csv");
        var BOM = "\uFEFF";
        var blob = new Blob([BOM + res.data]);
        __WEBPACK_IMPORTED_MODULE_8_file_saver___default.a.saveAs(blob, fileName);
        _this6.getCodes();
        _this6.generating = false;
        _this6.generateDialogVisible = false;
      }).catch(function (e) {
        _this6.generating = false;
        _this6.getCodes();
      });
    },
    setCodeStatus: function setCodeStatus() {
      var _this7 = this;

      this.$refs["statusForm"].validate(function (valid) {
        if (valid) {
          _this7.$axios.put("api/qrc/setstatus", {
            batchNumber: _this7.setStatusInfo.batchNumber,
            status: _this7.setStatusInfo.status
          }).then(function (resp) {
            _this7.$message({
              type: "success",
              message: _this7.$t("qrc.setStatusSuccess")
            });
            _this7.statusDialogVisible = false;
            _this7.getCodes();
          }).catch(function (e) {
            var msg = e.response && e.response.data || _this7.$t("qrc.setStatusFail");
            _this7.$message({
              type: "error",
              message: msg
            });
          });
        } else {
          return false;
        }
      });
    },
    QRCHistory: function QRCHistory() {
      this.$router.push({ name: "QRCHistory" });
    },
    tagType: function tagType(status) {
      switch (status) {
        case 0:
          return "";
        case 1:
          return "success";
        case 2:
          return "warning";
        case 3:
          return "info";
        default:
          return "";
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])(["roles", "permissions"]), {
    canEdit: function canEdit() {
      return this.roles.includes(__WEBPACK_IMPORTED_MODULE_5__models_roleTypes__["a" /* default */].Administrator) || this.permissions.find(function (p) {
        return p.toLowerCase() === "qrc.edit" || p.toLowerCase() === "qrc.insert";
      });
    }
  }),
  created: function created() {
    this.initializeFilter();
    __WEBPACK_IMPORTED_MODULE_7__services_searchHistoryService__["a" /* default */].removeBesides(__WEBPACK_IMPORTED_MODULE_6__models_searchTypes__["a" /* default */].QRC_HISTORY);
    this.getCodes();
  }
});

/***/ }),

/***/ "rqsq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CashbackAmountValidation__ = __webpack_require__("F/SY");

 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EditCashback",
  data: function data() {
    var _this = this;

    return {
      maxCashbackAmount: __WEBPACK_IMPORTED_MODULE_0__CashbackAmountValidation__["a" /* default */].maxCasbackAmount,
      minCashbackAmount: __WEBPACK_IMPORTED_MODULE_0__CashbackAmountValidation__["a" /* default */].minCasbackAmount,
      CashbackInfo: {
        Id: '',
        EANCode: '',
        CashbackAmount: '',
        ProductLongCode: '',
        CashbackInformation: '',
        UserType: ''
      },
      rules: {
        CashbackInformation: [{ required: true, message: this.$t("CashbackInformationValidation") }],
        CashbackAmount: [{ required: true, message: this.$t("CashbackAmountValidation") }, { type: 'number', message: this.$t("IsNumValidation") }, {
          validator: function validator(rule, value, callback) {

            if (parseFloat(value) > _this.maxCashbackAmount) {

              callback(new Error("最大返现金额不能超过" + _this.maxCashbackAmount + "元"));
            } else {
              if (0 < parseFloat(value) && parseFloat(value) < 1) {
                callback(new Error("金额不能低于" + _this.minCashbackAmount + "元"));
              } else {
                callback();
              }
            }
          }, trigger: 'blur'
        }]
      }

    };
  },
  created: function created() {
    var _this2 = this;

    this.$axios.get("api/cashback/" + this.$route.params.Id).then(function (response) {
      _this2.CashbackInfo.Id = response.data.Id;
      _this2.CashbackInfo.EANCode = response.data.EANCode;
      _this2.CashbackInfo.ProductLongCode = response.data.ProductLongCode;
      _this2.CashbackInfo.CashbackInformation = response.data.CashbackInformation;
      _this2.CashbackInfo.CashbackAmount = response.data.CashbackAmount;
      _this2.CashbackInfo.UserType = response.data.userType;
      // var elements=document.getElementsByClassName("el-input__inner");
      //elements[2].focus();
    });
  },

  methods: {
    addEAN: function addEAN(addCashbackForm) {
      var _this3 = this;

      this.$refs[addCashbackForm].validate(function (valid) {
        if (valid) {
          _this3.$axios.post("api/cashback/edit", _this3.CashbackInfo).then(function (response) {
            if (_this3.CashbackInfo) _this3.$message({
              message: _this3.$t("CashbackEditSuccessfully"),
              type: "success",
              showClose: true,
              duration: 2000
            });
            _this3.$router.push({ name: "Cashback" });
          });
        } else {
          _this3.$message({
            message: _this3.$t("operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },
    handlekeyup: function handlekeyup(event) {
      var father = event.currentTarget;
      var obj = father.getElementsByTagName("input")[0];
      obj.value = obj.value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符  
      obj.value = obj.value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的  
      obj.value = obj.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数  
      if (obj.value.indexOf(".") < 0 && obj.value != "") {
        obj.value = parseFloat(obj.value);
      }
    },
    handlefocus: function handlefocus(ev) {
      // this.CashbackInfo.AmountPerPackage=parseInt( this.CashbackInfo.AmountPerPackage);
    },
    cancelOperation: function cancelOperation() {
      this.$router.push({ name: "Cashback" });
    }
  }
});

/***/ }),

/***/ "s9gB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("boxScan.title"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[(_vm.canScan)?_c('el-button',{staticClass:"sm-hidden",attrs:{"plain":true,"size":"mini"},on:{"click":_vm.beginScan}},[_vm._v(_vm._s(_vm.$t("boxScan.beginScan"))+"\n        "),_c('i',{staticClass:"fa fa-qrcode"})]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n        "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("search"))+"\n        "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.scanInfos,"size":"mini"}},[(_vm.canDelete)?_c('el-table-column',{attrs:{"align":"center","resizable":true,"label":this.$t('operation')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","disabled":scope.row.CompleteIWAC},on:{"click":function($event){_vm.deleteScanInfo(scope.row.BoxNumber)}}},[_vm._v(_vm._s(_vm.$t('delete')))])]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"BoxNumber","align":"center","resizable":true,"label":this.$t('boxScan.boxNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ScanUserName","align":"center","resizable":true,"label":this.$t('boxScan.scanUserName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"DeliveryScanTime","align":"center","resizable":true,"label":this.$t('boxScan.deliveryScanTime'),"formatter":_vm.timeFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","resizable":true,"label":this.$t('boxScan.completeIWAC')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.CompleteIWAC)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v("已导入")]):_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("未导入")])]}}])})],1),_vm._v(" "),_c('el-row',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pageIndex,"page-sizes":[15, 30, 50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('search'),"visible":_vm.searchDialogVisible},on:{"update:visible":function($event){_vm.searchDialogVisible=$event}}},[_c('el-form',{staticClass:"search-form",attrs:{"model":_vm.filter,"inline":true,"size":"small","label-width":"70px"}},[_c('el-form-item',{attrs:{"label":this.$t('boxScan.boxNumber'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.boxNumber),callback:function ($$v) {_vm.$set(_vm.filter, "boxNumber", $$v)},expression:"filter.boxNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('boxScan.scanUserName'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.scanUserName),callback:function ($$v) {_vm.$set(_vm.filter, "scanUserName", $$v)},expression:"filter.scanUserName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('boxScan.deliveryScanTime'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.startScanTime),callback:function ($$v) {_vm.$set(_vm.filter, "startScanTime", $$v)},expression:"filter.startScanTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('to'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.endScanTime),callback:function ($$v) {_vm.$set(_vm.filter, "endScanTime", $$v)},expression:"filter.endScanTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('boxScan.completeIWAC'),"size":"small","label-width":"110px"}},[_c('el-radio',{attrs:{"label":"true"},model:{value:(_vm.filter.completeIWAC),callback:function ($$v) {_vm.$set(_vm.filter, "completeIWAC", $$v)},expression:"filter.completeIWAC"}},[_vm._v("已导入")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"false"},model:{value:(_vm.filter.completeIWAC),callback:function ($$v) {_vm.$set(_vm.filter, "completeIWAC", $$v)},expression:"filter.completeIWAC"}},[_vm._v("未导入")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"all"},model:{value:(_vm.filter.completeIWAC),callback:function ($$v) {_vm.$set(_vm.filter, "completeIWAC", $$v)},expression:"filter.completeIWAC"}},[_vm._v("所有")])],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(this.$t('reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":_vm.search}},[_vm._v(_vm._s(this.$t('confirm')))])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sonc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__("5reh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import router from "@/router/index";




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  data: function data() {
    return {
      userInfo: {
        username: "",
        password: "",
        grant_type: "password"
      },
      year: new Date().getFullYear(),
      rememberMeChecked: "",
      logining: false,
      rules: {
        username: [{
          required: true,
          message: this.$t("login.usernameRuleMessage"),
          trigger: "change"
        }],
        password: [{
          required: true,
          message: this.$t("login.passwordRuleMessage"),
          trigger: "change"
        }]
      }
    };
  },

  methods: {
    login: function login(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.logining = true;
          _this.$axios.post("token", __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(_this.userInfo)).then(function (response) {
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* LOGIN */], response.data);
            var redirect = decodeURI(_this.$route.query.redirect || "/");
            _this.$router.push({ path: redirect });
          }).catch(function (error) {
            var msg = _this.$t("login.loginFailure");
            var resp = error.response;
            if (!resp) {
              msg = "服务器错误，请联系管理员";
            }

            if (resp && resp.data && resp.data.error) {
              msg = "\u767B\u5F55\u5931\u8D25\uFF1A" + resp.data.error_description;
            }
            _this.$message({
              message: msg,
              type: "error",
              duration: 3000
            });
            _this.logining = false;
          });
        } else {
          return false;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["menus"])),
  created: function created() {}
});

/***/ }),

/***/ "tXg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar detail clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("user.addUser"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[_c('el-button',{attrs:{"plain":true,"type":"primary","size":"mini"},on:{"click":function($event){_vm.addUser('addUserForm')}}},[_vm._v(_vm._s(_vm.$t("save"))+"\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.cancelOperation()}}},[_vm._v(_vm._s(_vm.$t("cancel"))+"\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"data-list detail"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_c('el-form',{ref:"addUserForm",staticClass:"detail-form",attrs:{"model":_vm.userInfo,"rules":_vm.rules,"status-icon":"","size":"small","label-width":"100px"}},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.email'),"prop":"email"}},[_c('el-input',{model:{value:(_vm.userInfo.email),callback:function ($$v) {_vm.$set(_vm.userInfo, "email", $$v)},expression:"userInfo.email"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.rolesPlaceholder'),"prop":"userRoles"}},[_c('el-select',{model:{value:(_vm.userInfo.userRoles),callback:function ($$v) {_vm.$set(_vm.userInfo, "userRoles", $$v)},expression:"userInfo.userRoles"}},_vm._l((_vm.rolesList),function(role){return _c('el-option',{key:role.value,attrs:{"label":_vm.$t(("user.roles." + (role.Name))),"value":role.Name}})}))],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.name'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.userInfo.name),callback:function ($$v) {_vm.$set(_vm.userInfo, "name", $$v)},expression:"userInfo.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.phoneNumber'),"prop":"phoneNumber"}},[_c('el-input',{model:{value:(_vm.userInfo.phoneNumber),callback:function ($$v) {_vm.$set(_vm.userInfo, "phoneNumber", $$v)},expression:"userInfo.phoneNumber"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.password'),"prop":"password"}},[_c('div',{on:{"keyup":function($event){_vm.handlekeyup($event)}}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off"},model:{value:(_vm.userInfo.password),callback:function ($$v) {_vm.$set(_vm.userInfo, "password", $$v)},expression:"userInfo.password"}})],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":12}},[_c('el-form-item',{attrs:{"label":this.$t('user.confirmPassword'),"prop":"confirmPassword"}},[_c('div',{attrs:{"id":"confirmpwd"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off"},model:{value:(_vm.userInfo.confirmPassword),callback:function ($$v) {_vm.$set(_vm.userInfo, "confirmPassword", $$v)},expression:"userInfo.confirmPassword"}})],1)])],1)],1)],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-header"},[_c('span',[_vm._v("用户信息")]),_vm._v(" "),_c('div',{staticClass:"detail-triangle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uBdi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uPQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var status = {
    Generated: 0,
    Manufactured: 1,
    Delivered: 2,
    Received: 3
};

/* unused harmony default export */ var _unused_webpack_default_export = (status);

/***/ }),

/***/ "ucJP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wC+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n       "+_vm._s(_vm.$t("EANCodeManagement"))+"\n     ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[(false)?_c('FileImporter',{staticStyle:{"float":"left","margin-right":"16px"},attrs:{"apiurl":"api/eancodes/import"}}):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.addEAN}},[_vm._v(_vm._s(_vm.$t("add"))+"\n         "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n         "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("search"))+"\n         "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.EANData,"size":"mini"}},[(_vm.canEdit)?_c('el-table-column',{attrs:{"label":"操作","align":"center","width":"180","resizable":true},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.handleEdit(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$t("edit")))]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.handleDelete(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$t("delete")))])]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"EANCode","header-align":"center","align":"center","label":this.$t('EANCode')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ProductSerials","label":this.$t('ProductSerials'),"header-align":"center","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ProductLongCode","label":this.$t('ProductLongCode'),"header-align":"center","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ProductShortCode","label":this.$t('ProductShortCode'),"header-align":"center","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AmountPerPackage","label":this.$t('AmountPerPackage'),"header-align":"center","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"SuggestedRetailPrice","label":this.$t('SuggestedRetailPrice'),"header-align":"center","align":"center","formatter":_vm.priceFormatter}})],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"10px"}},[_c('el-pagination',{staticStyle:{"float":"right"},attrs:{"current-page":_vm.pageIndex,"page-sizes":[15,30,50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('search'),"visible":_vm.searchDialogVisible,"width":"45%"},on:{"update:visible":function($event){_vm.searchDialogVisible=$event}}},[_c('el-form',{ref:"searchEANCode",staticClass:"search-form",attrs:{"model":_vm.filter,"inline":true,"size":"small","label-width":"100px","rules":_vm.rules}},[_c('el-form-item',{attrs:{"label":this.$t('EANCode'),"size":"small","label-width":_vm.searchDialogLabelWidth,"prop":"EANCode"}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.filter.EANCode),callback:function ($$v) {_vm.$set(_vm.filter, "EANCode", $$v)},expression:"filter.EANCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('ProductLongCode'),"size":"small","label-width":_vm.searchDialogLabelWidth,"prop":"ProductLongCode"}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.filter.ProductLongCode),callback:function ($$v) {_vm.$set(_vm.filter, "ProductLongCode", $$v)},expression:"filter.ProductLongCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('ProductShortCode'),"size":"small","label-width":_vm.searchDialogLabelWidth,"prop":"ProductShortCode"}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.filter.ProductShortCode),callback:function ($$v) {_vm.$set(_vm.filter, "ProductShortCode", $$v)},expression:"filter.ProductShortCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('AmountPerPackage'),"size":"small","label-width":_vm.searchDialogLabelWidth,"prop":"AmountPerPackage"}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.filter.AmountPerPackage),callback:function ($$v) {_vm.$set(_vm.filter, "AmountPerPackage", $$v)},expression:"filter.AmountPerPackage"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('ProductSerials'),"size":"small","label-width":_vm.searchDialogLabelWidth}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.filter.ProductSerials),callback:function ($$v) {_vm.$set(_vm.filter, "ProductSerials", $$v)},expression:"filter.ProductSerials"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('SuggestedRetailPrice'),"size":"small","label-width":_vm.searchDialogLabelWidth,"prop":"SuggestedRetailPrice"}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.filter.SuggestedRetailPrice),callback:function ($$v) {_vm.$set(_vm.filter, "SuggestedRetailPrice", $$v)},expression:"filter.SuggestedRetailPrice"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",staticStyle:{"text-align":"center"},attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":"","size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(_vm.$t('reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":function($event){_vm.search('searchEANCode')}}},[_vm._v(_vm._s(this.$t('confirm')))])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wgec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "OperationHeader",
  props: ["title"],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__("5reh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Infrustructure_menu__ = __webpack_require__("Ccg8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Infrustructure_localStorageService__ = __webpack_require__("SXfi");



var _mutations;







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
    state: {
        token: __WEBPACK_IMPORTED_MODULE_6__Infrustructure_localStorageService__["a" /* default */].getItem('token'),
        user: __WEBPACK_IMPORTED_MODULE_6__Infrustructure_localStorageService__["a" /* default */].getItem('user') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_6__Infrustructure_localStorageService__["a" /* default */].getItem('user')) : {},
        menus: __WEBPACK_IMPORTED_MODULE_5__Infrustructure_menu__["a" /* default */],
        menuIndex: ""
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__types__["a" /* LOGIN */], function (state, data) {
        var access_token = data.access_token,
            userId = data.userId,
            userName = data.userName,
            roles = data.roles,
            permissions = data.permissions;

        state.token = access_token;
        state.user = { userId: userId, userName: userName };
        state.user.roles = roles ? roles.split(",") : [];
        state.user.permissions = permissions ? permissions.split(",") : [];
        try {
            __WEBPACK_IMPORTED_MODULE_6__Infrustructure_localStorageService__["a" /* default */].setItem('token', state.token);
            __WEBPACK_IMPORTED_MODULE_6__Infrustructure_localStorageService__["a" /* default */].setItem('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.user));
        } catch (e) {
            alert(e);
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__types__["b" /* LOGOUT */], function (state) {
        state.token = '';
        state.user = {};
        __WEBPACK_IMPORTED_MODULE_6__Infrustructure_localStorageService__["a" /* default */].removeItem('token');
        __WEBPACK_IMPORTED_MODULE_6__Infrustructure_localStorageService__["a" /* default */].removeItem('user');
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__types__["c" /* MENUINDEX */], function (state, data) {
        state.menuIndex = data;
    }), _mutations),
    getters: {
        token: function token(state) {
            return state.token;
        },
        user: function user(state) {
            return state.user;
        },
        menus: function menus(state) {
            var user = state.user;
            if (user.roles && user.roles.includes("Administrator")) {
                state.menus = __WEBPACK_IMPORTED_MODULE_5__Infrustructure_menu__["a" /* default */];
            } else {
                var permissions = user.permissions && user.permissions.map(function (p) {
                    if (p.includes(".")) {
                        return p.split(".")[0];
                    }
                    return p;
                });

                if (permissions) {
                    state.menus = __WEBPACK_IMPORTED_MODULE_5__Infrustructure_menu__["a" /* default */].filter(function (m) {
                        return permissions.find(function (p) {
                            return p === m.name;
                        });
                    });
                }
            }
            return state.menus;
        },
        menuIndex: function menuIndex(state) {
            return state.menuIndex;
        },
        roles: function roles(state) {
            return state.user.roles;
        },
        permissions: function permissions(state) {
            return state.user.permissions;
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AppRoot"
});

/***/ }),

/***/ "xhJp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATYAAABwCAYAAACUylxsAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAANoSURBVHja7N3dUSJBGAVQe4qoNALyIQuNRyIgrrYsn7SYEoWB7+ect33YrZlmuN67uO54fX9+ooz549fjkt902J+cHKXsHEHJQIPWFkeQPtCmwAPB1iHQhBumKOYmaGxEbWdCEQRb+UATbpiimJygsRG5oQlNBBulA024YYoiYECwkS3MPq9jeDkwRck0NzVGNDaEB2hsZGxoghfBRulAE24INgQEZOLv2G7n0k8ZZ+BrA42NFK1OqCHYAAQb2hoINqEm1ECwAfzJbuM2cavWkLnxRLz2b9f0dnwJ80Ae9qfVa1+5znbfZvOPM6p+TuNcsNFrgk7n6xkseo8j0xT18DrLc/fhufDeWb3fxQvTqq0h1Frctw8PTFBn6/krd/+LF8eDDtUs3ogmqLN1RoKNaIYHHeIHm7bmLEFjM0GByMGmYThLKBVsJujt2ppQQ7BhgoJg09YELQg2E9QEBVNUqJmgkDbYNAxnCaWCzQTV1sAUFWraGkQONm9EZwmlgs0ENUHBFBVq2hpEDjZvRO0RSgWbCZo7RIQaafjv90xQhPejzmiz5/hejc0bUXuEklNUiJigUCbYtDUTFEoFmw8MtEe4Ox8emHxCLd8XPK9NgCmKOQ+CTVszQUGwmaCAYDNBBS2CjS4hItQQbGwaIj4wAMFmgmpr8MX3sZl8Qm2bs9K4NbZWb0QTFASbCeqLBNQPtsptzVlCw2AzQYFf+fCg7wQVps6j7BllamwmKFByipqgQJlgq9p4hBo0DTYTFDBFtTUQbBrP/a9dqEHTYDNBAVPUBAUiB5sJCpQKNhMUMEVNUCBysGlrwNUi/SN4P7kjx3lqnmhs+OGR0DXYTFBnCaWCzQQFTFETVFuDyMFmgjpL9+iMSgWbCQqCyxQ1QT3s3tjO6JL7Xxy8CUrJZ290PiONzQTN+joMz55wW7vfXZIXyAT14K7d/+zyZr3y989OZzTmVDLOeTu+RA+2kqF22J88fFzNFM3b1gDBZoKCYAMQbNqatgaCTagJNdjEzhGECq5bXJPwQ2NzBIBg62MkvF5tDUxR4Qsam+DQzkCwCTeBBqYoJidobMWDRUMDwVYm3AQamKLCExBs1wTP3ODPBEzREq3K3ASNTTACGlu0cNLQQGPT0ACNLVpgaWgg2MqEm0CDB/sQYABusa2DsiWK4AAAAABJRU5ErkJggg=="

/***/ }),

/***/ "xvOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-bar clearfix"},[_c('div',{staticClass:"module pull-left"},[_vm._v("\n      "+_vm._s(_vm.$t("delivery.title"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-group pull-right"},[(_vm.canImportIWAC)?_c('el-button',{staticClass:"sm-hidden",attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.uploadDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("delivery.importIWAC"))+"\n        "),_c('i',{staticClass:"fa fa-file-excel-o"})]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.qrcSearchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("delivery.qrcSearch"))+"\n        "),_c('i',{staticClass:"fa fa-qrcode"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.$t("refresh"))+"\n        "),_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible=true}}},[_vm._v(_vm._s(_vm.$t("search"))+"\n        "),_c('i',{staticClass:"fa fa-search"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-list",attrs:{"element-loading-text":"Loading"}},[_c('el-table',{staticClass:"customer-table",attrs:{"border":"","stripe":"","data":_vm.deliveryInfos,"size":"mini"}},[_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"align":"center","resizable":true,"label":this.$t('operation')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.setOverview(scope.row)}}},[_vm._v(_vm._s(_vm.$t("delivery.overview"))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ChannelAccount","align":"center","resizable":true,"label":this.$t('delivery.customerNumber'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ChannelName","align":"center","resizable":true,"label":this.$t('delivery.customerName'),"width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"UserType","align":"center","resizable":true,"label":this.$t('delivery.customerType'),"formatter":_vm.customerTypeFormatter,"width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"Office","align":"center","resizable":true,"label":this.$t('delivery.customerOffice'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"OrderNumber","align":"center","resizable":true,"label":this.$t('delivery.orderNumber'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"BoxNumber","align":"center","resizable":true,"label":this.$t('delivery.boxNumber'),"width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"EANcode","align":"center","resizable":true,"label":this.$t('delivery.eanCode'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ProductLongCode","align":"center","resizable":true,"label":this.$t('delivery.productLongCode'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ProductShortCode","align":"center","resizable":true,"label":this.$t('delivery.productShortCode'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"AmountPerPackage","align":"center","resizable":true,"label":this.$t('delivery.amountPerPackage'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ProductSerials","align":"center","resizable":true,"label":this.$t('delivery.productSerials'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"Bonus","align":"center","resizable":true,"label":this.$t('delivery.bonus'),"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"QRCode1","align":"center","resizable":true,"label":this.$t('delivery.qrc1'),"width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"QRCode2","align":"center","resizable":true,"label":this.$t('delivery.qrc2'),"width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"DeliveryTime","align":"center","resizable":true,"label":this.$t('delivery.deliveryTime'),"formatter":_vm.timeFormatter,"width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"DeliveryScanTime","align":"center","resizable":true,"label":this.$t('delivery.boxScanTime'),"formatter":_vm.timeFormatter,"width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"align":"center","resizable":true,"label":this.$t('delivery.codeAuthCount'),"width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.ScanCount>0)?[_c('el-popover',{ref:"historypop",attrs:{"placement":"left","trigger":"click","width":"350"},on:{"show":function($event){_vm.listScanHistory(scope.row.QRCode1)}}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingHistory),expression:"loadingHistory"}],attrs:{"stripe":"","data":_vm.scanHistory,"element-loading-text":"Loading..."}},[_c('el-table-column',{attrs:{"align":"center","property":"ScanOrder","label":"扫描次数","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","property":"ScanTime","label":"扫描时间","width":"200"}})],1)],1),_vm._v(" "),_c('el-button',{directives:[{name:"popover",rawName:"v-popover:historypop",arg:"historypop"}],staticClass:"count-btn",attrs:{"size":"mini","type":"text"}},[_vm._v(_vm._s(scope.row.ScanCount))])]:_c('span',[_vm._v(_vm._s(scope.row.ScanCount))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"align":"center","resizable":true,"label":this.$t('delivery.hasReceived'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.ReceivedTime)?_c('span',[_vm._v("已领取")]):_c('span',[_vm._v("未领取")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":true,"prop":"ReceivedTime","align":"center","resizable":true,"label":this.$t('delivery.receivedTime'),"formatter":_vm.receivedTimeFormatter,"width":"180"}})],1),_vm._v(" "),_c('el-row',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pageIndex,"page-sizes":[15, 30, 50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('search'),"visible":_vm.searchDialogVisible,"width":"760px"},on:{"update:visible":function($event){_vm.searchDialogVisible=$event}}},[_c('el-form',{staticClass:"search-form",attrs:{"model":_vm.filter,"inline":true,"size":"small","label-width":"100px"}},[_c('el-form-item',{attrs:{"label":this.$t('delivery.customerNumber'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.ChannelAccount),callback:function ($$v) {_vm.$set(_vm.filter, "ChannelAccount", $$v)},expression:"filter.ChannelAccount"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.customerName'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.ChannelName),callback:function ($$v) {_vm.$set(_vm.filter, "ChannelName", $$v)},expression:"filter.ChannelName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.orderNumber'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.OrderNumber),callback:function ($$v) {_vm.$set(_vm.filter, "OrderNumber", $$v)},expression:"filter.OrderNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.boxNumber'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.BoxNumber),callback:function ($$v) {_vm.$set(_vm.filter, "BoxNumber", $$v)},expression:"filter.BoxNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.eanCode'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.EANcode),callback:function ($$v) {_vm.$set(_vm.filter, "EANcode", $$v)},expression:"filter.EANcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.productLongCode'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.ProductLongCode),callback:function ($$v) {_vm.$set(_vm.filter, "ProductLongCode", $$v)},expression:"filter.ProductLongCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.productShortCode'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.ProductShortCode),callback:function ($$v) {_vm.$set(_vm.filter, "ProductShortCode", $$v)},expression:"filter.ProductShortCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.productSerials'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.ProductSerials),callback:function ($$v) {_vm.$set(_vm.filter, "ProductSerials", $$v)},expression:"filter.ProductSerials"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.qrc1'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.QRCode1),callback:function ($$v) {_vm.$set(_vm.filter, "QRCode1", $$v)},expression:"filter.QRCode1"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.qrc2'),"size":"small"}},[_c('el-input',{model:{value:(_vm.filter.QRCode2),callback:function ($$v) {_vm.$set(_vm.filter, "QRCode2", $$v)},expression:"filter.QRCode2"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.hasReceived'),"size":"small"}},[_c('el-radio',{attrs:{"label":"true"},model:{value:(_vm.filter.hasReceived),callback:function ($$v) {_vm.$set(_vm.filter, "hasReceived", $$v)},expression:"filter.hasReceived"}},[_vm._v("已领取")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"false"},model:{value:(_vm.filter.hasReceived),callback:function ($$v) {_vm.$set(_vm.filter, "hasReceived", $$v)},expression:"filter.hasReceived"}},[_vm._v("未领取")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"all"},model:{value:(_vm.filter.hasReceived),callback:function ($$v) {_vm.$set(_vm.filter, "hasReceived", $$v)},expression:"filter.hasReceived"}},[_vm._v("所有")])],1),_c('br'),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.deliveryTime'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.StartDeliveryTime),callback:function ($$v) {_vm.$set(_vm.filter, "StartDeliveryTime", $$v)},expression:"filter.StartDeliveryTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('to'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.EndDeliveryTime),callback:function ($$v) {_vm.$set(_vm.filter, "EndDeliveryTime", $$v)},expression:"filter.EndDeliveryTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.boxScanTime'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.StartDeliveryScanTime),callback:function ($$v) {_vm.$set(_vm.filter, "StartDeliveryScanTime", $$v)},expression:"filter.StartDeliveryScanTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('to'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.EndDeliveryScanTime),callback:function ($$v) {_vm.$set(_vm.filter, "EndDeliveryScanTime", $$v)},expression:"filter.EndDeliveryScanTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('delivery.receivedTime'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.StartReceivedScanTime),callback:function ($$v) {_vm.$set(_vm.filter, "StartReceivedScanTime", $$v)},expression:"filter.StartReceivedScanTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":this.$t('to'),"size":"small"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"选择日期"},model:{value:(_vm.filter.EndReceivedScanTime),callback:function ($$v) {_vm.$set(_vm.filter, "EndReceivedScanTime", $$v)},expression:"filter.EndReceivedScanTime"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.searchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(this.$t('reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":_vm.search}},[_vm._v(_vm._s(this.$t('confirm')))])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog upload-dialog",attrs:{"title":this.$t('upload'),"visible":_vm.uploadDialogVisible,"width":"480px"},on:{"update:visible":function($event){_vm.uploadDialogVisible=$event}}},[_c('el-alert',{staticClass:"upload-alert",attrs:{"title":_vm.$t('delivery.ensureScanned'),"type":"warning"}}),_vm._v(" "),_c('el-upload',{ref:"upload",staticClass:"iwac-upload",attrs:{"action":_vm.uploadUrl,"accept":".xlsx,.xls","limit":1,"on-exceed":_vm.handleExceed,"file-list":_vm.fileList,"headers":_vm.uploadHeaders,"on-error":_vm.handleError,"on-success":_vm.handleSuccess,"auto-upload":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("\n        "+_vm._s(this.$t('delivery.clickToUpload'))+"\n        "),_c('i',{staticClass:"fa fa-upload"})]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(this.$t('delivery.selectUploadFile')))])],1),_vm._v(" "),_c('a',{staticClass:"download-tmp",attrs:{"href":"static/iwac.xlsx"}},[_vm._v(_vm._s(_vm.$t('delivery.downloadTemp')))]),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.uploadDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini","loading":_vm.uploading},on:{"click":_vm.upload}},[_vm._v(_vm._s(this.$t('upload')))])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog upload-dialog",attrs:{"title":this.$t('delivery.uploadQrc'),"visible":_vm.qrcSearchDialogVisible,"width":"30%"},on:{"update:visible":function($event){_vm.qrcSearchDialogVisible=$event}}},[(_vm.qrcSearchType==='img')?_c('el-upload',{ref:"upload",staticClass:"qrc-upload",attrs:{"action":"","on-exceed":_vm.handleQrcExceed,"on-change":_vm.handleQrcChange,"on-remove":_vm.handleQrcRemove,"accept":"image/*","limit":1,"auto-upload":false,"list-type":"picture-card"}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(this.$t('delivery.selectUploadQrc'))+"或\n        "),_c('el-button',{staticClass:"input-qrc",attrs:{"type":"text"},on:{"click":function($event){_vm.qrcSearchType = 'text'}}},[_vm._v("手动输入")])],1)]):_c('div',[_c('el-input',{staticClass:"el-upload__tip",attrs:{"placeholder":"请输入二维码内容","clearable":true},model:{value:(_vm.qrcUrl),callback:function ($$v) {_vm.qrcUrl=$$v},expression:"qrcUrl"}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('span',{staticClass:"el-upload__tip"},[_vm._v("\n          手动输入二维码内容\n        ")]),_vm._v("\n        或\n        "),_c('el-button',{staticClass:"input-qrc",attrs:{"type":"text"},on:{"click":function($event){_vm.qrcSearchType = 'img'}}},[_vm._v("上传图片")])],1)],1),_vm._v(" "),_c('div',{staticClass:"search-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"plain":true,"size":"mini"},on:{"click":function($event){_vm.qrcSearchDialogVisible = false}}},[_vm._v(_vm._s(this.$t('cancel')))]),_vm._v(" "),(_vm.qrcSearchType==='img')?_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":_vm.searchImgQrc}},[_vm._v(_vm._s(this.$t('query')))]):_c('el-button',{attrs:{"type":"primary","plain":true,"size":"mini"},on:{"click":_vm.searchUrlQrc}},[_vm._v(_vm._s(this.$t('query')))])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"search-dialog",attrs:{"title":this.$t('delivery.overview'),"visible":_vm.showOverview,"width":"350px"},on:{"update:visible":function($event){_vm.showOverview=$event}}},[_c('div',{staticClass:"overview-list"},[_c('div',{staticClass:"item"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('delivery.customerNumber'))+"：")]),_vm._v(" "),_c('span',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.overviewData.ChannelAccount))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('delivery.customerName'))+"：")]),_vm._v(" "),_c('span',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.overviewData.ChannelName))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('delivery.customerOffice'))+"：")]),_vm._v(" "),_c('span',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.overviewData.Office))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('delivery.deliveryTime'))+"：")]),_vm._v(" "),_c('span',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.overviewData.DeliveryTime))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('delivery.hasReceived'))+"：")]),_vm._v(" "),_c('span',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.overviewData.ReceivedTime?'已领取':'未领取'))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yd8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\r\nAdd cashback\r\n\r\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yzOQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ResetPassword",
  data: function data() {
    var _this = this;

    var confirmPassword = function confirmPassword(rule, value, callback) {
      if (value !== _this.newPassword.password) {
        callback(new Error(_this.$t("user.confirmPasswordSameValidation")));
      } else {
        callback();
      }
    };

    return {
      userInfo: {},
      newPassword: {
        password: "",
        confirmPassword: "",
        userId: this.$route.params.userId
      },
      rules: {
        password: [{
          required: true,
          message: this.$t("user.passwordValidation")
        }, {
          min: 6,
          message: this.$t("user.pvalid.minLen", { len: 6 }),
          trigger: "blur"
        }, {
          pattern: new RegExp(/[A-Z]/),
          message: this.$t("user.pvalid.oneUppercase"),
          trigger: "blur"
        }, {
          pattern: new RegExp(/[a-z]/),
          message: this.$t("user.pvalid.oneLowercase"),
          trigger: "blur"
        }, {
          pattern: new RegExp(/[0-9]/),
          message: this.$t("user.pvalid.oneDigit"),
          trigger: "blur"
        }, {
          pattern: new RegExp(/[^a-zA-Z0-9]/),
          message: this.$t("user.pvalid.oneNonLetterOrDigit"),
          trigger: "blur"
        }],
        confirmPassword: [{
          required: true,
          message: this.$t("user.confirmPasswordRequiredValidation")
        }, { validator: confirmPassword, trigger: "blur change" }]
      }
    };
  },

  methods: {
    handlekeyup: function handlekeyup(event) {
      var father = event.currentTarget;
      var confirm = document.getElementById("confirmpwd").getElementsByTagName("input")[0];
      var obj = father.getElementsByTagName("input")[0];
      if (obj.value === this.newPassword.confirmPassword) {
        confirm.focus();
        obj.focus();
      }
    },
    resetPassword: function resetPassword(resetPasswordForm) {
      var _this2 = this;

      this.$refs[resetPasswordForm].validate(function (valid) {
        if (valid) {
          _this2.$axios.post("api/users/resetPassword", _this2.newPassword).then(function (response) {
            _this2.$message({
              message: _this2.$t("user.passwordResetSuccessfully"),
              type: "success",
              showClose: true,
              duration: 2000
            });
            _this2.$router.push({ name: "UserManagement" });
          }).catch(function (e) {
            var modelState = e.response && e.response.data.ModelState;
            var msg = modelState && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(modelState).join() || _this2.$t("user.operationFailure");
            _this2.$message({
              message: msg,
              type: "error"
            });
          });
        } else {
          return false;
        }
      });
    },
    cancelOperation: function cancelOperation() {
      this.$router.push({ name: "UserManagement" });
    }
  },
  created: function created() {
    var _this3 = this;

    this.$axios.get("api/users/" + this.$route.params.userId).then(function (response) {
      _this3.userInfo = response.data;
    });
  }
});

/***/ }),

/***/ "z3nk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__("qDWc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da7d5e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__("IzDB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da7d5e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zKtV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_roleTypes__ = __webpack_require__("B0E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_searchTypes__ = __webpack_require__("iyrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__ = __webpack_require__("jb9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_userTypes__ = __webpack_require__("aYxF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_qrcode_reader__ = __webpack_require__("sUpM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_qrcodeService__ = __webpack_require__("B7TC");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "QRCCode",
  data: function data() {
    return {
      searchDialogVisible: false,
      uploadDialogVisible: false,
      qrcSearchDialogVisible: false,
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
      deliveryInfos: [],
      loading: true,
      loadingHistory: false,
      uploading: false,
      showOverview: false,
      overviewData: {},
      filter: {
        hasReceived: "all"
      },
      filterOptions: [],
      fileList: [],
      uploadUrl: this.$axios.defaults.baseURL + "api/delivery/iwac/import",
      qrcUrl: "",
      qrcFile: {},
      qrcSearchType: "img", //text
      scanHistory: []
    };
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getDeliveryInfo();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageIndex = val;
      this.getDeliveryInfo();
    },
    getDeliveryInfo: function getDeliveryInfo() {
      var _this = this;

      this.loading = true;
      var params = {
        filter: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios.get("api/delivery", { params: params }).then(function (res) {
        _this.totalCount = res.data.TotalCount;
        _this.deliveryInfos = res.data.Data;
        _this.loading = false;
      }).catch(function (e) {
        _this.loading = false;
      });
    },
    search: function search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].setHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].DELIVERY_HISTORY, this.filterOptions);
      this.getDeliveryInfo();
    },
    resetFilter: function resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].removeHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].DELIVERY_HISTORY);
    },
    setFilterOptions: function setFilterOptions() {
      var _this2 = this;

      this.filterOptions = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter).forEach(function (k) {
        var val = _this2.filter[k];
        if (typeof val === "number" || val) {
          _this2.filterOptions.push({ name: k, value: val });
        }
      });
    },
    refresh: function refresh() {
      this.resetFilter();
      this.getDeliveryInfo();
    },
    initializeFilter: function initializeFilter() {
      var _this3 = this;

      var his = __WEBPACK_IMPORTED_MODULE_5__services_searchHistoryService__["a" /* default */].getHistory(__WEBPACK_IMPORTED_MODULE_4__models_searchTypes__["a" /* default */].DELIVERY_HISTORY);
      if (his) {
        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.filter);
        his.forEach(function (h) {
          if (keys.includes(h.name)) {
            _this3.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    upload: function upload() {
      var res = this.$refs.upload.submit();
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: this.$t("delivery.uploadOneFileMsg"),
        type: "error"
      });
    },
    handleQrcExceed: function handleQrcExceed() {
      this.$message({
        message: this.$t("delivery.uploadOneQrcMsg"),
        type: "error"
      });
    },
    handleError: function handleError(err, f, fl) {
      this.uploading = false;
      this.$message({
        message: err.message,
        type: "error"
      });
    },
    handleSuccess: function handleSuccess(resp, f, fl) {
      this.uploading = false;
      this.$message({
        message: this.$t("delivery.uploadSuccess"),
        type: "success"
      });
      this.uploadDialogVisible = false;
      this.fileList = [];
      this.refresh();
      this.showUnmatchedBoxNumber();
    },
    showUnmatchedBoxNumber: function showUnmatchedBoxNumber() {
      var _this4 = this;

      this.$axios.get("api/delivery/iwac/unmatched").then(function (resp) {
        var res = resp.data || [];
        var length = res.length;
        var title = length && "\u5F85\u5339\u914D\u7BB1\u53F7(\u5171" + length + "\u4E2A)" || "提示";
        var msg = length && res.join(",\r\n") || "全部扫描箱号均已匹配IWAC信息！";
        var type = length && "warning" || "success";
        _this4.$alert(msg, title, { type: type });
      });
    },
    customerTypeFormatter: function customerTypeFormatter(row, col, val) {
      return __WEBPACK_IMPORTED_MODULE_8__models_userTypes__["a" /* default */][val];
    },
    receivedTimeFormatter: function receivedTimeFormatter(row, col, val) {
      if (val) {
        return this.timeFormatter(row, col, val);
      }
      return this.$t("delivery.notReceived");
    },
    handleQrcChange: function handleQrcChange(f, fl) {
      this.qrcFile = f;
      var item = this.$refs.upload.$el.querySelector(".el-upload");
      item.style.display = "none";
    },
    handleQrcRemove: function handleQrcRemove(f, fl) {
      this.qrcFile = {};
      var item = this.$refs.upload.$el.querySelector(".el-upload");
      item.style.display = "inline-block";
    },
    searchImgQrc: function searchImgQrc() {
      var _this5 = this;

      if (this.qrcFile.url) {
        var reader = new __WEBPACK_IMPORTED_MODULE_9_qrcode_reader__["a" /* default */]();
        reader.callback = function (err, val) {
          if (!err) {
            var qrcCode = __WEBPACK_IMPORTED_MODULE_10__services_qrcodeService__["a" /* default */].getQRCode(val.result);
            _this5.searchQrc(qrcCode);
          } else {
            _this5.$message({
              message: _this5.$t("delivery.resolveQrcodeFail"),
              type: "error"
            });
          }
        };
        reader.decode(this.qrcFile.url);
      }
    },
    searchUrlQrc: function searchUrlQrc() {
      var qrcCode = __WEBPACK_IMPORTED_MODULE_10__services_qrcodeService__["a" /* default */].getQRCode(this.qrcUrl);
      this.searchQrc(qrcCode);
    },
    searchQrc: function searchQrc(qrcCode) {
      var _this6 = this;

      this.$axios.get("api/qrc/check/" + qrcCode).then(function (resp) {
        var res = resp.data;
        if (!res) {
          _this6.$message({
            message: _this6.$t("delivery.notExistQrcode"),
            type: "error"
          });
          return;
        }
        _this6.resetFilter();
        if (res === 1) {
          _this6.filter.QRCode1 = qrcCode;
        } else if (res === 2) {
          _this6.filter.QRCode2 = qrcCode;
        }
        _this6.search();
        _this6.qrcSearchDialogVisible = false;
      }).catch(function (e) {
        _this6.$message({
          message: _this6.$t("delivery.notExistQrcode"),
          type: "error"
        });
      });
    },
    listScanHistory: function listScanHistory(code) {
      var _this7 = this;

      this.scanHistory = [];
      this.loadingHistory = true;
      this.$axios.get("api/delivery/scanhistory/" + code).then(function (resp) {
        if (resp.data) {
          _this7.scanHistory = resp.data;
          _this7.loadingHistory = false;
        }
      });
    },
    setOverview: function setOverview(data) {
      this.showOverview = true;
      this.overviewData = data;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(["roles", "permissions", "token"]), {
    canImportIWAC: function canImportIWAC() {
      return this.roles.includes(__WEBPACK_IMPORTED_MODULE_3__models_roleTypes__["a" /* default */].Administrator);
    },
    uploadHeaders: function uploadHeaders() {
      return {
        Authorization: "bearer " + this.token
      };
    }
  }),
  created: function created() {
    this.initializeFilter();
    this.getDeliveryInfo();
  }
});

/***/ }),

/***/ "zyzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ATips",
  props: ['str'],
  data: function data() {
    return {
      shortCutStr: ""

    };
  },

  methods: {
    handleFocus: function handleFocus(event) {
      if (this.str.split(",").length > 1) event.currentTarget.title = this.str;
    },
    handleLoad: function handleLoad() {

      if (this.str.split(",").length > 1) {
        return this.str.split(",")[0] + "...";
      }
      return this.str;
    }
  }
});

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.8602904d18bcfeab995b.js